import * as $s from "vue";
import { defineComponent as Ee, h as ns, getCurrentScope as al, onScopeDispose as il, inject as ll, onMounted as Mt, onUnmounted as Qr, Fragment as Fe, computed as me, watch as vt, ref as G, shallowRef as cl, createVNode as it, Text as ul, openBlock as L, createElementBlock as I, createElementVNode as d, toDisplayString as O, unref as k, createCommentVNode as Z, withModifiers as ea, createTextVNode as et, withDirectives as ot, vModelText as wt, renderList as Je, normalizeClass as Ae, reactive as dl, createBlock as ct, resolveComponent as co, Transition as fl, withCtx as Sn, renderSlot as ml, useModel as hl, vModelSelect as uo, mergeModels as Yo, nextTick as pl } from "vue";
import { logger as Ne, getOrderItemStatusLabel as ta, ORDER_ITEM_STATUS as Lt, STATUS_FLOW as An, ORDER_STATUS as je, formatToMerchantTimeHM as na, getOrderStatusLabel as js, confirmDuplicateOrders as gl, processUbnInput as bl } from "@myorg/type-lib";
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ot(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Go = {};
function wl(e) {
  Go[e] || (Go[e] = !0, Ot(e));
}
const Dt = typeof window < "u";
let lt, Zt;
if (process.env.NODE_ENV !== "production") {
  const e = Dt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (lt = (t) => {
    e.mark(t);
  }, Zt = (t, n, s) => {
    e.measure(t, n, s), e.clearMarks(n), e.clearMarks(s);
  });
}
const yl = /\{([0-9a-zA-Z]+)\}/g;
function gs(e, ...t) {
  return t.length === 1 && ce(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(yl, (n, s) => t.hasOwnProperty(s) ? t[s] : "");
}
const Bt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), vl = (e, t, n) => _l({ l: e, k: t, s: n }), _l = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), qe = (e) => typeof e == "number" && isFinite(e), sa = (e) => mo(e) === "[object Date]", ss = (e) => mo(e) === "[object RegExp]", bs = (e) => we(e) && Object.keys(e).length === 0, Ue = Object.assign, xl = Object.create, xe = (e = null) => xl(e);
let Ko;
const Gt = () => Ko || (Ko = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : xe());
function Xo(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function El(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const kl = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, Cl = /^(?:href|src|action|formaction)$/i;
function fo(e) {
  return kl.test(e);
}
function Tl(e) {
  const t = /url\s*\(/gi;
  let n = "", s = 0, o;
  for (; (o = t.exec(e)) !== null; ) {
    const r = o.index, a = t.lastIndex - 1;
    let i = a + 1, l = 1, c = null;
    for (; i < e.length; i++) {
      const p = e[i];
      if (c) {
        p === c && (c = null);
        continue;
      }
      if (p === '"' || p === "'")
        c = p;
      else if (p === "(")
        l++;
      else if (p === ")" && (l--, l === 0))
        break;
    }
    if (l !== 0)
      break;
    const h = e.slice(a + 1, i).trim(), m = h.startsWith('"') && h.endsWith('"') || h.startsWith("'") && h.endsWith("'") ? h.slice(1, -1).trim() : h;
    n += e.slice(s, r), n += fo(m) ? "url(about:blank)" : e.slice(r, i + 1), s = i + 1;
  }
  return n + e.slice(s);
}
function Jo(e, t) {
  if (Cl.test(e) && fo(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? Tl(t) : t;
  return El(n);
}
function Ol(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, s, o) => `${s}="${Jo(s, o)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, s, o) => `${s}='${Jo(s, o)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Ot("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, s, o) => fo(o) ? `${s}about:blank` : n), e;
}
const Al = Object.prototype.hasOwnProperty;
function gt(e, t) {
  return Al.call(e, t);
}
const Pe = Array.isArray, Oe = (e) => typeof e == "function", z = (e) => typeof e == "string", Ie = (e) => typeof e == "boolean", ce = (e) => e !== null && typeof e == "object", Sl = (e) => ce(e) && Oe(e.then) && Oe(e.catch), oa = Object.prototype.toString, mo = (e) => oa.call(e), we = (e) => mo(e) === "[object Object]", Nl = (e) => e == null ? "" : Pe(e) || we(e) && e.toString === oa ? JSON.stringify(e, null, 2) : String(e);
function ho(e, t = "") {
  return e.reduce((n, s, o) => o === 0 ? n + s : n + t + s, "");
}
const Zo = 2;
function Ll(e, t = 0, n = e.length) {
  const s = e.split(/\r?\n/);
  let o = 0;
  const r = [];
  for (let a = 0; a < s.length; a++)
    if (o += s[a].length + 1, o >= t) {
      for (let i = a - Zo; i <= a + Zo || n > o; i++) {
        if (i < 0 || i >= s.length)
          continue;
        const l = i + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${s[i]}`);
        const c = s[i].length;
        if (i === a) {
          const h = t - (o - c) + 1, m = Math.max(1, n > o ? c - h : n - t);
          r.push("   |  " + " ".repeat(h) + "^".repeat(m));
        } else if (i > a) {
          if (n > o) {
            const h = Math.max(Math.min(n - o, c), 1);
            r.push("   |  " + "^".repeat(h));
          }
          o += c + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function ra() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, s) {
      const o = e.get(n);
      o && o.push(s) || e.set(n, [s]);
    },
    off(n, s) {
      const o = e.get(n);
      o && o.splice(o.indexOf(s) >>> 0, 1);
    },
    emit(n, s) {
      (e.get(n) || []).slice().map((o) => o(s)), (e.get("*") || []).slice().map((o) => o(n, s));
    }
  };
}
const Yn = (e) => !ce(e) || Pe(e);
function Zn(e, t) {
  if (Yn(e) || Yn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: s, des: o } = n.pop();
    Object.keys(s).forEach((r) => {
      r !== "__proto__" && (ce(s[r]) && !ce(o[r]) && (o[r] = Array.isArray(s[r]) ? [] : xe()), Yn(o[r]) || Yn(s[r]) ? o[r] = s[r] : n.push({ src: s[r], des: o[r] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function $l(e, t, n) {
  return { line: e, column: t, offset: n };
}
function qs(e, t, n) {
  return { start: e, end: t };
}
const ee = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Il = 17, Pl = {
  // tokenizer error messages
  [ee.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ee.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ee.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ee.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ee.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ee.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ee.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ee.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ee.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ee.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ee.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ee.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ee.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ee.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ee.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ee.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function yn(e, t, n = {}) {
  const { domain: s, messages: o, args: r } = n, a = process.env.NODE_ENV !== "production" ? gs((o || Pl)[e] || "", ...r || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = s, i;
}
function Dl(e) {
  throw e;
}
const Rl = /<\/?[\w\s="/.':;#-\/]+>/, Ml = (e) => Rl.test(e), xt = " ", Bl = "\r", Ge = `
`, Fl = "\u2028", Ul = "\u2029";
function Vl(e) {
  const t = e;
  let n = 0, s = 1, o = 1, r = 0;
  const a = (C) => t[C] === Bl && t[C + 1] === Ge, i = (C) => t[C] === Ge, l = (C) => t[C] === Ul, c = (C) => t[C] === Fl, h = (C) => a(C) || i(C) || l(C) || c(C), m = () => n, p = () => s, g = () => o, _ = () => r, f = (C) => a(C) || l(C) || c(C) ? Ge : t[C], w = () => f(n), u = () => f(n + r);
  function b() {
    return r = 0, h(n) && (s++, o = 0), a(n) && n++, n++, o++, t[n];
  }
  function x() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function v() {
    n = 0, s = 1, o = 1, r = 0;
  }
  function A(C = 0) {
    r = C;
  }
  function $() {
    const C = n + r;
    for (; C !== n; )
      b();
    r = 0;
  }
  return {
    index: m,
    line: p,
    column: g,
    peekOffset: _,
    charAt: f,
    currentChar: w,
    currentPeek: u,
    next: b,
    peek: x,
    reset: v,
    resetPeek: A,
    skipToPeek: $
  };
}
const Nt = void 0, Hl = ".", Qo = "'", jl = "tokenizer";
function ql(e, t = {}) {
  const n = t.location !== !1, s = Vl(e), o = () => s.index(), r = () => $l(s.line(), s.column(), s.index()), a = r(), i = o(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: h } = t;
  function m(y, E, P, ...W) {
    const Ce = c();
    if (E.column += P, E.offset += P, h) {
      const Le = n ? qs(Ce.startLoc, E) : null, ue = yn(y, Le, {
        domain: jl,
        args: W
      });
      h(ue);
    }
  }
  function p(y, E, P) {
    y.endLoc = r(), y.currentType = E;
    const W = { type: E };
    return n && (W.loc = qs(y.startLoc, y.endLoc)), P != null && (W.value = P), W;
  }
  const g = (y) => p(
    y,
    13
    /* TokenTypes.EOF */
  );
  function _(y, E) {
    return y.currentChar() === E ? (y.next(), E) : (m(ee.EXPECTED_TOKEN, r(), 0, E), "");
  }
  function f(y) {
    let E = "";
    for (; y.currentPeek() === xt || y.currentPeek() === Ge; )
      E += y.currentPeek(), y.peek();
    return E;
  }
  function w(y) {
    const E = f(y);
    return y.skipToPeek(), E;
  }
  function u(y) {
    if (y === Nt)
      return !1;
    const E = y.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E === 95;
  }
  function b(y) {
    if (y === Nt)
      return !1;
    const E = y.charCodeAt(0);
    return E >= 48 && E <= 57;
  }
  function x(y, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    f(y);
    const W = u(y.currentPeek());
    return y.resetPeek(), W;
  }
  function v(y, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    f(y);
    const W = y.currentPeek() === "-" ? y.peek() : y.currentPeek(), Ce = b(W);
    return y.resetPeek(), Ce;
  }
  function A(y, E) {
    const { currentType: P } = E;
    if (P !== 2)
      return !1;
    f(y);
    const W = y.currentPeek() === Qo;
    return y.resetPeek(), W;
  }
  function $(y, E) {
    const { currentType: P } = E;
    if (P !== 7)
      return !1;
    f(y);
    const W = y.currentPeek() === ".";
    return y.resetPeek(), W;
  }
  function C(y, E) {
    const { currentType: P } = E;
    if (P !== 8)
      return !1;
    f(y);
    const W = u(y.currentPeek());
    return y.resetPeek(), W;
  }
  function B(y, E) {
    const { currentType: P } = E;
    if (!(P === 7 || P === 11))
      return !1;
    f(y);
    const W = y.currentPeek() === ":";
    return y.resetPeek(), W;
  }
  function D(y, E) {
    const { currentType: P } = E;
    if (P !== 9)
      return !1;
    const W = () => {
      const Le = y.currentPeek();
      return Le === "{" ? u(y.peek()) : Le === "@" || Le === "|" || Le === ":" || Le === "." || Le === xt || !Le ? !1 : Le === Ge ? (y.peek(), W()) : H(y, !1);
    }, Ce = W();
    return y.resetPeek(), Ce;
  }
  function F(y) {
    f(y);
    const E = y.currentPeek() === "|";
    return y.resetPeek(), E;
  }
  function H(y, E = !0) {
    const P = (Ce = !1, Le = "") => {
      const ue = y.currentPeek();
      return ue === "{" || ue === "@" || !ue ? Ce : ue === "|" ? !(Le === xt || Le === Ge) : ue === xt ? (y.peek(), P(!0, xt)) : ue === Ge ? (y.peek(), P(!0, Ge)) : !0;
    }, W = P();
    return E && y.resetPeek(), W;
  }
  function te(y, E) {
    const P = y.currentChar();
    return P === Nt ? Nt : E(P) ? (y.next(), P) : null;
  }
  function Me(y) {
    const E = y.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E >= 48 && E <= 57 || // 0-9
    E === 95 || // _
    E === 36;
  }
  function j(y) {
    return te(y, Me);
  }
  function U(y) {
    const E = y.charCodeAt(0);
    return E >= 97 && E <= 122 || // a-z
    E >= 65 && E <= 90 || // A-Z
    E >= 48 && E <= 57 || // 0-9
    E === 95 || // _
    E === 36 || // $
    E === 45;
  }
  function M(y) {
    return te(y, U);
  }
  function K(y) {
    const E = y.charCodeAt(0);
    return E >= 48 && E <= 57;
  }
  function V(y) {
    return te(y, K);
  }
  function J(y) {
    const E = y.charCodeAt(0);
    return E >= 48 && E <= 57 || // 0-9
    E >= 65 && E <= 70 || // A-F
    E >= 97 && E <= 102;
  }
  function q(y) {
    return te(y, J);
  }
  function oe(y) {
    let E = "", P = "";
    for (; E = V(y); )
      P += E;
    return P;
  }
  function le(y) {
    let E = "";
    for (; ; ) {
      const P = y.currentChar();
      if (P === "\\") {
        const W = y.peek();
        W === "{" || W === "}" || W === "@" || W === "|" || W === "\\" ? (E += P + W, y.next(), y.next()) : (y.resetPeek(), E += P, y.next());
      } else {
        if (P === "{" || P === "}" || P === "@" || P === "|" || !P)
          break;
        if (P === xt || P === Ge)
          if (H(y))
            E += P, y.next();
          else {
            if (F(y))
              break;
            E += P, y.next();
          }
        else
          E += P, y.next();
      }
    }
    return E;
  }
  function ne(y) {
    w(y);
    let E = "", P = "";
    for (; E = M(y); )
      P += E;
    const W = y.currentChar();
    if (W && W !== "}" && W !== Nt && W !== xt && W !== Ge && W !== "　") {
      const Ce = ke(y);
      return m(ee.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, P + Ce), P + Ce;
    }
    return y.currentChar() === Nt && m(ee.UNTERMINATED_CLOSING_BRACE, r(), 0), P;
  }
  function fe(y) {
    w(y);
    let E = "";
    return y.currentChar() === "-" ? (y.next(), E += `-${oe(y)}`) : E += oe(y), y.currentChar() === Nt && m(ee.UNTERMINATED_CLOSING_BRACE, r(), 0), E;
  }
  function be(y) {
    return y !== Qo && y !== Ge;
  }
  function Ye(y) {
    w(y), _(y, "'");
    let E = "", P = "";
    for (; E = te(y, be); )
      E === "\\" ? P += Te(y) : P += E;
    const W = y.currentChar();
    return W === Ge || W === Nt ? (m(ee.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), W === Ge && (y.next(), _(y, "'")), P) : (_(y, "'"), P);
  }
  function Te(y) {
    const E = y.currentChar();
    switch (E) {
      case "\\":
      case "'":
        return y.next(), `\\${E}`;
      case "u":
        return ae(y, E, 4);
      case "U":
        return ae(y, E, 6);
      default:
        return m(ee.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, E), "";
    }
  }
  function ae(y, E, P) {
    _(y, E);
    let W = "";
    for (let Ce = 0; Ce < P; Ce++) {
      const Le = q(y);
      if (!Le) {
        m(ee.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${E}${W}${y.currentChar()}`);
        break;
      }
      W += Le;
    }
    return `\\${E}${W}`;
  }
  function Be(y) {
    return y !== "{" && y !== "}" && y !== xt && y !== Ge;
  }
  function ke(y) {
    w(y);
    let E = "", P = "";
    for (; E = te(y, Be); )
      P += E;
    return P;
  }
  function re(y) {
    let E = "", P = "";
    for (; E = j(y); )
      P += E;
    return P;
  }
  function se(y) {
    const E = (P) => {
      const W = y.currentChar();
      return W === "{" || W === "@" || W === "|" || W === "(" || W === ")" || !W || W === xt ? P : (P += W, y.next(), E(P));
    };
    return E("");
  }
  function ie(y) {
    w(y);
    const E = _(
      y,
      "|"
      /* TokenChars.Pipe */
    );
    return w(y), E;
  }
  function Q(y, E) {
    let P = null;
    switch (y.currentChar()) {
      case "{":
        return E.braceNest >= 1 && m(ee.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), y.next(), P = p(
          E,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), w(y), E.braceNest++, P;
      case "}":
        return E.braceNest > 0 && E.currentType === 2 && m(ee.EMPTY_PLACEHOLDER, r(), 0), y.next(), P = p(
          E,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), E.braceNest--, E.braceNest > 0 && w(y), E.inLinked && E.braceNest === 0 && (E.inLinked = !1), P;
      case "@":
        return E.braceNest > 0 && m(ee.UNTERMINATED_CLOSING_BRACE, r(), 0), P = ve(y, E) || g(E), E.braceNest = 0, P;
      default: {
        let Ce = !0, Le = !0, ue = !0;
        if (F(y))
          return E.braceNest > 0 && m(ee.UNTERMINATED_CLOSING_BRACE, r(), 0), P = p(E, 1, ie(y)), E.braceNest = 0, E.inLinked = !1, P;
        if (E.braceNest > 0 && (E.currentType === 4 || E.currentType === 5 || E.currentType === 6))
          return m(ee.UNTERMINATED_CLOSING_BRACE, r(), 0), E.braceNest = 0, Qe(y, E);
        if (Ce = x(y, E))
          return P = p(E, 4, ne(y)), w(y), P;
        if (Le = v(y, E))
          return P = p(E, 5, fe(y)), w(y), P;
        if (ue = A(y, E))
          return P = p(E, 6, Ye(y)), w(y), P;
        if (!Ce && !Le && !ue)
          return P = p(E, 12, ke(y)), m(ee.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, P.value), w(y), P;
        break;
      }
    }
    return P;
  }
  function ve(y, E) {
    const { currentType: P } = E;
    let W = null;
    const Ce = y.currentChar();
    switch ((P === 7 || P === 8 || P === 11 || P === 9) && (Ce === Ge || Ce === xt) && m(ee.INVALID_LINKED_FORMAT, r(), 0), Ce) {
      case "@":
        return y.next(), W = p(
          E,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), E.inLinked = !0, W;
      case ".":
        return w(y), y.next(), p(
          E,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return w(y), y.next(), p(
          E,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return F(y) ? (W = p(E, 1, ie(y)), E.braceNest = 0, E.inLinked = !1, W) : $(y, E) || B(y, E) ? (w(y), ve(y, E)) : C(y, E) ? (w(y), p(E, 11, re(y))) : D(y, E) ? (w(y), Ce === "{" ? Q(y, E) || W : p(E, 10, se(y))) : (P === 7 && m(ee.INVALID_LINKED_FORMAT, r(), 0), E.braceNest = 0, E.inLinked = !1, Qe(y, E));
    }
  }
  function Qe(y, E) {
    let P = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (E.braceNest > 0)
      return Q(y, E) || g(E);
    if (E.inLinked)
      return ve(y, E) || g(E);
    switch (y.currentChar()) {
      case "{":
        return Q(y, E) || g(E);
      case "}":
        return m(ee.UNBALANCED_CLOSING_BRACE, r(), 0), y.next(), p(
          E,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ve(y, E) || g(E);
      default: {
        if (F(y))
          return P = p(E, 1, ie(y)), E.braceNest = 0, E.inLinked = !1, P;
        if (H(y))
          return p(E, 0, le(y));
        break;
      }
    }
    return P;
  }
  function ze() {
    const { currentType: y, offset: E, startLoc: P, endLoc: W } = l;
    return l.lastType = y, l.lastOffset = E, l.lastStartLoc = P, l.lastEndLoc = W, l.offset = o(), l.startLoc = r(), s.currentChar() === Nt ? p(
      l,
      13
      /* TokenTypes.EOF */
    ) : Qe(s, l);
  }
  return {
    nextToken: ze,
    currentOffset: o,
    currentPosition: r,
    context: c
  };
}
const Wl = "parser", zl = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, Yl = /\\([\\@{}|])/g;
function Gl(e, t) {
  return t;
}
function Kl(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const s = parseInt(t || n, 16);
      return s <= 55295 || s >= 57344 ? String.fromCodePoint(s) : "�";
    }
  }
}
function Xl(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function s(u, b, x, v, ...A) {
    const $ = u.currentPosition();
    if ($.offset += v, $.column += v, n) {
      const C = t ? qs(x, $) : null, B = yn(b, C, {
        domain: Wl,
        args: A
      });
      n(B);
    }
  }
  function o(u, b, x) {
    const v = { type: u };
    return t && (v.start = b, v.end = b, v.loc = { start: x, end: x }), v;
  }
  function r(u, b, x, v) {
    t && (u.end = b, u.loc && (u.loc.end = x));
  }
  function a(u, b) {
    const x = u.context(), v = o(3, x.offset, x.startLoc);
    return v.value = b.replace(Yl, Gl), r(v, u.currentOffset(), u.currentPosition()), v;
  }
  function i(u, b) {
    const x = u.context(), { lastOffset: v, lastStartLoc: A } = x, $ = o(5, v, A);
    return $.index = parseInt(b, 10), u.nextToken(), r($, u.currentOffset(), u.currentPosition()), $;
  }
  function l(u, b) {
    const x = u.context(), { lastOffset: v, lastStartLoc: A } = x, $ = o(4, v, A);
    return $.key = b, u.nextToken(), r($, u.currentOffset(), u.currentPosition()), $;
  }
  function c(u, b) {
    const x = u.context(), { lastOffset: v, lastStartLoc: A } = x, $ = o(9, v, A);
    return $.value = b.replace(zl, Kl), u.nextToken(), r($, u.currentOffset(), u.currentPosition()), $;
  }
  function h(u) {
    const b = u.nextToken(), x = u.context(), { lastOffset: v, lastStartLoc: A } = x, $ = o(8, v, A);
    return b.type !== 11 ? (s(u, ee.UNEXPECTED_EMPTY_LINKED_MODIFIER, x.lastStartLoc, 0), $.value = "", r($, v, A), {
      nextConsumeToken: b,
      node: $
    }) : (b.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, Et(b)), $.value = b.value || "", r($, u.currentOffset(), u.currentPosition()), {
      node: $
    });
  }
  function m(u, b) {
    const x = u.context(), v = o(7, x.offset, x.startLoc);
    return v.value = b, r(v, u.currentOffset(), u.currentPosition()), v;
  }
  function p(u) {
    const b = u.context(), x = o(6, b.offset, b.startLoc);
    let v = u.nextToken();
    if (v.type === 8) {
      const A = h(u);
      x.modifier = A.node, v = A.nextConsumeToken || u.nextToken();
    }
    switch (v.type !== 9 && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(v)), v = u.nextToken(), v.type === 2 && (v = u.nextToken()), v.type) {
      case 10:
        v.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(v)), x.key = m(u, v.value || "");
        break;
      case 4:
        v.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(v)), x.key = l(u, v.value || "");
        break;
      case 5:
        v.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(v)), x.key = i(u, v.value || "");
        break;
      case 6:
        v.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(v)), x.key = c(u, v.value || "");
        break;
      default: {
        s(u, ee.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const A = u.context(), $ = o(7, A.offset, A.startLoc);
        return $.value = "", r($, A.offset, A.startLoc), x.key = $, r(x, A.offset, A.startLoc), {
          nextConsumeToken: v,
          node: x
        };
      }
    }
    return r(x, u.currentOffset(), u.currentPosition()), {
      node: x
    };
  }
  function g(u) {
    const b = u.context(), x = b.currentType === 1 ? u.currentOffset() : b.offset, v = b.currentType === 1 ? b.endLoc : b.startLoc, A = o(2, x, v);
    A.items = [];
    let $ = null;
    do {
      const D = $ || u.nextToken();
      switch ($ = null, D.type) {
        case 0:
          D.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(D)), A.items.push(a(u, D.value || ""));
          break;
        case 5:
          D.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(D)), A.items.push(i(u, D.value || ""));
          break;
        case 4:
          D.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(D)), A.items.push(l(u, D.value || ""));
          break;
        case 6:
          D.value == null && s(u, ee.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Et(D)), A.items.push(c(u, D.value || ""));
          break;
        case 7: {
          const F = p(u);
          A.items.push(F.node), $ = F.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 13 && b.currentType !== 1);
    const C = b.currentType === 1 ? b.lastOffset : u.currentOffset(), B = b.currentType === 1 ? b.lastEndLoc : u.currentPosition();
    return r(A, C, B), A;
  }
  function _(u, b, x, v) {
    const A = u.context();
    let $ = v.items.length === 0;
    const C = o(1, b, x);
    C.cases = [], C.cases.push(v);
    do {
      const B = g(u);
      $ || ($ = B.items.length === 0), C.cases.push(B);
    } while (A.currentType !== 13);
    return $ && s(u, ee.MUST_HAVE_MESSAGES_IN_PLURAL, x, 0), r(C, u.currentOffset(), u.currentPosition()), C;
  }
  function f(u) {
    const b = u.context(), { offset: x, startLoc: v } = b, A = g(u);
    return b.currentType === 13 ? A : _(u, x, v, A);
  }
  function w(u) {
    const b = ql(u, Ue({}, e)), x = b.context(), v = o(0, x.offset, x.startLoc);
    return t && v.loc && (v.loc.source = u), v.body = f(b), e.onCacheKey && (v.cacheKey = e.onCacheKey(u)), x.currentType !== 13 && s(b, ee.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, u[x.offset] || ""), r(v, b.currentOffset(), b.currentPosition()), v;
  }
  return { parse: w };
}
function Et(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Jl(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function er(e, t) {
  for (let n = 0; n < e.length; n++)
    po(e[n], t);
}
function po(e, t) {
  switch (e.type) {
    case 1:
      er(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      er(e.items, t);
      break;
    case 6: {
      po(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Zl(e, t = {}) {
  const n = Jl(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && po(e.body, n);
  const s = n.context();
  e.helpers = Array.from(s.helpers);
}
function Ql(e) {
  const t = e.body;
  return t.type === 2 ? tr(t) : t.cases.forEach((n) => tr(n)), e;
}
function tr(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const s = e.items[n];
      if (!(s.type === 3 || s.type === 9) || s.value == null)
        break;
      t.push(s.value);
    }
    if (t.length === e.items.length) {
      e.static = ho(t);
      for (let n = 0; n < e.items.length; n++) {
        const s = e.items[n];
        (s.type === 3 || s.type === 9) && delete s.value;
      }
    }
  }
}
const ec = "minifier";
function un(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      un(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let s = 0; s < n.length; s++)
        un(n[s]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let s = 0; s < n.length; s++)
        un(n[s]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      un(t.key), t.k = t.key, delete t.key, t.modifier && (un(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw yn(ee.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: ec,
          args: [e.type]
        });
  }
  delete e.type;
}
const tc = "parser";
function nc(e, t) {
  const { filename: n, breakLineCode: s, needIndent: o } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: s,
    needIndent: o,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(f, w) {
    a.code += f;
  }
  function c(f, w = !0) {
    const u = w ? s : "";
    l(o ? u + "  ".repeat(f) : u);
  }
  function h(f = !0) {
    const w = ++a.indentLevel;
    f && c(w);
  }
  function m(f = !0) {
    const w = --a.indentLevel;
    f && c(w);
  }
  function p() {
    c(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: h,
    deindent: m,
    newline: p,
    helper: (f) => `_${f}`,
    needIndent: () => a.needIndent
  };
}
function sc(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), hn(e, t.key), t.modifier ? (e.push(", "), hn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function oc(e, t) {
  const { helper: n, needIndent: s } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(s());
  const o = t.items.length;
  for (let r = 0; r < o && (hn(e, t.items[r]), r !== o - 1); r++)
    e.push(", ");
  e.deindent(s()), e.push("])");
}
function rc(e, t) {
  const { helper: n, needIndent: s } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(s());
    const o = t.cases.length;
    for (let r = 0; r < o && (hn(e, t.cases[r]), r !== o - 1); r++)
      e.push(", ");
    e.deindent(s()), e.push("])");
  }
}
function ac(e, t) {
  t.body ? hn(e, t.body) : e.push("null");
}
function hn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      ac(e, t);
      break;
    case 1:
      rc(e, t);
      break;
    case 2:
      oc(e, t);
      break;
    case 6:
      sc(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw yn(ee.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: tc,
          args: [t.type]
        });
  }
}
const ic = (e, t = {}) => {
  const n = z(t.mode) ? t.mode : "normal", s = z(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = nc(e, {
    filename: s,
    breakLineCode: o,
    needIndent: r
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(r), a.length > 0 && (i.push(`const { ${ho(a.map((h) => `${h}: _${h}`), ", ")} } = ctx`), i.newline()), i.push("return "), hn(i, e), i.deindent(r), i.push("}"), delete e.helpers;
  const { code: l, map: c } = i.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function lc(e, t = {}) {
  const n = Ue({}, t), s = !!n.jit, o = !!n.minify, r = n.optimize == null ? !0 : n.optimize, i = Xl(n).parse(e);
  return s ? (r && Ql(i), o && un(i), { ast: i, code: "" }) : (Zl(i, n), ic(i, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function cc() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Gt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Gt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function yt(e) {
  return ce(e) && go(e) === 0 && (gt(e, "b") || gt(e, "body"));
}
const aa = ["b", "body"];
function uc(e) {
  return Ht(e, aa);
}
const ia = ["c", "cases"];
function dc(e) {
  return Ht(e, ia, []);
}
const la = ["s", "static"];
function fc(e) {
  return Ht(e, la);
}
const ca = ["i", "items"];
function mc(e) {
  return Ht(e, ca, []);
}
const ua = ["t", "type"];
function go(e) {
  return Ht(e, ua);
}
const da = ["v", "value"];
function Gn(e, t) {
  const n = Ht(e, da);
  if (n != null)
    return n;
  throw Nn(t);
}
const fa = ["m", "modifier"];
function hc(e) {
  return Ht(e, fa);
}
const ma = ["k", "key"];
function pc(e) {
  const t = Ht(e, ma);
  if (t)
    return t;
  throw Nn(
    6
    /* NodeTypes.Linked */
  );
}
function Ht(e, t, n) {
  for (let s = 0; s < t.length; s++) {
    const o = t[s];
    if (gt(e, o) && e[o] != null)
      return e[o];
  }
  return n;
}
const ha = [
  ...aa,
  ...ia,
  ...la,
  ...ca,
  ...ma,
  ...fa,
  ...da,
  ...ua
];
function Nn(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Is(e) {
  return (n) => gc(n, e);
}
function gc(e, t) {
  const n = uc(t);
  if (n == null)
    throw Nn(
      0
      /* NodeTypes.Resource */
    );
  if (go(n) === 1) {
    const r = dc(n);
    return e.plural(r.reduce((a, i) => [
      ...a,
      nr(e, i)
    ], []));
  } else
    return nr(e, n);
}
function nr(e, t) {
  const n = fc(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const s = mc(t).reduce((o, r) => [...o, Ws(e, r)], []);
    return e.normalize(s);
  }
}
function Ws(e, t) {
  const n = go(t);
  switch (n) {
    case 3:
      return Gn(t, n);
    case 9:
      return Gn(t, n);
    case 4: {
      const s = t;
      if (gt(s, "k") && s.k)
        return e.interpolate(e.named(s.k));
      if (gt(s, "key") && s.key)
        return e.interpolate(e.named(s.key));
      throw Nn(n);
    }
    case 5: {
      const s = t;
      if (gt(s, "i") && qe(s.i))
        return e.interpolate(e.list(s.i));
      if (gt(s, "index") && qe(s.index))
        return e.interpolate(e.list(s.index));
      throw Nn(n);
    }
    case 6: {
      const s = t, o = hc(s), r = pc(s);
      return e.linked(Ws(e, r), o ? Ws(e, o) : void 0, e.type);
    }
    case 7:
      return Gn(t, n);
    case 8:
      return Gn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const bc = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function wc(e, t) {
  t && Ml(e) && Ot(gs(bc, { source: e }));
}
const yc = (e) => e;
let Kn = xe();
function vc(e, t = {}) {
  let n = !1;
  const s = t.onError || Dl;
  return t.onError = (o) => {
    n = !0, s(o);
  }, { ...lc(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function _c(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && z(e)) {
    const n = Ie(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && wc(e, n);
    const o = (t.onCacheKey || yc)(e), r = Kn[o];
    if (r)
      return r;
    const { ast: a, detectError: i } = vc(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Is(a);
    return i ? l : Kn[o] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !yt(e))
      return Ot(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const s = Kn[n];
      return s || (Kn[n] = Is(e));
    } else
      return Is(e);
  }
}
let Ln = null;
function xc(e) {
  Ln = e;
}
function Ec(e, t, n) {
  Ln && Ln.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const kc = /* @__PURE__ */ Cc("function:translate");
function Cc(e) {
  return (t) => Ln && Ln.emit(e, t);
}
const Ke = {
  INVALID_ARGUMENT: Il,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Tc = 24;
function $t(e) {
  return yn(e, null, process.env.NODE_ENV !== "production" ? { messages: Oc } : void 0);
}
const Oc = {
  [Ke.INVALID_ARGUMENT]: "Invalid arguments",
  [Ke.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ke.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ke.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ke.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ke.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ke.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function bo(e, t) {
  return t.locale != null ? sr(t.locale) : sr(e.locale);
}
let Ps;
function sr(e) {
  if (z(e))
    return e;
  if (Oe(e)) {
    if (e.resolvedOnce && Ps != null)
      return Ps;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Sl(t))
        throw $t(Ke.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ps = t;
    } else
      throw $t(Ke.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw $t(Ke.NOT_SUPPORT_LOCALE_TYPE);
}
function Ac(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Pe(t) ? t : ce(t) ? Object.keys(t) : z(t) ? [t] : [n]
  ])];
}
function zs(e, t, n) {
  const s = z(n) ? n : os, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let r = o.__localeChainCache.get(s);
  if (!r) {
    r = [];
    let a = [n];
    for (; Pe(a); )
      a = or(r, a, t);
    const i = Pe(t) || !we(t) ? t : t.default ? t.default : null;
    a = z(i) ? [i] : i, Pe(a) && or(r, a, !1), o.__localeChainCache.set(s, r);
  }
  return r;
}
function or(e, t, n) {
  let s = !0;
  for (let o = 0; o < t.length && Ie(s); o++) {
    const r = t[o];
    z(r) && (s = Sc(e, t[o], n));
  }
  return s;
}
function Sc(e, t, n) {
  let s;
  const o = t.split("-");
  do {
    const r = o.join("-");
    s = Nc(e, r, n), o.splice(-1, 1);
  } while (o.length && s === !0);
  return s;
}
function Nc(e, t, n) {
  let s = !1;
  if (!e.includes(t) && (s = !0, t)) {
    s = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (Pe(n) || we(n)) && n[o] && (s = n[o]);
  }
  return s;
}
const jt = [];
jt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
jt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
jt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
jt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
jt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
jt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
jt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Lc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $c(e) {
  return Lc.test(e);
}
function Ic(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Pc(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Dc(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : $c(t) ? Ic(t) : "*" + t;
}
function Rc(e) {
  const t = [];
  let n = -1, s = 0, o = 0, r, a, i, l, c, h, m;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), o++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, s = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, a === void 0 || (a = Dc(a), a === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const _ = e[n + 1];
    if (s === 5 && _ === "'" || s === 6 && _ === '"')
      return n++, i = "\\" + _, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; s !== null; )
    if (n++, r = e[n], !(r === "\\" && g())) {
      if (l = Pc(r), m = jt[s], c = m[l] || m.l || 8, c === 8 || (s = c[0], c[1] !== void 0 && (h = p[c[1]], h && (i = r, h() === !1))))
        return;
      if (s === 7)
        return t;
    }
}
const rr = /* @__PURE__ */ new Map();
function Mc(e, t) {
  return ce(e) ? e[t] : null;
}
function Bc(e, t) {
  if (!ce(e))
    return null;
  let n = rr.get(t);
  if (n || (n = Rc(t), n && rr.set(t, n)), !n)
    return null;
  const s = n.length;
  let o = e, r = 0;
  for (; r < s; ) {
    const a = n[r];
    if (ha.includes(a) && yt(o) || !ce(o) || !gt(o, a))
      return null;
    const i = o[a];
    if (i === void 0 || Oe(o))
      return null;
    o = i, r++;
  }
  return o;
}
const He = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, ln = 10, Fc = {
  [He.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [He.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [He.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [He.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [He.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [He.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [He.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [He.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [He.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function It(e, ...t) {
  return gs(Fc[e], ...t);
}
const Uc = "11.4.4", ws = -1, os = "en-US", pn = "", ar = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Vc() {
  return {
    upper: (e, t) => t === "text" && z(e) ? e.toUpperCase() : t === "vnode" && ce(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && z(e) ? e.toLowerCase() : t === "vnode" && ce(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && z(e) ? ar(e) : t === "vnode" && ce(e) && "__v_isVNode" in e ? ar(e.children) : e
  };
}
let pa;
function Hc(e) {
  pa = e;
}
let ga;
function jc(e) {
  ga = e;
}
let ba;
function qc(e) {
  ba = e;
}
let wa = null;
const Wc = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  wa = e;
}, zc = /* @__NO_SIDE_EFFECTS__ */ () => wa;
let ya = null;
const ir = (e) => {
  ya = e;
}, Yc = () => ya;
let lr = 0;
function Gc(e = {}) {
  const t = Oe(e.onWarn) ? e.onWarn : Ot, n = z(e.version) ? e.version : Uc, s = z(e.locale) || Oe(e.locale) ? e.locale : os, o = Oe(s) ? os : s, r = Pe(e.fallbackLocale) || we(e.fallbackLocale) || z(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, a = we(e.messages) ? e.messages : Ds(o), i = we(e.datetimeFormats) ? e.datetimeFormats : Ds(o), l = we(e.numberFormats) ? e.numberFormats : Ds(o), c = Ue(xe(), e.modifiers, Vc()), h = e.pluralRules || xe(), m = Oe(e.missing) ? e.missing : null, p = Ie(e.missingWarn) || ss(e.missingWarn) ? e.missingWarn : !0, g = Ie(e.fallbackWarn) || ss(e.fallbackWarn) ? e.fallbackWarn : !0, _ = !!e.fallbackFormat, f = !!e.unresolving, w = Oe(e.postTranslation) ? e.postTranslation : null, u = we(e.processor) ? e.processor : null, b = Ie(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter, v = Oe(e.messageCompiler) ? e.messageCompiler : pa;
  process.env.NODE_ENV !== "production" && Oe(e.messageCompiler) && wl(It(He.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = Oe(e.messageResolver) ? e.messageResolver : ga || Mc, $ = Oe(e.localeFallbacker) ? e.localeFallbacker : ba || Ac, C = ce(e.fallbackContext) ? e.fallbackContext : void 0, B = e, D = ce(B.__datetimeFormatters) ? B.__datetimeFormatters : /* @__PURE__ */ new Map(), F = ce(B.__numberFormatters) ? B.__numberFormatters : /* @__PURE__ */ new Map(), H = ce(B.__meta) ? B.__meta : {};
  lr++;
  const te = {
    version: n,
    cid: lr,
    locale: s,
    fallbackLocale: r,
    messages: a,
    modifiers: c,
    pluralRules: h,
    missing: m,
    missingWarn: p,
    fallbackWarn: g,
    fallbackFormat: _,
    unresolving: f,
    postTranslation: w,
    processor: u,
    warnHtmlMessage: b,
    escapeParameter: x,
    messageCompiler: v,
    messageResolver: A,
    localeFallbacker: $,
    fallbackContext: C,
    onWarn: t,
    __meta: H
  };
  return te.datetimeFormats = i, te.numberFormats = l, te.__datetimeFormatters = D, te.__numberFormatters = F, process.env.NODE_ENV !== "production" && (te.__v_emitter = B.__v_emitter != null ? B.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ec(te, n, H), te;
}
const Ds = (e) => ({ [e]: xe() });
function ys(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function va(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function wo(e, t, n, s, o) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (r !== null) {
    const i = r(e, n, t, o);
    return z(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && va(s, t) && a(It(He.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Tn(e, t, n) {
  const s = e;
  s.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function _a(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Kc(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let s = n + 1; s < t.length; s++)
    if (_a(e, t[s]))
      return !0;
  return !1;
}
const cr = typeof Intl < "u", xa = {
  dateTimeFormat: cr && typeof Intl.DateTimeFormat < "u",
  numberFormat: cr && typeof Intl.NumberFormat < "u"
};
function ur(e, ...t) {
  const { datetimeFormats: n, unresolving: s, fallbackLocale: o, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !xa.dateTimeFormat)
    return r(It(He.CANNOT_FORMAT_DATE)), pn;
  if (!z(t[0]) && !sa(t[0]) && !qe(t[0]))
    return process.env.NODE_ENV !== "production" && r(It(He.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), pn;
  const [l, c, h, m] = Ys(...t), p = Ie(h.missingWarn) ? h.missingWarn : e.missingWarn, g = Ie(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, _ = !!h.part, f = bo(e, h), w = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    f
  );
  if (!z(l) || l === "")
    return new Intl.DateTimeFormat(f.replace(/!/g, ""), m).format(c);
  let u = {}, b, x = null, v = f, A = null;
  const $ = "datetime format";
  for (let D = 0; D < w.length; D++) {
    if (b = A = w[D], process.env.NODE_ENV !== "production" && f !== b && ys(g, l) && r(It(He.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && f !== b) {
      const F = e.__v_emitter;
      F && F.emit("fallback", {
        type: $,
        key: l,
        from: v,
        to: A,
        groupId: `${$}:${l}`
      });
    }
    if (u = n[b] || {}, x = u[l], we(x))
      break;
    wo(e, l, b, p, $), v = A;
  }
  if (!we(x) || !z(b))
    return s ? ws : l;
  let C = `${b}__${l}`;
  bs(m) || (C = `${C}__${JSON.stringify(m)}`);
  let B = i.get(C);
  return B || (B = new Intl.DateTimeFormat(b, Ue({}, x, m)), i.set(C, B)), _ ? B.formatToParts(c) : B.format(c);
}
const Ea = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Ys(...e) {
  const [t, n, s, o] = e, r = xe();
  let a = xe(), i;
  if (z(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw $t(Ke.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(c);
    try {
      i.toISOString();
    } catch {
      throw $t(Ke.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (sa(t)) {
    if (isNaN(t.getTime()))
      throw $t(Ke.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (qe(t))
    i = t;
  else
    throw $t(Ke.INVALID_ARGUMENT);
  return z(n) ? r.key = n : we(n) && Object.keys(n).forEach((l) => {
    Ea.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), z(s) ? r.locale = s : we(s) && (a = s), we(o) && (a = o), [r.key || "", i, r, a];
}
function dr(e, t, n) {
  const s = e;
  for (const o in n) {
    const r = `${t}__${o}`;
    s.__datetimeFormatters.has(r) && s.__datetimeFormatters.delete(r);
  }
}
function fr(e, ...t) {
  const { numberFormats: n, unresolving: s, fallbackLocale: o, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !xa.numberFormat)
    return r(It(He.CANNOT_FORMAT_NUMBER)), pn;
  if (!qe(t[0]))
    return process.env.NODE_ENV !== "production" && r(It(He.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), pn;
  const [l, c, h, m] = Gs(...t), p = Ie(h.missingWarn) ? h.missingWarn : e.missingWarn, g = Ie(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, _ = !!h.part, f = bo(e, h), w = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    f
  );
  if (!z(l) || l === "")
    return new Intl.NumberFormat(f.replace(/!/g, ""), m).format(c);
  let u = {}, b, x = null, v = f, A = null;
  const $ = "number format";
  for (let D = 0; D < w.length; D++) {
    if (b = A = w[D], process.env.NODE_ENV !== "production" && f !== b && ys(g, l) && r(It(He.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: b
    })), process.env.NODE_ENV !== "production" && f !== b) {
      const F = e.__v_emitter;
      F && F.emit("fallback", {
        type: $,
        key: l,
        from: v,
        to: A,
        groupId: `${$}:${l}`
      });
    }
    if (u = n[b] || {}, x = u[l], we(x))
      break;
    wo(e, l, b, p, $), v = A;
  }
  if (!we(x) || !z(b))
    return s ? ws : l;
  let C = `${b}__${l}`;
  bs(m) || (C = `${C}__${JSON.stringify(m)}`);
  let B = i.get(C);
  return B || (B = new Intl.NumberFormat(b, Ue({}, x, m)), i.set(C, B)), _ ? B.formatToParts(c) : B.format(c);
}
const ka = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Gs(...e) {
  const [t, n, s, o] = e, r = xe();
  let a = xe();
  if (!qe(t))
    throw $t(Ke.INVALID_ARGUMENT);
  const i = t;
  return z(n) ? r.key = n : we(n) && Object.keys(n).forEach((l) => {
    ka.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), z(s) ? r.locale = s : we(s) && (a = s), we(o) && (a = o), [r.key || "", i, r, a];
}
function mr(e, t, n) {
  const s = e;
  for (const o in n) {
    const r = `${t}__${o}`;
    s.__numberFormatters.has(r) && s.__numberFormatters.delete(r);
  }
}
const Xc = (e) => e, Jc = (e) => "", Zc = "text", Qc = (e) => e.length === 0 ? "" : ho(e), eu = Nl;
function Rs(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function tu(e) {
  var n, s;
  const t = qe(e.pluralIndex) ? e.pluralIndex : -1;
  return qe((n = e.named) == null ? void 0 : n.count) ? e.named.count : qe((s = e.named) == null ? void 0 : s.n) ? e.named.n : t;
}
function nu(e = {}) {
  var u, b, x, v;
  const t = e.locale, n = tu(e), s = z(t) && Oe((u = e.pluralRules) == null ? void 0 : u[t]) ? e.pluralRules[t] : Rs, o = s === Rs ? void 0 : Rs, r = (A) => A[s(n, A.length, o)], a = e.list || [], i = (A) => a[A], l = e.named || xe();
  qe(e.pluralIndex) && (l.count || (l.count = e.pluralIndex), l.n || (l.n = e.pluralIndex));
  const c = (A) => l[A];
  function h(A, $) {
    const C = Oe(e.messages) ? e.messages(A, !!$) : ce(e.messages) ? e.messages[A] : !1;
    return C || (e.parent ? e.parent.message(A) : Jc);
  }
  const m = (A) => e.modifiers ? e.modifiers[A] : Xc, p = Oe((b = e.processor) == null ? void 0 : b.normalize) ? e.processor.normalize : Qc, g = Oe((x = e.processor) == null ? void 0 : x.interpolate) ? e.processor.interpolate : eu, _ = z((v = e.processor) == null ? void 0 : v.type) ? e.processor.type : Zc, w = {
    list: i,
    named: c,
    plural: r,
    linked: (A, ...$) => {
      const [C, B] = $;
      let D = "text", F = "";
      $.length === 1 ? ce(C) ? (F = C.modifier || F, D = C.type || D) : z(C) && (F = C || F) : $.length === 2 && (z(C) && (F = C || F), z(B) && (D = B || D));
      const H = h(A, !0)(w), te = H === "" || H === void 0 ? A : H, Me = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        D === "vnode" && Pe(te) && F ? te[0] : te
      );
      return F ? m(F)(Me, D) : Me;
    },
    message: h,
    type: _,
    interpolate: g,
    normalize: p,
    values: Ue(xe(), a, l)
  };
  return w;
}
const hr = () => "", pt = (e) => Oe(e);
function pr(e, ...t) {
  const { fallbackFormat: n, postTranslation: s, unresolving: o, messageCompiler: r, fallbackLocale: a, messages: i } = e, [l, c] = Ks(...t), h = Ie(c.missingWarn) ? c.missingWarn : e.missingWarn, m = Ie(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = Ie(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, g = !!c.resolvedMessage, _ = z(c.default) || Ie(c.default) ? Ie(c.default) ? r ? l : () => l : c.default : n ? r ? l : () => l : null, f = n || _ != null && (z(_) || Oe(_)), w = bo(e, c);
  p && su(c);
  let [u, b, x] = g ? [
    l,
    w,
    i[w] || xe()
  ] : Ca(e, l, w, a, m, h), v = u, A = l;
  if (!g && !(z(v) || yt(v) || pt(v)) && f && (v = _, A = v), !g && (!(z(v) || yt(v) || pt(v)) || !z(b)))
    return o ? ws : l;
  if (process.env.NODE_ENV !== "production" && z(v) && e.messageCompiler == null)
    return Ot(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let $ = !1;
  const C = () => {
    $ = !0;
  }, B = pt(v) ? v : Ta(e, l, b, v, A, C);
  if ($)
    return v;
  const D = iu(e, b, x, c), F = nu(D), H = ou(e, B, F);
  let te = s ? s(H, l) : H;
  if (p && z(te) && (te = Ol(te)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Me = {
      timestamp: Date.now(),
      key: z(l) ? l : pt(v) ? v.key : "",
      locale: b || (pt(v) ? v.locale : ""),
      format: z(v) ? v : pt(v) ? v.source : "",
      message: te
    };
    Me.meta = Ue({}, e.__meta, /* @__PURE__ */ zc() || {}), kc(Me);
  }
  return te;
}
function su(e) {
  Pe(e.list) ? e.list = e.list.map((t) => z(t) ? Xo(t) : t) : ce(e.named) && Object.keys(e.named).forEach((t) => {
    z(e.named[t]) && (e.named[t] = Xo(e.named[t]));
  });
}
function Ca(e, t, n, s, o, r) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: c } = e, h = c(e, s, n);
  let m = xe(), p, g = null, _ = n, f = null;
  const w = "translate";
  for (let u = 0; u < h.length; u++) {
    p = f = h[u], process.env.NODE_ENV !== "production" && n !== p && !_a(n, p) && ys(o, t) && i(It(He.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    }));
    const b = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== p && b && b.emit("fallback", {
      type: w,
      key: t,
      from: _,
      to: f,
      groupId: `${w}:${t}`
    }), m = a[p] || xe();
    let x = null, v, A;
    if (process.env.NODE_ENV !== "production" && Dt && b && (x = window.performance.now(), v = "intlify-message-resolve-start", A = "intlify-message-resolve-end", lt && lt(v)), (g = l(m, t)) === null && (g = m[t]), process.env.NODE_ENV !== "production" && Dt && b) {
      const $ = window.performance.now();
      b && x && g && b.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: $ - x,
        groupId: `${w}:${t}`
      }), v && A && lt && Zt && (lt(A), Zt("intlify message resolve", v, A));
    }
    if (z(g) || yt(g) || pt(g))
      break;
    if (!Kc(p, h)) {
      const $ = wo(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        r,
        w
      );
      $ !== t && (g = $);
    }
    _ = f;
  }
  return [g, p, m];
}
function Ta(e, t, n, s, o, r) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (pt(s)) {
    const g = s;
    return g.locale = g.locale || n, g.key = g.key || t, g;
  }
  if (a == null) {
    const g = () => s;
    return g.locale = n, g.key = t, g;
  }
  const l = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let c = null, h, m;
  process.env.NODE_ENV !== "production" && Dt && l && (c = window.performance.now(), h = "intlify-message-compilation-start", m = "intlify-message-compilation-end", lt && lt(h));
  const p = a(s, ru(e, n, o, s, i, r));
  if (process.env.NODE_ENV !== "production" && Dt && l) {
    const g = window.performance.now();
    l && c && l.emit("message-compilation", {
      type: "message-compilation",
      message: s,
      time: g - c,
      groupId: `translate:${t}`
    }), h && m && lt && Zt && (lt(m), Zt("intlify message compilation", h, m));
  }
  return p.locale = n, p.key = t, p.source = s, p;
}
function ou(e, t, n) {
  const s = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let o = null, r, a;
  process.env.NODE_ENV !== "production" && Dt && s && (o = window.performance.now(), r = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", lt && lt(r));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && Dt && s) {
    const l = window.performance.now();
    s && o && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: l - o,
      groupId: `translate:${t.key}`
    }), r && a && lt && Zt && (lt(a), Zt("intlify message evaluation", r, a));
  }
  return i;
}
function Ks(...e) {
  const [t, n, s] = e, o = xe();
  if (!z(t) && !qe(t) && !pt(t) && !yt(t))
    throw $t(Ke.INVALID_ARGUMENT);
  const r = qe(t) ? String(t) : (pt(t), t);
  return qe(n) ? o.plural = n : z(n) ? o.default = n : we(n) && !bs(n) ? o.named = n : Pe(n) && (o.list = n), qe(s) ? o.plural = s : z(s) ? o.default = s : we(s) && Ue(o, s), [r, o];
}
function ru(e, t, n, s, o, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const i = au(s), l = a.location && i && Ll(i, a.location.start.offset, a.location.end.offset), c = e.__v_emitter;
        c && i && c.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const h = `Message compilation error: ${a.message}`;
        throw new SyntaxError(l ? `${h}
${l}` : h);
      }
      throw a;
    },
    onCacheKey: (a) => vl(t, n, a)
  };
}
function au(e) {
  if (z(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function iu(e, t, n, s) {
  const { modifiers: o, pluralRules: r, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: c, fallbackContext: h } = e, p = {
    locale: t,
    modifiers: o,
    pluralRules: r,
    messages: (g, _) => {
      let f = a(n, g);
      if (f == null && (h || _)) {
        const [w, , u] = Ca(
          h || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          g,
          t,
          i,
          l,
          c
        );
        f = w ?? a(u, g);
      }
      if (z(f) || yt(f)) {
        let w = !1;
        const b = Ta(e, g, t, f, g, () => {
          w = !0;
        });
        return w ? hr : b;
      } else return pt(f) ? f : hr;
    }
  };
  return e.processor && (p.processor = e.processor), s.list && (p.list = s.list), s.named && (p.named = s.named), qe(s.plural) && (p.pluralIndex = s.plural), p;
}
cc();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const lu = "11.4.4";
function cu() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Gt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Gt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Gt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Gt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Ve = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Tc,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function fn(e, ...t) {
  return yn(e, null, process.env.NODE_ENV !== "production" ? { messages: uu, args: t } : void 0);
}
const uu = {
  [Ve.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ve.INVALID_ARGUMENT]: "Invalid argument",
  [Ve.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ve.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ve.UNEXPECTED_ERROR]: "Unexpected error",
  [Ve.REQUIRED_VALUE]: "Required in value: {0}",
  [Ve.INVALID_VALUE]: "Invalid value",
  [Ve.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ve.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ve.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ve.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Xs = /* @__PURE__ */ Bt("__translateVNode"), Js = /* @__PURE__ */ Bt("__datetimeParts"), Zs = /* @__PURE__ */ Bt("__numberParts"), $n = /* @__PURE__ */ Bt("__enableEmitter"), In = /* @__PURE__ */ Bt("__disableEmitter"), du = Bt("__setPluralRules"), Oa = /* @__PURE__ */ Bt("__injectWithOption"), dn = /* @__PURE__ */ Bt("__dispose"), Ct = {
  FALLBACK_TO_ROOT: ln,
  // 10
  NOT_FOUND_PARENT_SCOPE: ln + 1,
  IGNORE_OBJ_FLATTEN: ln + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: ln + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: ln + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: ln + 5
}, fu = {
  [Ct.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ct.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ct.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ct.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ct.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Ct.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function rs(e, ...t) {
  return gs(fu[e], ...t);
}
function Pn(e) {
  if (!ce(e) || yt(e))
    return e;
  for (const t in e)
    if (gt(e, t))
      if (!t.includes("."))
        ce(e[t]) && Pn(e[t]);
      else {
        const n = t.split("."), s = n.length - 1;
        let o = e, r = !1;
        for (let a = 0; a < s; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in o || (o[n[a]] = xe()), !ce(o[n[a]])) {
            process.env.NODE_ENV !== "production" && Ot(rs(Ct.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          o = o[n[a]];
        }
        if (r || (yt(o) ? ha.includes(n[s]) || delete e[t] : (o[n[s]] = e[t], delete e[t])), !yt(o)) {
          const a = o[n[s]];
          ce(a) && Pn(a);
        }
      }
  return e;
}
function Aa(e, t) {
  const { messages: n, __i18n: s, messageResolver: o, flatJson: r } = t, a = we(n) ? n : Pe(s) ? xe() : { [e]: xe() };
  if (Pe(s) && s.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: c } = i;
      l ? (a[l] = a[l] || xe(), Zn(c, a[l])) : Zn(c, a);
    } else
      z(i) && Zn(JSON.parse(i), a);
  }), o == null && r)
    for (const i in a)
      gt(a, i) && Pn(a[i]);
  return a;
}
function Sa(e) {
  return e.type;
}
function mu(e, t, n) {
  let s = ce(t.messages) ? t.messages : xe();
  "__i18nGlobal" in n && (s = Aa(e.locale.value, {
    messages: s,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(s);
  o.length && o.forEach((r) => {
    e.mergeLocaleMessage(r, s[r]);
  });
  {
    if (ce(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (ce(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function gr(e) {
  return it(ul, null, e, 0);
}
function yo() {
  const e = "currentInstance";
  return e in $s ? $s[e] : $s.getCurrentInstance();
}
const br = "__INTLIFY_META__", wr = () => [], hu = () => !1;
let yr = 0;
function vr(e) {
  return (t, n, s, o) => e(n, s, yo() || void 0, o);
}
const pu = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = yo();
  let t = null;
  return e && (t = Sa(e)[br]) ? { [br]: t } : null;
};
function _r(e = {}) {
  const { __root: t, __injectWithOption: n } = e, s = t === void 0, o = e.flatJson, r = Dt ? G : cl;
  let a = Ie(e.inheritLocale) ? e.inheritLocale : !0;
  const i = r(
    // prettier-ignore
    t && a ? t.locale.value : z(e.locale) ? e.locale : os
  ), l = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : z(e.fallbackLocale) || Pe(e.fallbackLocale) || we(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), c = r(Aa(i.value, e)), h = r(we(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), m = r(we(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let p = t ? t.missingWarn : Ie(e.missingWarn) || ss(e.missingWarn) ? e.missingWarn : !0, g = t ? t.fallbackWarn : Ie(e.fallbackWarn) || ss(e.fallbackWarn) ? e.fallbackWarn : !0, _ = t ? t.fallbackRoot : Ie(e.fallbackRoot) ? e.fallbackRoot : !0, f = !!e.fallbackFormat, w = Oe(e.missing) ? e.missing : null, u = Oe(e.missing) ? vr(e.missing) : null, b = Oe(e.postTranslation) ? e.postTranslation : null, x = t ? t.warnHtmlMessage : Ie(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter;
  const A = t ? t.modifiers : we(e.modifiers) ? e.modifiers : {};
  let $ = e.pluralRules || t && t.pluralRules, C;
  C = (() => {
    s && ir(null);
    const N = {
      version: lu,
      locale: i.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: A,
      pluralRules: $,
      missing: u === null ? void 0 : u,
      missingWarn: p,
      fallbackWarn: g,
      fallbackFormat: f,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: x,
      escapeParameter: v,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    N.datetimeFormats = h.value, N.numberFormats = m.value, N.__datetimeFormatters = we(C) ? C.__datetimeFormatters : void 0, N.__numberFormatters = we(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (N.__v_emitter = we(C) ? C.__v_emitter : void 0);
    const R = Gc(N);
    return s && ir(R), R;
  })(), Tn(C, i.value, l.value);
  function D() {
    return [
      i.value,
      l.value,
      c.value,
      h.value,
      m.value
    ];
  }
  const F = me({
    get: () => i.value,
    set: (N) => {
      C.locale = N, i.value = N;
    }
  }), H = me({
    get: () => l.value,
    set: (N) => {
      C.fallbackLocale = N, l.value = N, Tn(C, i.value, N);
    }
  }), te = me(() => c.value), Me = /* @__PURE__ */ me(() => h.value), j = /* @__PURE__ */ me(() => m.value);
  function U() {
    return Oe(b) ? b : null;
  }
  function M(N) {
    b = N, C.postTranslation = N;
  }
  function K() {
    return w;
  }
  function V(N) {
    N !== null && (u = vr(N)), w = N, C.missing = u;
  }
  function J(N, R) {
    return N !== "translate" || !R.resolvedMessage;
  }
  const q = (N, R, de, Se, qt, Wt) => {
    D();
    let mt;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, s || (C.fallbackContext = t ? Yc() : void 0), mt = N(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, s || (C.fallbackContext = void 0);
    }
    if (de !== "translate exists" && // for not `te` (e.g `t`)
    qe(mt) && mt === ws || de === "translate exists" && !mt) {
      const [zt, rl] = R();
      if (process.env.NODE_ENV !== "production" && t && z(zt) && J(de, rl) && (_ && (ys(g, zt) || va(p, zt)) && Ot(rs(Ct.FALLBACK_TO_ROOT, {
        key: zt,
        type: de
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: zo } = C;
        zo && _ && zo.emit("fallback", {
          type: de,
          key: zt,
          to: "global",
          groupId: `${de}:${zt}`
        });
      }
      return t && _ ? Se(t) : qt(zt);
    } else {
      if (Wt(mt))
        return mt;
      throw fn(Ve.UNEXPECTED_RETURN_TYPE);
    }
  };
  function oe(...N) {
    return q((R) => Reflect.apply(pr, null, [R, ...N]), () => Ks(...N), "translate", (R) => Reflect.apply(R.t, R, [...N]), (R) => R, (R) => z(R));
  }
  function le(...N) {
    const [R, de, Se] = N;
    if (Se && !ce(Se))
      throw fn(Ve.INVALID_ARGUMENT);
    return oe(R, de, Ue({ resolvedMessage: !0 }, Se || {}));
  }
  function ne(...N) {
    return q((R) => Reflect.apply(ur, null, [R, ...N]), () => Ys(...N), "datetime format", (R) => Reflect.apply(R.d, R, [...N]), () => pn, (R) => z(R) || Pe(R));
  }
  function fe(...N) {
    return q((R) => Reflect.apply(fr, null, [R, ...N]), () => Gs(...N), "number format", (R) => Reflect.apply(R.n, R, [...N]), () => pn, (R) => z(R) || Pe(R));
  }
  function be(N) {
    return N.map((R) => z(R) || qe(R) || Ie(R) ? gr(String(R)) : R);
  }
  const Te = {
    normalize: be,
    interpolate: (N) => N,
    type: "vnode"
  };
  function ae(...N) {
    return q((R) => {
      let de;
      const Se = R;
      try {
        Se.processor = Te, de = Reflect.apply(pr, null, [Se, ...N]);
      } finally {
        Se.processor = null;
      }
      return de;
    }, () => Ks(...N), "translate", (R) => R[Xs](...N), (R) => [gr(R)], (R) => Pe(R));
  }
  function Be(...N) {
    return q((R) => Reflect.apply(fr, null, [R, ...N]), () => Gs(...N), "number format", (R) => R[Zs](...N), wr, (R) => z(R) || Pe(R));
  }
  function ke(...N) {
    return q((R) => Reflect.apply(ur, null, [R, ...N]), () => Ys(...N), "datetime format", (R) => R[Js](...N), wr, (R) => z(R) || Pe(R));
  }
  function re(N) {
    $ = N, C.pluralRules = $;
  }
  function se(N, R) {
    return q(() => {
      if (!N)
        return !1;
      const de = z(R) ? R : i.value, Se = z(R) ? [de] : zs(C, l.value, de);
      for (let qt = 0; qt < Se.length; qt++) {
        const Wt = ve(Se[qt]);
        let mt = C.messageResolver(Wt, N);
        if (mt === null && (mt = Wt[N]), yt(mt) || pt(mt) || z(mt))
          return !0;
      }
      return !1;
    }, () => [N], "translate exists", (de) => Reflect.apply(de.te, de, [N, R]), hu, (de) => Ie(de));
  }
  function ie(N) {
    let R = null;
    const de = zs(C, l.value, i.value);
    for (let Se = 0; Se < de.length; Se++) {
      const qt = c.value[de[Se]] || {}, Wt = C.messageResolver(qt, N);
      if (Wt != null) {
        R = Wt;
        break;
      }
    }
    return R;
  }
  function Q(N) {
    const R = ie(N);
    return R ?? (t ? t.tm(N) || {} : {});
  }
  function ve(N) {
    return c.value[N] || {};
  }
  function Qe(N, R) {
    if (o) {
      const de = { [N]: R };
      for (const Se in de)
        gt(de, Se) && Pn(de[Se]);
      R = de[N];
    }
    c.value[N] = R, C.messages = c.value;
  }
  function ze(N, R) {
    c.value[N] = c.value[N] || {};
    const de = { [N]: R };
    if (o)
      for (const Se in de)
        gt(de, Se) && Pn(de[Se]);
    R = de[N], Zn(R, c.value[N]), C.messages = c.value;
  }
  function y(N) {
    return h.value[N] || {};
  }
  function E(N, R) {
    h.value[N] = R, C.datetimeFormats = h.value, dr(C, N, R);
  }
  function P(N, R) {
    h.value[N] = Ue(h.value[N] || {}, R), C.datetimeFormats = h.value, dr(C, N, R);
  }
  function W(N) {
    return m.value[N] || {};
  }
  function Ce(N, R) {
    m.value[N] = R, C.numberFormats = m.value, mr(C, N, R);
  }
  function Le(N, R) {
    m.value[N] = Ue(m.value[N] || {}, R), C.numberFormats = m.value, mr(C, N, R);
  }
  yr++, t && Dt && (vt(t.locale, (N) => {
    a && (i.value = N, C.locale = N, Tn(C, i.value, l.value));
  }), vt(t.fallbackLocale, (N) => {
    a && (l.value = N, C.fallbackLocale = N, Tn(C, i.value, l.value));
  }));
  const ue = {
    id: yr,
    locale: F,
    fallbackLocale: H,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(N) {
      a = N, N && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, Tn(C, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: te,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return $ || {};
    },
    get isGlobal() {
      return s;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(N) {
      p = N, C.missingWarn = p;
    },
    get fallbackWarn() {
      return g;
    },
    set fallbackWarn(N) {
      g = N, C.fallbackWarn = g;
    },
    get fallbackRoot() {
      return _;
    },
    set fallbackRoot(N) {
      _ = N;
    },
    get fallbackFormat() {
      return f;
    },
    set fallbackFormat(N) {
      f = N, C.fallbackFormat = f;
    },
    get warnHtmlMessage() {
      return x;
    },
    set warnHtmlMessage(N) {
      x = N, C.warnHtmlMessage = N;
    },
    get escapeParameter() {
      return v;
    },
    set escapeParameter(N) {
      v = N, C.escapeParameter = N;
    },
    t: oe,
    getLocaleMessage: ve,
    setLocaleMessage: Qe,
    mergeLocaleMessage: ze,
    getPostTranslationHandler: U,
    setPostTranslationHandler: M,
    getMissingHandler: K,
    setMissingHandler: V,
    [du]: re
  };
  return ue.datetimeFormats = Me, ue.numberFormats = j, ue.rt = le, ue.te = se, ue.tm = Q, ue.d = ne, ue.n = fe, ue.getDateTimeFormat = y, ue.setDateTimeFormat = E, ue.mergeDateTimeFormat = P, ue.getNumberFormat = W, ue.setNumberFormat = Ce, ue.mergeNumberFormat = Le, ue[Oa] = n, ue[Xs] = ae, ue[Js] = ke, ue[Zs] = Be, process.env.NODE_ENV !== "production" && (ue[$n] = (N) => {
    C.__v_emitter = N;
  }, ue[In] = () => {
    C.__v_emitter = void 0;
  }), ue;
}
function as(e, t) {
}
const vo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function gu({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((s, o) => [
    ...s,
    // prettier-ignore
    ...o.type === Fe ? o.children : [o]
  ], []) : t.reduce((n, s) => {
    const o = e[s];
    return o && (n[s] = o()), n;
  }, xe());
}
function Na() {
  return Fe;
}
Ue({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => qe(e) || !isNaN(e)
  }
}, vo);
function bu(e) {
  return Pe(e) && !z(e[0]);
}
function La(e, t, n, s) {
  const { slots: o, attrs: r } = t;
  return () => {
    const a = () => {
      const c = { part: !0 };
      let h = xe();
      e.locale && (c.locale = e.locale), z(e.format) ? c.key = e.format : ce(e.format) && (z(e.format.key) && (c.key = e.format.key), h = Object.keys(e.format).reduce((g, _) => n.includes(_) ? Ue(xe(), g, { [_]: e.format[_] }) : g, xe()));
      const m = s(e.value, c, h);
      let p = [c.key];
      return Pe(m) ? p = m.map((g, _) => {
        const f = o[g.type], w = f ? f({ [g.type]: g.value, index: _, parts: m }) : [g.value];
        return bu(w) && (w[0].key = `${g.type}-${_}`), w;
      }) : z(m) && (p = [m]), p;
    }, i = Ue(xe(), r), l = z(e.tag) || ce(e.tag) ? e.tag : Na();
    return ce(l) ? ns(l, i, { default: a }) : ns(l, i, a());
  };
}
Ue({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vo);
const wu = /* @__PURE__ */ Bt("global-vue-i18n");
function St(e = {}) {
  const t = yo();
  if (t == null)
    throw fn(Ve.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw fn(Ve.NOT_INSTALLED);
  const n = yu(t), s = _u(n), o = Sa(t), r = vu(e, o);
  if (r === "global")
    return mu(s, e, o), s;
  if (r === "parent") {
    let l = xr(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Ot(rs(Ct.NOT_FOUND_PARENT_SCOPE)), l = s), l;
  }
  if (r === "isolated") {
    if (n.mode !== "composition")
      throw fn(Ve.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const l = n, c = Ue({}, e), h = xr(n, t);
    c.__root = h || s;
    const m = _r(c);
    l.__composerExtend && (m[dn] = l.__composerExtend(m));
    let p = null;
    if (process.env.NODE_ENV !== "production") {
      p = ra();
      const _ = m;
      _[$n] && _[$n](p), p.on("*", as);
    }
    return al() && il(() => {
      if (process.env.NODE_ENV !== "production") {
        p && p.off("*", as);
        const f = m;
        f[In] && f[In]();
      }
      const _ = m[dn];
      _ && (_(), delete m[dn]);
    }), m;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = Ue({}, e);
    "__i18n" in o && (l.__i18n = o.__i18n), s && (l.__root = s), i = _r(l), a.__composerExtend && (i[dn] = a.__composerExtend(i)), Eu(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && Ot(rs(Ct.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function yu(e) {
  const t = ll(e.isCE ? wu : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw fn(e.isCE ? Ve.NOT_INSTALLED_WITH_PROVIDE : Ve.UNEXPECTED_ERROR);
  return t;
}
function vu(e, t) {
  return bs(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function _u(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function xr(e, t, n = !1) {
  let s = null;
  const o = t.root;
  let r = xu(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      s = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(r);
      i != null && (s = i.__composer, n && s && !s[Oa] && (s = null));
    }
    if (s != null || o === r)
      break;
    r = r.parent;
  }
  return s;
}
function xu(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Eu(e, t, n) {
  let s = null;
  Mt(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, s = ra();
      const o = n;
      o[$n] && o[$n](s), s.on("*", as);
    }
  }, t), Qr(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && (s && s.off("*", as), o[In] && o[In](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = o[dn];
    r && (r(), delete o[dn]);
  }, t);
}
Ue({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vo);
cu();
Hc(_c);
jc(Bc);
qc(zs);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Gt();
  e.__INTLIFY__ = !0, xc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function ku(e) {
  const t = G([]), n = G(!1), s = G(null);
  return { items: t, loading: n, error: s, load: async () => {
    n.value = !0, s.value = null;
    try {
      t.value = await e.getMenu();
    } catch (a) {
      s.value = a.message || "Unknown error";
    } finally {
      n.value = !1;
    }
  }, addItems: async (a) => {
    if (!e.createMenuItems)
      throw new Error("createMenuItems API not implemented");
    n.value = !0, s.value = null;
    try {
      const i = await e.createMenuItems(a);
      t.value.push(...i), t.value.sort((l, c) => l.order - c.order);
    } catch (i) {
      s.value = i.message || "Unknown error";
    } finally {
      n.value = !1;
    }
  } };
}
const Cu = (e) => {
  if (!e.trim()) return { payload: [], error: !1 };
  const t = e.split(`
`).map((o) => o.trim()).filter((o) => o), n = /* @__PURE__ */ new Map();
  let s = !1;
  return t.forEach((o, r) => {
    const a = o.split(",").map((h) => h.trim());
    if (a.length !== 3 || Number.isNaN(Number(a[1]))) {
      s = !0;
      return;
    }
    const i = a[0], l = a[1], c = a[2];
    n.has(i) || n.set(i, { name: i, price: l, description: c, order: r + 1 });
  }), {
    payload: Array.from(n.values()),
    error: s
  };
}, Tu = (e, t, n) => `
    <div class="text-left space-y-4">
      <div class="p-3.5 border-none rounded-2xl bg-gray-100 shadow-inner">
        <p class="text-xs font-bold text-gray-700/70 mb-1 uppercase tracking-wider">
          ${n("order.selectedOrders")}: ${e}
        </p>
        <p class="text-3xl font-black text-blue-700">$${t}</p>
      </div>

      <div class="grid gap-3 text-left">
        <div>
          <label for="checkout-carrier-num" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            手機條碼
          </label>
          <input id="checkout-carrier-num" type="text" maxlength="8" placeholder="/ABC1234" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm font-mono" />
        </div>

        <div>
          <label for="checkout-customer-identifier" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            統一編號
          </label>
          <input id="checkout-customer-identifier" type="text" inputmode="numeric" maxlength="8" placeholder="8 碼統一編號" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm font-mono" />
        </div>

        <div>
          <label for="checkout-customer-name" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            公司全名
          </label>
          <input id="checkout-customer-name" type="text" placeholder="公司全名" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm" />
        </div>

        <div>
          <label for="checkout-customer-email" class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
            Email
          </label>
          <input id="checkout-customer-email" type="email" placeholder="name@example.com" 
            class="swal2-input !m-0 !w-full !h-auto !px-4 !py-3 !rounded-xl !border !border-gray-200 !shadow-none !text-sm" />
        </div>
      </div>
    </div>
  `;
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function $a(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Ou(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Er(e, t) {
  return e.get($a(e, t));
}
function Au(e, t, n) {
  Ou(e, t), t.set(e, n);
}
function Su(e, t, n) {
  return e.set($a(e, t), n), n;
}
const Nu = 100, X = {}, Lu = () => {
  X.previousActiveElement instanceof HTMLElement ? (X.previousActiveElement.focus(), X.previousActiveElement = null) : document.body && document.body.focus();
}, $u = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, s = window.scrollY;
  X.restoreFocusTimeout = setTimeout(() => {
    Lu(), t();
  }, Nu), window.scrollTo(n, s);
}), Ia = "swal2-", Iu = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], S = Iu.reduce(
  (e, t) => (e[t] = Ia + t, e),
  /** @type {SwalClasses} */
  {}
), Pu = ["success", "warning", "info", "question", "error"], is = Pu.reduce(
  (e, t) => (e[t] = Ia + t, e),
  /** @type {SwalIcons} */
  {}
), Pa = "SweetAlert2:", _o = (e) => e.charAt(0).toUpperCase() + e.slice(1), nt = (e) => {
  console.warn(`${Pa} ${typeof e == "object" ? e.join(" ") : e}`);
}, nn = (e) => {
  console.error(`${Pa} ${e}`);
}, kr = [], Du = (e) => {
  kr.includes(e) || (kr.push(e), nt(e));
}, Da = (e, t = null) => {
  Du(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, vs = (e) => typeof e == "function" ? e() : e, xo = (e) => e && typeof e.toPromise == "function", Dn = (e) => xo(e) ? e.toPromise() : Promise.resolve(e), Eo = (e) => e && Promise.resolve(e) === e, Ru = () => navigator.userAgent.includes("Firefox"), st = () => document.body.querySelector(`.${S.container}`), Rn = (e) => {
  const t = st();
  return t ? t.querySelector(e) : null;
}, dt = (e) => Rn(`.${e}`), pe = () => dt(S.popup), vn = () => dt(S.icon), Mu = () => dt(S["icon-content"]), Ra = () => dt(S.title), ko = () => dt(S["html-container"]), Ma = () => dt(S.image), Co = () => dt(S["progress-steps"]), _s = () => dt(S["validation-message"]), At = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${S.actions} .${S.confirm}`)
), _n = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${S.actions} .${S.cancel}`)
), sn = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${S.actions} .${S.deny}`)
), Bu = () => dt(S["input-label"]), xn = () => Rn(`.${S.loader}`), Mn = () => dt(S.actions), Ba = () => dt(S.footer), xs = () => dt(S["timer-progress-bar"]), To = () => dt(S.close), Fu = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Oo = () => {
  const e = pe();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const i = parseInt(r.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), s = e.querySelectorAll(Fu), o = Array.from(s).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(o))].filter((r) => rt(r));
}, Ao = () => Pt(document.body, S.shown) && !Pt(document.body, S["toast-shown"]) && !Pt(document.body, S["no-backdrop"]), Es = () => {
  const e = pe();
  return e ? Pt(e, S.toast) : !1;
}, Uu = () => {
  const e = pe();
  return e ? e.hasAttribute("data-loading") : !1;
}, ft = (e, t) => {
  if (e.textContent = "", t) {
    const s = new DOMParser().parseFromString(t, "text/html"), o = s.querySelector("head");
    o && Array.from(o.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = s.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, Pt = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, Vu = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(S).includes(n) && !Object.values(is).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, ut = (e, t, n) => {
  if (Vu(e, t), !t.customClass)
    return;
  const s = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (s) {
    if (typeof s != "string" && !s.forEach) {
      nt(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof s}"`);
      return;
    }
    he(e, s);
  }
}, ks = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${S.popup} > .${S[t]}`);
    case "checkbox":
      return e.querySelector(`.${S.popup} > .${S.checkbox} input`);
    case "radio":
      return e.querySelector(`.${S.popup} > .${S.radio} input:checked`) || e.querySelector(`.${S.popup} > .${S.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${S.popup} > .${S.range} input`);
    default:
      return e.querySelector(`.${S.popup} > .${S.input}`);
  }
}, Fa = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ua = (e, t, n) => {
  if (!e || !t)
    return;
  const s = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((r) => {
    s.forEach((a) => {
      n ? r.classList.add(a) : r.classList.remove(a);
    });
  });
}, he = (e, t) => {
  Ua(e, t, !0);
}, bt = (e, t) => {
  Ua(e, t, !1);
}, Ft = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && Pt(n, t))
), Xt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, We = (e, t = "flex") => {
  e && (e.style.display = t);
}, Ze = (e) => {
  e && (e.style.display = "none");
}, So = (e, t = "block") => {
  e && new MutationObserver(() => {
    Bn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Cr = (e, t, n, s) => {
  const o = e.querySelector(t);
  o && o.style.setProperty(n, s);
}, Bn = (e, t, n = "flex") => {
  t ? We(e, n) : Ze(e);
}, rt = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Hu = () => !rt(At()) && !rt(sn()) && !rt(_n()), Qs = (e) => e.scrollHeight > e.clientHeight, ju = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (Qs(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Va = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), s = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || s > 0;
}, No = (e, t = !1) => {
  const n = xs();
  n && rt(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, qu = () => {
  const e = xs();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), s = t / n * 100;
  e.style.width = `${s}%`;
}, Wu = () => typeof window > "u" || typeof document > "u", zu = `
 <div aria-labelledby="${S.title}" aria-describedby="${S["html-container"]}" class="${S.popup}" tabindex="-1">
   <button type="button" class="${S.close}"></button>
   <ul class="${S["progress-steps"]}"></ul>
   <div class="${S.icon}"></div>
   <img class="${S.image}" />
   <h2 class="${S.title}" id="${S.title}"></h2>
   <div class="${S["html-container"]}" id="${S["html-container"]}"></div>
   <input class="${S.input}" id="${S.input}" />
   <input type="file" class="${S.file}" />
   <div class="${S.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${S.select}" id="${S.select}"></select>
   <div class="${S.radio}"></div>
   <label class="${S.checkbox}">
     <input type="checkbox" id="${S.checkbox}" />
     <span class="${S.label}"></span>
   </label>
   <textarea class="${S.textarea}" id="${S.textarea}"></textarea>
   <div class="${S["validation-message"]}" id="${S["validation-message"]}"></div>
   <div class="${S.actions}">
     <div class="${S.loader}"></div>
     <button type="button" class="${S.confirm}"></button>
     <button type="button" class="${S.deny}"></button>
     <button type="button" class="${S.cancel}"></button>
   </div>
   <div class="${S.footer}"></div>
   <div class="${S["timer-progress-bar-container"]}">
     <div class="${S["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Yu = () => {
  const e = st();
  return e ? (e.remove(), bt([document.documentElement, document.body], [
    S["no-backdrop"],
    S["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    S["has-column"]
  ]), !0) : !1;
}, Yt = () => {
  X.currentInstance && X.currentInstance.resetValidationMessage();
}, Gu = () => {
  const e = pe();
  if (!e)
    return;
  const t = Ft(e, S.input), n = Ft(e, S.file), s = e.querySelector(`.${S.range} input`), o = e.querySelector(`.${S.range} output`), r = Ft(e, S.select), a = e.querySelector(`.${S.checkbox} input`), i = Ft(e, S.textarea);
  t && (t.oninput = Yt), n && (n.onchange = Yt), r && (r.onchange = Yt), a && (a.onchange = Yt), i && (i.oninput = Yt), s && o && (s.oninput = () => {
    Yt(), o.value = s.value;
  }, s.onchange = () => {
    Yt(), o.value = s.value;
  });
}, Ku = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Xu = (e) => {
  const t = pe();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Ju = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (he(st(), S.rtl), X.isRTL = !0);
}, Zu = (e) => {
  const t = Yu();
  if (Wu()) {
    nn("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = S.container, t && he(n, S["no-transition"]), ft(n, zu), n.dataset.swal2Theme = e.theme;
  const s = Ku(e.target || "body");
  s.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Xu(e), Ju(s), Gu();
}, Lo = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Qu(e, t) : e && ft(t, e);
}, Qu = (e, t) => {
  "jquery" in e ? ed(t, e) : ft(t, e.toString());
}, ed = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, td = (e, t) => {
  const n = Mn(), s = xn();
  !n || !s || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Ze(n) : We(n), ut(n, t, "actions"), nd(n, s, t), ft(s, t.loaderHtml || ""), ut(s, t, "loader"));
};
function nd(e, t, n) {
  const s = At(), o = sn(), r = _n();
  !s || !o || !r || (Ms(s, "confirm", n), Ms(o, "deny", n), Ms(r, "cancel", n), sd(s, o, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, s), e.insertBefore(o, s)) : (e.insertBefore(r, t), e.insertBefore(o, t), e.insertBefore(s, t))));
}
function sd(e, t, n, s) {
  if (!s.buttonsStyling) {
    bt([e, t, n], S.styled);
    return;
  }
  he([e, t, n], S.styled), [[e, "confirm", s.confirmButtonColor], [t, "deny", s.denyButtonColor], [n, "cancel", s.cancelButtonColor]].forEach(([r, a, i]) => {
    i && r.style.setProperty(`--swal2-${a}-button-background-color`, i), od(r);
  });
}
function od(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Ms(e, t, n) {
  const s = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    _o(t)
  );
  Bn(e, n[`show${s}Button`], "inline-block"), ft(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = S[t], ut(e, n, `${t}Button`);
}
const rd = (e, t) => {
  const n = To();
  n && (ft(n, t.closeButtonHtml || ""), ut(n, t, "closeButton"), Bn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, ad = (e, t) => {
  const n = st();
  n && (id(n, t.backdrop), ld(n, t.position), cd(n, t.grow), ut(n, t, "container"));
};
function id(e, t) {
  typeof t == "string" ? e.style.background = t : t || he([document.documentElement, document.body], S["no-backdrop"]);
}
function ld(e, t) {
  t && (t in S ? he(e, S[t]) : (nt('The "position" parameter is not valid, defaulting to "center"'), he(e, S.center)));
}
function cd(e, t) {
  t && he(e, S[`grow-${t}`]);
}
var ye = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const ud = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], dd = (e, t) => {
  const n = pe();
  if (!n)
    return;
  const s = ye.innerParams.get(e), o = !s || t.input !== s.input;
  ud.forEach((r) => {
    const a = Ft(n, S[r]);
    a && (hd(r, t.inputAttributes), a.className = S[r], o && Ze(a));
  }), t.input && (o && fd(t), pd(t));
}, fd = (e) => {
  if (!e.input)
    return;
  if (!$e[e.input]) {
    nn(`Unexpected type of input! Expected ${Object.keys($e).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Ha(e.input);
  if (!t)
    return;
  const n = $e[e.input](t, e);
  We(t), e.inputAutoFocus && setTimeout(() => {
    Fa(n);
  });
}, md = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, hd = (e, t) => {
  const n = pe();
  if (!n)
    return;
  const s = ks(n, e);
  if (s) {
    md(s);
    for (const o in t)
      s.setAttribute(o, t[o]);
  }
}, pd = (e) => {
  if (!e.input)
    return;
  const t = Ha(e.input);
  t && ut(t, e, "input");
}, $o = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Fn = (e, t, n) => {
  if (n.inputLabel) {
    const s = document.createElement("label"), o = S["input-label"];
    s.setAttribute("for", e.id), s.className = o, typeof n.customClass == "object" && he(s, n.customClass.inputLabel), s.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", s);
  }
}, Ha = (e) => {
  const t = pe();
  if (t)
    return Ft(t, S[
      /** @type {SwalClass} */
      e
    ] || S.input);
}, ls = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Eo(t) || nt(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, $e = {};
$e.text = $e.email = $e.password = $e.number = $e.tel = $e.url = $e.search = $e.date = $e["datetime-local"] = $e.time = $e.week = $e.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return ls(n, t.inputValue), Fn(n, n, t), $o(n, t), n.type = /** @type {string} */
  t.input, n;
};
$e.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Fn(n, n, t), $o(n, t), n;
};
$e.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), s = n.querySelector("input"), o = n.querySelector("output");
  return s && (ls(s, t.inputValue), s.type = /** @type {string} */
  t.input, Fn(
    s,
    /** @type {Input} */
    e,
    t
  )), o && ls(o, t.inputValue), /** @type {Input} */
  e;
};
$e.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const s = document.createElement("option");
    ft(s, t.inputPlaceholder), s.value = "", s.disabled = !0, s.selected = !0, n.appendChild(s);
  }
  return Fn(n, n, t), n;
};
$e.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
$e.checkbox = (e, t) => {
  const n = pe();
  if (!n)
    throw new Error("Popup not found");
  const s = ks(n, "checkbox");
  if (!s)
    throw new Error("Checkbox input not found");
  s.value = "1", s.checked = !!t.inputValue;
  const r = /** @type {HTMLElement} */ e.querySelector("span");
  if (r) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && ft(r, a);
  }
  return s;
};
$e.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  ls(n, t.inputValue), $o(n, t), Fn(n, n, t);
  const s = (o) => parseInt(window.getComputedStyle(o).marginLeft) + parseInt(window.getComputedStyle(o).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const o = pe();
      if (!o)
        return;
      const r = parseInt(window.getComputedStyle(o).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + s(n), l = pe();
        l && (i > r ? l.style.width = `${i}px` : Xt(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const gd = (e, t) => {
  const n = ko();
  n && (So(n), ut(n, t, "htmlContainer"), t.html ? (Lo(t.html, n), We(n, "block")) : t.text ? (n.textContent = t.text, We(n, "block")) : Ze(n), dd(e, t));
}, bd = (e, t) => {
  const n = Ba();
  n && (So(n), Bn(n, !!t.footer, "block"), t.footer && Lo(t.footer, n), ut(n, t, "footer"));
}, wd = (e, t) => {
  const n = ye.innerParams.get(e), s = vn();
  if (!s)
    return;
  if (n && t.icon === n.icon) {
    Or(s, t), Tr(s, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Ze(s);
    return;
  }
  if (t.icon && Object.keys(is).indexOf(t.icon) === -1) {
    nn(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Ze(s);
    return;
  }
  We(s), Or(s, t), Tr(s, t), he(s, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ja);
}, Tr = (e, t) => {
  for (const [n, s] of Object.entries(is))
    t.icon !== n && bt(e, s);
  he(e, t.icon && is[t.icon]), _d(e, t), ja(), ut(e, t, "icon");
}, ja = () => {
  const e = pe();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((s) => {
    s.style.backgroundColor = t;
  });
}, yd = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, vd = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Or = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, s = "";
  t.iconHtml ? s = Ar(t.iconHtml) : t.icon === "success" ? (s = yd(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? s = vd : t.icon && (s = Ar({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== s.trim() && ft(e, s);
}, _d = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Cr(e, n, "background-color", t.iconColor);
    Cr(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Ar = (e) => `<div class="${S["icon-content"]}">${e}</div>`, xd = (e, t) => {
  const n = Ma();
  if (n) {
    if (!t.imageUrl) {
      Ze(n);
      return;
    }
    We(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Xt(n, "width", t.imageWidth), Xt(n, "height", t.imageHeight), n.className = S.image, ut(n, t, "image");
  }
};
let Io = !1, qa = 0, Wa = 0, za = 0, Ya = 0;
const Ed = (e) => {
  e.addEventListener("mousedown", cs), document.body.addEventListener("mousemove", us), e.addEventListener("mouseup", ds), e.addEventListener("touchstart", cs), document.body.addEventListener("touchmove", us), e.addEventListener("touchend", ds);
}, kd = (e) => {
  e.removeEventListener("mousedown", cs), document.body.removeEventListener("mousemove", us), e.removeEventListener("mouseup", ds), e.removeEventListener("touchstart", cs), document.body.removeEventListener("touchmove", us), e.removeEventListener("touchend", ds);
}, cs = (e) => {
  const t = pe();
  if (!t)
    return;
  const n = vn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Io = !0;
    const s = Ga(e);
    qa = s.clientX, Wa = s.clientY, za = parseInt(t.style.insetInlineStart) || 0, Ya = parseInt(t.style.insetBlockStart) || 0, he(t, "swal2-dragging");
  }
}, us = (e) => {
  const t = pe();
  if (t && Io) {
    let {
      clientX: n,
      clientY: s
    } = Ga(e);
    const o = n - qa;
    t.style.insetInlineStart = `${za + (X.isRTL ? -o : o)}px`, t.style.insetBlockStart = `${Ya + (s - Wa)}px`;
  }
}, ds = () => {
  const e = pe();
  Io = !1, bt(e, "swal2-dragging");
}, Ga = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, Cd = (e, t) => {
  const n = st(), s = pe();
  if (!(!n || !s)) {
    if (t.toast) {
      Xt(n, "width", t.width), s.style.width = "100%";
      const o = xn();
      o && s.insertBefore(o, vn());
    } else
      Xt(s, "width", t.width);
    Xt(s, "padding", t.padding), t.color && (s.style.color = t.color), t.background && (s.style.background = t.background), Ze(_s()), Td(s, t), t.draggable && !t.toast ? (he(s, S.draggable), Ed(s)) : (bt(s, S.draggable), kd(s));
  }
}, Td = (e, t) => {
  const n = t.showClass || {};
  e.className = `${S.popup} ${rt(e) ? n.popup : ""}`, t.toast ? (he([document.documentElement, document.body], S["toast-shown"]), he(e, S.toast)) : he(e, S.modal), ut(e, t, "popup"), typeof t.customClass == "string" && he(e, t.customClass), t.icon && he(e, S[`icon-${t.icon}`]);
}, Od = (e, t) => {
  const n = Co();
  if (!n)
    return;
  const {
    progressSteps: s,
    currentProgressStep: o
  } = t;
  if (!s || s.length === 0 || o === void 0) {
    Ze(n);
    return;
  }
  We(n), n.textContent = "", o >= s.length && nt("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), s.forEach((r, a) => {
    const i = Ad(r);
    if (n.appendChild(i), a === o && he(i, S["active-progress-step"]), a !== s.length - 1) {
      const l = Sd(t);
      n.appendChild(l);
    }
  });
}, Ad = (e) => {
  const t = document.createElement("li");
  return he(t, S["progress-step"]), ft(t, e), t;
}, Sd = (e) => {
  const t = document.createElement("li");
  return he(t, S["progress-step-line"]), e.progressStepsDistance && Xt(t, "width", e.progressStepsDistance), t;
}, Nd = (e, t) => {
  const n = Ra();
  n && (So(n), Bn(n, !!(t.title || t.titleText), "block"), t.title && Lo(t.title, n), t.titleText && (n.innerText = t.titleText), ut(n, t, "title"));
}, Ka = (e, t) => {
  var n;
  Cd(e, t), ad(e, t), Od(e, t), wd(e, t), xd(e, t), Nd(e, t), rd(e, t), gd(e, t), td(e, t), bd(e, t);
  const s = pe();
  typeof t.didRender == "function" && s && t.didRender(s), (n = X.eventEmitter) === null || n === void 0 || n.emit("didRender", s);
}, Ld = () => rt(pe()), Xa = () => {
  var e;
  return (e = At()) === null || e === void 0 ? void 0 : e.click();
}, $d = () => {
  var e;
  return (e = sn()) === null || e === void 0 ? void 0 : e.click();
}, Id = () => {
  var e;
  return (e = _n()) === null || e === void 0 ? void 0 : e.click();
}, En = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Ja = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, Pd = (e, t, n) => {
  if (Ja(e), !t.toast) {
    const s = (r) => Rd(t, r, n);
    e.keydownHandler = s;
    const o = t.keydownListenerCapture ? window : pe();
    if (o) {
      e.keydownTarget = o, e.keydownListenerCapture = t.keydownListenerCapture;
      const r = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        s
      );
      e.keydownTarget.addEventListener("keydown", r, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, eo = (e, t) => {
  var n;
  const s = Oo();
  return s.length ? (e = e + t, e === -2 && (e = s.length - 1), e === s.length ? e = 0 : e === -1 && (e = s.length - 1), s[e].focus(), !(Ru() && s[e] instanceof HTMLIFrameElement)) : ((n = pe()) === null || n === void 0 || n.focus(), !0);
}, Za = ["ArrowRight", "ArrowDown"], Dd = ["ArrowLeft", "ArrowUp"], Rd = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Md(t, e) : t.key === "Tab" ? Bd(t) : [...Za, ...Dd].includes(t.key) ? Fd(t.key) : t.key === "Escape" && Ud(t, e, n)));
}, Md = (e, t) => {
  if (!vs(t.allowEnterKey))
    return;
  const n = pe();
  if (!n || !t.input)
    return;
  const s = ks(n, t.input);
  if (e.target && s && e.target instanceof HTMLElement && e.target.outerHTML === s.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Xa(), e.preventDefault();
  }
}, Bd = (e) => {
  const t = e.target, s = Oo().findIndex((r) => r === t);
  let o = !0;
  e.shiftKey ? o = eo(s, -1) : o = eo(s, 1), e.stopPropagation(), o && e.preventDefault();
}, Fd = (e) => {
  const t = Mn(), n = At(), s = sn(), o = _n();
  if (!t || !n || !s || !o)
    return;
  const r = [n, s, o];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = Za.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && rt(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Ud = (e, t, n) => {
  e.preventDefault(), vs(t.allowEscapeKey) && n(En.esc);
};
var gn = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Vd = () => {
  const e = st();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Qa = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Po = typeof window < "u" && !!window.GestureEvent, Hd = Po && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, jd = () => {
  if (Po && !Pt(document.body, S.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, he(document.body, S.iosfix), qd();
  }
}, qd = () => {
  const e = st();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Wd(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Wd = (e) => {
  const t = e.target, n = st(), s = ko();
  return !n || !s || zd(e) || Yd(e) ? !1 : t === n || !Qs(n) && t instanceof HTMLElement && !ju(t, s) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Qs(s) && // #1944
  s.contains(t));
}, zd = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), Yd = (e) => e.touches && e.touches.length > 1, Gd = () => {
  if (Pt(document.body, S.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    bt(document.body, S.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Kd = () => {
  const e = document.createElement("div");
  e.className = S["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let mn = null;
const Xd = (e) => {
  mn === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (mn = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${mn + Kd()}px`);
}, Jd = () => {
  mn !== null && (document.body.style.paddingRight = `${mn}px`, mn = null);
};
function ei(e, t, n, s) {
  Es() ? Sr(e, s) : ($u(n).then(() => Sr(e, s)), Ja(X)), Po ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Ao() && (Jd(), Gd(), Qa()), Zd();
}
function Zd() {
  bt([document.documentElement, document.body], [S.shown, S["height-auto"], S["no-backdrop"], S["toast-shown"]]);
}
function Ut(e) {
  e = ef(e);
  const t = gn.swalPromiseResolve.get(this), n = Qd(this);
  this.isAwaitingPromise ? e.isDismissed || (Un(this), t(e)) : n && t(e);
}
const Qd = (e) => {
  const t = pe();
  if (!t)
    return !1;
  const n = ye.innerParams.get(e);
  if (!n || Pt(t, n.hideClass.popup))
    return !1;
  bt(t, n.showClass.popup), he(t, n.hideClass.popup);
  const s = st();
  return bt(s, n.showClass.backdrop), he(s, n.hideClass.backdrop), tf(e, t, n), !0;
};
function ti(e) {
  const t = gn.swalPromiseReject.get(this);
  Un(this), t && t(e);
}
const Un = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ye.innerParams.get(e) || e._destroy());
}, ef = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), tf = (e, t, n) => {
  var s;
  const o = st(), r = Va(t);
  typeof n.willClose == "function" && n.willClose(t), (s = X.eventEmitter) === null || s === void 0 || s.emit("willClose", t), r && o ? nf(e, t, o, !!n.returnFocus, n.didClose) : o && ei(e, o, !!n.returnFocus, n.didClose);
}, nf = (e, t, n, s, o) => {
  X.swalCloseEventFinishedCallback = ei.bind(null, e, n, s, o);
  const r = function(a) {
    if (a.target === t) {
      var i;
      (i = X.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(X), delete X.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, Sr = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = X.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, bn = (e) => {
  let t = pe();
  if (t || new _e(), t = pe(), !t)
    return;
  const n = xn();
  Es() ? Ze(vn()) : sf(t, e), We(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, sf = (e, t) => {
  const n = Mn(), s = xn();
  !n || !s || (!t && rt(At()) && (t = At()), We(n), t && (Ze(t), s.setAttribute("data-button-to-replace", t.className), n.insertBefore(s, t)), he([e, n], S.loading));
}, of = (e, t) => {
  t.input === "select" || t.input === "radio" ? uf(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (xo(t.inputValue) || Eo(t.inputValue)) && (bn(At()), df(e, t));
}, rf = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return af(n);
    case "radio":
      return lf(n);
    case "file":
      return cf(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, af = (e) => e.checked ? 1 : 0, lf = (e) => e.checked ? e.value : null, cf = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, uf = (e, t) => {
  const n = pe();
  if (!n)
    return;
  const s = (o) => {
    t.input === "select" ? ff(n, to(o), t) : t.input === "radio" && mf(n, to(o), t);
  };
  xo(t.inputOptions) || Eo(t.inputOptions) ? (bn(At()), Dn(t.inputOptions).then((o) => {
    e.hideLoading(), s(o);
  })) : typeof t.inputOptions == "object" ? s(t.inputOptions) : nn(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, df = (e, t) => {
  const n = e.getInput();
  n && (Ze(n), Dn(t.inputValue).then((s) => {
    n.value = t.input === "number" ? `${parseFloat(s) || 0}` : `${s}`, We(n), n.focus(), e.hideLoading();
  }).catch((s) => {
    nn(`Error in inputValue promise: ${s}`), n.value = "", We(n), n.focus(), e.hideLoading();
  }));
};
function ff(e, t, n) {
  const s = Ft(e, S.select);
  if (!s)
    return;
  const o = (r, a, i) => {
    const l = document.createElement("option");
    l.value = i, ft(l, a), l.selected = ni(i, n.inputValue), r.appendChild(l);
  };
  t.forEach((r) => {
    const a = r[0], i = r[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, s.appendChild(l), i.forEach((c) => o(l, c[1], c[0]));
    } else
      o(s, i, a);
  }), s.focus();
}
function mf(e, t, n) {
  const s = Ft(e, S.radio);
  if (!s)
    return;
  t.forEach((r) => {
    const a = r[0], i = r[1], l = document.createElement("input"), c = document.createElement("label");
    l.type = "radio", l.name = S.radio, l.value = a, ni(a, n.inputValue) && (l.checked = !0);
    const h = document.createElement("span");
    ft(h, i), h.className = S.label, c.appendChild(l), c.appendChild(h), s.appendChild(c);
  });
  const o = s.querySelectorAll("input");
  o.length && o[0].focus();
}
const to = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, s]) => [n, typeof s == "object" ? to(s) : s]), ni = (e, t) => !!t && t != null && t.toString() === e.toString(), hf = (e) => {
  const t = ye.innerParams.get(e);
  e.disableButtons(), t.input ? si(e, "confirm") : Ro(e, !0);
}, pf = (e) => {
  const t = ye.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? si(e, "deny") : Do(e, !1);
}, gf = (e, t) => {
  e.disableButtons(), t(En.cancel);
}, si = (e, t) => {
  const n = ye.innerParams.get(e);
  if (!n.input) {
    nn(`The "input" parameter is needed to be set when using returnInputValueOn${_o(t)}`);
    return;
  }
  const s = e.getInput(), o = rf(e, n);
  n.inputValidator ? bf(e, o, t) : s && !s.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || s.validationMessage)) : t === "deny" ? Do(e, o) : Ro(e, o);
}, bf = (e, t, n) => {
  const s = ye.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Dn(s.inputValidator(t, s.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Do(e, t) : Ro(e, t);
  });
}, Do = (e, t) => {
  const n = ye.innerParams.get(e);
  n.showLoaderOnDeny && bn(sn()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Dn(n.preDeny(t, n.validationMessage))).then((o) => {
    o === !1 ? (e.hideLoading(), Un(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof o > "u" ? t : o
      }
    );
  }).catch((o) => oi(e, o))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Nr = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, oi = (e, t) => {
  e.rejectPromise(t);
}, Ro = (e, t) => {
  const n = ye.innerParams.get(e);
  n.showLoaderOnConfirm && bn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Dn(n.preConfirm(t, n.validationMessage))).then((o) => {
    rt(_s()) || o === !1 ? (e.hideLoading(), Un(e)) : Nr(e, typeof o > "u" ? t : o);
  }).catch((o) => oi(e, o))) : Nr(e, t);
};
function fs() {
  const e = ye.innerParams.get(this);
  if (!e)
    return;
  const t = ye.domCache.get(this);
  Ze(t.loader), Es() ? e.icon && We(vn()) : wf(t), bt([t.popup, t.actions], S.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const wf = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? We(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Hu() && Ze(e.actions);
};
function ri() {
  const e = ye.innerParams.get(this), t = ye.domCache.get(this);
  return t ? ks(t.popup, e.input) : null;
}
function ai(e, t, n) {
  const s = ye.domCache.get(e);
  t.forEach((o) => {
    s[o].disabled = n;
  });
}
function ii(e, t) {
  const n = pe();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${S.radio}"]`).forEach((o) => {
    o.disabled = t;
  }) : e.disabled = t);
}
function li() {
  ai(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = ye.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), ye.focusedElement.delete(this);
}
function ci() {
  ye.focusedElement.set(this, document.activeElement), ai(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function ui() {
  ii(this.getInput(), !1);
}
function di() {
  ii(this.getInput(), !0);
}
function fi(e) {
  const t = ye.domCache.get(this), n = ye.innerParams.get(this);
  ft(t.validationMessage, e), t.validationMessage.className = S["validation-message"], n.customClass && n.customClass.validationMessage && he(t.validationMessage, n.customClass.validationMessage), We(t.validationMessage);
  const s = this.getInput();
  s && (s.setAttribute("aria-invalid", "true"), s.setAttribute("aria-describedby", S["validation-message"]), Fa(s), he(s, S.inputerror));
}
function mi() {
  const e = ye.domCache.get(this);
  e.validationMessage && Ze(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), bt(t, S.inputerror));
}
const Vt = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, yf = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], vf = {
  allowEnterKey: void 0
}, _f = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], hi = (e) => Object.prototype.hasOwnProperty.call(Vt, e), pi = (e) => yf.indexOf(e) !== -1, gi = (e) => vf[e], xf = (e) => {
  hi(e) || nt(`Unknown parameter "${e}"`);
}, Ef = (e) => {
  _f.includes(e) && nt(`The parameter "${e}" is incompatible with toasts`);
}, kf = (e) => {
  const t = gi(e);
  t && Da(e, t);
}, bi = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && nt('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && nt(`Invalid theme "${e.theme}"`);
  for (const t in e)
    xf(t), e.toast && Ef(t), kf(t);
};
function wi(e) {
  const t = st(), n = pe(), s = ye.innerParams.get(this);
  if (!n || Pt(n, s.hideClass.popup)) {
    nt("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const o = Cf(e), r = Object.assign({}, s, o);
  bi(r), t && (t.dataset.swal2Theme = r.theme), Ka(this, r), ye.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Cf = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (pi(n)) {
      const s = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = s[n];
    } else
      nt(`Invalid parameter to update: ${n}`);
  }), t;
};
function yi() {
  var e;
  const t = ye.domCache.get(this), n = ye.innerParams.get(this);
  if (!n) {
    vi(this);
    return;
  }
  t.popup && X.swalCloseEventFinishedCallback && (X.swalCloseEventFinishedCallback(), delete X.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = X.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Tf(this);
}
const Tf = (e) => {
  vi(e), delete e.params, delete X.keydownHandler, delete X.keydownTarget, delete X.currentInstance;
}, vi = (e) => {
  e.isAwaitingPromise ? (Bs(ye, e), e.isAwaitingPromise = !0) : (Bs(gn, e), Bs(ye, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Bs = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var Of = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: yi,
  close: Ut,
  closeModal: Ut,
  closePopup: Ut,
  closeToast: Ut,
  disableButtons: ci,
  disableInput: di,
  disableLoading: fs,
  enableButtons: li,
  enableInput: ui,
  getInput: ri,
  handleAwaitingPromise: Un,
  hideLoading: fs,
  rejectPromise: ti,
  resetValidationMessage: mi,
  showValidationMessage: fi,
  update: wi
});
const Af = (e, t, n) => {
  e.toast ? Sf(e, t, n) : (Lf(t), $f(t), If(e, t, n));
}, Sf = (e, t, n) => {
  t.popup.onclick = () => {
    e && (Nf(e) || e.timer || e.input) || n(En.close);
  };
}, Nf = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let ms = !1;
const Lf = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (ms = !0);
    };
  };
}, $f = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (ms = !0);
    };
  };
}, If = (e, t, n) => {
  t.container.onclick = (s) => {
    if (ms) {
      ms = !1;
      return;
    }
    s.target === t.container && vs(e.allowOutsideClick) && n(En.backdrop);
  };
}, Pf = (e) => typeof e == "object" && e !== null && "jquery" in e, Lr = (e) => e instanceof Element || Pf(e), Df = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Lr(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, s) => {
    const o = e[s];
    typeof o == "string" || Lr(o) ? t[n] = o : o !== void 0 && nn(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof o}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function Rf(...e) {
  return new this(...e);
}
function Mf(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(s, o) {
      return super._main(s, Object.assign({}, e, o));
    }
  }
  return t;
}
const Bf = () => X.timeout && X.timeout.getTimerLeft(), _i = () => {
  if (X.timeout)
    return qu(), X.timeout.stop();
}, xi = () => {
  if (X.timeout) {
    const e = X.timeout.start();
    return No(e), e;
  }
}, Ff = () => {
  const e = X.timeout;
  return e && (e.running ? _i() : xi());
}, Uf = (e) => {
  if (X.timeout) {
    const t = X.timeout.increase(e);
    return No(t, !0), t;
  }
}, Vf = () => !!(X.timeout && X.timeout.isRunning());
let $r = !1;
const no = {};
function Hf(e = "data-swal-template") {
  no[e] = this, $r || (document.body.addEventListener("click", jf), $r = !0);
}
const jf = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in no) {
      const s = t.getAttribute && t.getAttribute(n);
      if (s) {
        no[n].fire({
          template: s
        });
        return;
      }
    }
};
class qf {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const s = this._getHandlersByEventName(t);
    s.includes(n) || s.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const s = (...o) => {
      this.removeListener(t, s), n.apply(this, o);
    };
    this.on(t, s);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (s) => {
        try {
          s.apply(this, n);
        } catch (o) {
          console.error(o);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const s = this._getHandlersByEventName(t), o = s.indexOf(n);
    o > -1 && s.splice(o, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
X.eventEmitter = new qf();
const Wf = (e, t) => {
  X.eventEmitter && X.eventEmitter.on(e, t);
}, zf = (e, t) => {
  X.eventEmitter && X.eventEmitter.once(e, t);
}, Yf = (e, t) => {
  if (X.eventEmitter) {
    if (!e) {
      X.eventEmitter.reset();
      return;
    }
    t ? X.eventEmitter.removeListener(e, t) : X.eventEmitter.removeAllListeners(e);
  }
};
var Gf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Df,
  bindClickHandler: Hf,
  clickCancel: Id,
  clickConfirm: Xa,
  clickDeny: $d,
  enableLoading: bn,
  fire: Rf,
  getActions: Mn,
  getCancelButton: _n,
  getCloseButton: To,
  getConfirmButton: At,
  getContainer: st,
  getDenyButton: sn,
  getFocusableElements: Oo,
  getFooter: Ba,
  getHtmlContainer: ko,
  getIcon: vn,
  getIconContent: Mu,
  getImage: Ma,
  getInputLabel: Bu,
  getLoader: xn,
  getPopup: pe,
  getProgressSteps: Co,
  getTimerLeft: Bf,
  getTimerProgressBar: xs,
  getTitle: Ra,
  getValidationMessage: _s,
  increaseTimer: Uf,
  isDeprecatedParameter: gi,
  isLoading: Uu,
  isTimerRunning: Vf,
  isUpdatableParameter: pi,
  isValidParameter: hi,
  isVisible: Ld,
  mixin: Mf,
  off: Yf,
  on: Wf,
  once: zf,
  resumeTimer: xi,
  showLoading: bn,
  stopTimer: _i,
  toggleTimer: Ff
});
class Kf {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Ei = ["swal-title", "swal-html", "swal-footer"], Xf = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return om(n), Object.assign(Jf(n), Zf(n), Qf(n), em(n), tm(n), nm(n), sm(n, Ei));
}, Jf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((s) => {
    Qt(s, ["name", "value"]);
    const o = (
      /** @type {keyof SweetAlertOptions} */
      s.getAttribute("name")
    ), r = s.getAttribute("value");
    !o || !r || (o in Vt && typeof Vt[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "boolean" ? t[o] = r !== "false" : o in Vt && typeof Vt[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "object" ? t[o] = JSON.parse(r) : t[o] = r);
  }), t;
}, Zf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((s) => {
    const o = (
      /** @type {keyof SweetAlertOptions} */
      s.getAttribute("name")
    ), r = s.getAttribute("value");
    !o || !r || (t[o] = new Function(`return ${r}`)());
  }), t;
}, Qf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((s) => {
    Qt(s, ["type", "color", "aria-label"]);
    const o = s.getAttribute("type");
    if (!o || !["confirm", "cancel", "deny"].includes(o))
      return;
    t[`${o}ButtonText`] = s.innerHTML, t[`show${_o(o)}Button`] = !0;
    const r = s.getAttribute("color");
    r !== null && (t[`${o}ButtonColor`] = r);
    const a = s.getAttribute("aria-label");
    a !== null && (t[`${o}ButtonAriaLabel`] = a);
  }), t;
}, em = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    Qt(n, ["src", "width", "height", "alt"]);
    const s = n.getAttribute("src");
    s !== null && (t.imageUrl = s || void 0);
    const o = n.getAttribute("width");
    o !== null && (t.imageWidth = o || void 0);
    const r = n.getAttribute("height");
    r !== null && (t.imageHeight = r || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, tm = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Qt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, nm = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Qt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const s = Array.from(e.querySelectorAll("swal-input-option"));
  return s.length && (t.inputOptions = {}, s.forEach((o) => {
    Qt(o, ["value"]);
    const r = o.getAttribute("value");
    if (!r)
      return;
    const a = o.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, sm = (e, t) => {
  const n = {};
  for (const s in t) {
    const o = t[s], r = e.querySelector(o);
    r && (Qt(r, []), n[o.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, om = (e) => {
  const t = Ei.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const s = n.tagName.toLowerCase();
    t.includes(s) || nt(`Unrecognized element <${s}>`);
  });
}, Qt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && nt([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, ki = 10, rm = (e) => {
  var t, n;
  const s = st(), o = pe();
  if (!s || !o)
    return;
  typeof e.willOpen == "function" && e.willOpen(o), (t = X.eventEmitter) === null || t === void 0 || t.emit("willOpen", o);
  const a = window.getComputedStyle(document.body).overflowY;
  if (lm(s, o, e), setTimeout(() => {
    am(s, o);
  }, ki), Ao() && (im(s, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), Vd()), Hd && e.backdrop === !1 && o.scrollHeight > s.clientHeight && (s.style.pointerEvents = "auto"), !Es() && !X.previousActiveElement && (X.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const i = e.didOpen;
    setTimeout(() => i(o));
  }
  (n = X.eventEmitter) === null || n === void 0 || n.emit("didOpen", o);
}, hs = (e) => {
  const t = pe();
  if (!t || e.target !== t)
    return;
  const n = st();
  n && (t.removeEventListener("animationend", hs), t.removeEventListener("transitionend", hs), n.style.overflowY = "auto", bt(n, S["no-transition"]));
}, am = (e, t) => {
  Va(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", hs), t.addEventListener("transitionend", hs)) : e.style.overflowY = "auto";
}, im = (e, t, n) => {
  jd(), t && n !== "hidden" && Xd(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, lm = (e, t, n) => {
  var s;
  (s = n.showClass) !== null && s !== void 0 && s.backdrop && he(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), We(t, "grid"), setTimeout(() => {
    var o;
    (o = n.showClass) !== null && o !== void 0 && o.popup && he(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, ki)) : We(t, "grid"), he([document.documentElement, document.body], S.shown), n.heightAuto && n.backdrop && !n.toast && he([document.documentElement, document.body], S["height-auto"]);
};
var Ir = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function cm(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Ir.email), e.input === "url" && (e.inputValidator = Ir.url));
}
function um(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (nt('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function dm(e) {
  cm(e), e.showLoaderOnConfirm && !e.preConfirm && nt(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), um(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Zu(e);
}
let kt;
var Xn = /* @__PURE__ */ new WeakMap();
class Re {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Au(
      this,
      Xn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    kt = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Su(Xn, this, this._main(kt.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (bi(Object.assign({}, n, t)), X.currentInstance) {
      const r = gn.swalPromiseResolve.get(X.currentInstance), {
        isAwaitingPromise: a
      } = X.currentInstance;
      X.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), Ao() && Qa();
    }
    X.currentInstance = kt;
    const s = mm(t, n);
    dm(s), Object.freeze(s), X.timeout && (X.timeout.stop(), delete X.timeout), clearTimeout(X.restoreFocusTimeout);
    const o = hm(kt);
    return Ka(kt, s), ye.innerParams.set(kt, s), fm(kt, o, s);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return Er(Xn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Er(Xn, this).finally(t);
  }
}
const fm = (e, t, n) => new Promise((s, o) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  gn.swalPromiseResolve.set(e, s), gn.swalPromiseReject.set(e, o), t.confirmButton.onclick = () => {
    hf(e);
  }, t.denyButton.onclick = () => {
    pf(e);
  }, t.cancelButton.onclick = () => {
    gf(e, r);
  }, t.closeButton.onclick = () => {
    r(En.close);
  }, Af(n, t, r), Pd(X, n, r), of(e, n), rm(n), pm(X, n, r), gm(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), mm = (e, t) => {
  const n = Xf(e), s = Object.assign({}, Vt, t, n, e);
  return s.showClass = Object.assign({}, Vt.showClass, s.showClass), s.hideClass = Object.assign({}, Vt.hideClass, s.hideClass), s.animation === !1 && (s.showClass = {
    backdrop: "swal2-noanimation"
  }, s.hideClass = {}), s;
}, hm = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        pe()
      ),
      container: (
        /** @type {HTMLElement} */
        st()
      ),
      actions: (
        /** @type {HTMLElement} */
        Mn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        At()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        sn()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        _n()
      ),
      loader: (
        /** @type {HTMLElement} */
        xn()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        To()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        _s()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Co()
      )
    }
  );
  return ye.domCache.set(e, t), t;
}, pm = (e, t, n) => {
  const s = xs();
  Ze(s), t.timer && (e.timeout = new Kf(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && s && (We(s), ut(s, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && No(
      /** @type {number} */
      t.timer
    );
  })));
}, gm = (e, t) => {
  if (!t.toast) {
    if (!vs(t.allowEnterKey)) {
      Da("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    bm(e) || wm(e, t) || eo(-1, 1);
  }
}, bm = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && rt(n))
      return n.focus(), !0;
  return !1;
}, wm = (e, t) => t.focusDeny && rt(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && rt(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && rt(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
Re.prototype.disableButtons = ci;
Re.prototype.enableButtons = li;
Re.prototype.getInput = ri;
Re.prototype.disableInput = di;
Re.prototype.enableInput = ui;
Re.prototype.hideLoading = fs;
Re.prototype.disableLoading = fs;
Re.prototype.showValidationMessage = fi;
Re.prototype.resetValidationMessage = mi;
Re.prototype.close = Ut;
Re.prototype.closePopup = Ut;
Re.prototype.closeModal = Ut;
Re.prototype.closeToast = Ut;
Re.prototype.rejectPromise = ti;
Re.prototype.update = wi;
Re.prototype._destroy = yi;
Object.assign(Re, Gf);
Object.keys(Of).forEach((e) => {
  Re[e] = function(...t) {
    if (kt && kt[e])
      return kt[e](...t);
  };
});
Re.DismissReason = En;
Re.version = "11.26.25";
const _e = Re;
_e.default = _e;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const ym = { class: "menu-lib-container" }, vm = { class: "lib-header" }, _m = { class: "lib-title" }, xm = {
  key: 0,
  class: "lib-status-loading"
}, Em = {
  key: 1,
  class: "lib-status-error"
}, km = { class: "lib-label" }, Cm = { class: "lib-label-text" }, Tm = { class: "lib-instruction-box" }, Om = { class: "whitespace-pre-line" }, Am = { class: "text-accent" }, Sm = ["placeholder"], Nm = ["disabled"], Lm = { class: "lib-grid" }, $m = { class: "card-body" }, Im = { class: "card-title" }, Pm = { class: "card-footer" }, Dm = { class: "price-tag" }, Rm = { class: "price-tag" }, Mm = { class: "order-tag" }, Bm = { class: "lib-footer-actions" }, Fm = /* @__PURE__ */ Ee({
  __name: "MenuEditorPage",
  props: {
    api: {},
    items: {}
  },
  emits: ["refresh"],
  setup(e, { emit: t }) {
    const { t: n } = St(), s = e, o = t, { items: r, loading: a, error: i, load: l, addItems: c } = ku(s.api), h = G("");
    vt(r, (g) => {
      h.value || (h.value = [...g].sort((_, f) => _.order - f.order).map((_) => `${_.name},${_.price},${_.description}`).join(`
`));
    }, { immediate: !0 });
    const m = me(() => [...r.value].sort((g, _) => g.order - _.order));
    Mt(() => {
      l();
    });
    const p = async () => {
      const { payload: g, error: _ } = Cu(h.value);
      if (_) {
        _e.fire({
          icon: "error",
          title: n("menu.invalidFormatTitle"),
          text: n("menu.invalidFormatText"),
          confirmButtonColor: "#2563eb"
        });
        return;
      }
      if (g.length !== 0)
        try {
          a.value = !0, await c(g), await _e.fire({
            title: n("menu.saveSuccessTitle"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), h.value = "", o("refresh"), l();
        } catch (f) {
          console.error(f);
        } finally {
          a.value = !1;
        }
    };
    return (g, _) => (L(), I("section", ym, [
      d("header", vm, [
        d("h1", _m, O(k(n)("menu.editorTitle")), 1)
      ]),
      k(a) ? (L(), I("div", xm, O(k(n)("common.loading")), 1)) : k(i) ? (L(), I("div", Em, O(k(i)), 1)) : Z("", !0),
      d("form", {
        onSubmit: ea(p, ["prevent"]),
        class: "lib-form"
      }, [
        d("label", km, [
          d("span", Cm, O(k(n)("menu.inputLabel")), 1),
          d("div", Tm, [
            et(O(k(n)("menu.formatInstruction")), 1),
            _[2] || (_[2] = d("br", null, null, -1)),
            et(" " + O(k(n)("menu.exampleTitle")), 1),
            _[3] || (_[3] = d("br", null, null, -1)),
            d("div", Om, O(k(n)("menu.exampleList")), 1),
            d("span", Am, O(k(n)("menu.copyPasteNote")), 1)
          ])
        ]),
        ot(d("textarea", {
          "onUpdate:modelValue": _[0] || (_[0] = (f) => h.value = f),
          class: "lib-textarea",
          placeholder: k(n)("menu.placeholder")
        }, null, 8, Sm), [
          [wt, h.value]
        ]),
        d("button", {
          type: "submit",
          disabled: k(a),
          class: "lib-btn-primary"
        }, O(k(a) ? k(n)("common.saving") : k(n)("menu.submitBtn")), 9, Nm)
      ], 32),
      d("div", Lm, [
        (L(!0), I(Fe, null, Je(m.value, (f) => (L(), I("div", {
          key: f.id,
          class: Ae(["lib-card", f.order % 2 === 0 ? "card-even" : "card-odd"])
        }, [
          d("div", $m, [
            d("h2", Im, O(f.name), 1)
          ]),
          d("div", Pm, [
            d("p", Dm, O(k(n)("menu.pricePrefix")) + ": " + O(f.price), 1),
            d("p", Rm, O(k(n)("menu.categoryPrefix")) + ": " + O(f.category || ""), 1),
            d("p", Mm, O(k(n)("menu.orderPrefix")) + ": " + O(f.order), 1)
          ])
        ], 2))), 128))
      ]),
      d("div", Bm, [
        d("button", {
          onClick: _[1] || (_[1] = //@ts-ignore
          (...f) => k(l) && k(l)(...f)),
          class: "lib-btn-secondary"
        }, O(k(n)("menu.reloadBtn")), 1)
      ])
    ]));
  }
}), kn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, o] of t)
    n[s] = o;
  return n;
}, fv = /* @__PURE__ */ kn(Fm, [["__scopeId", "data-v-3a70dff2"]]);
var Um = 20, Vm = 1, en = 1e6, Pr = 1e6, Hm = -7, jm = 21, qm = !1, Vn = "[big.js] ", on = Vn + "Invalid ", Cs = on + "decimal places", Wm = on + "rounding mode", Ci = Vn + "Division by zero", ge = {}, Tt = void 0, zm = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function Ti() {
  function e(t) {
    var n = this;
    if (!(n instanceof e))
      return t === Tt && arguments.length === 0 ? Ti() : new e(t);
    if (t instanceof e)
      n.s = t.s, n.e = t.e, n.c = t.c.slice();
    else {
      if (typeof t != "string") {
        if (e.strict === !0 && typeof t != "bigint")
          throw TypeError(on + "value");
        t = t === 0 && 1 / t < 0 ? "-0" : String(t);
      }
      Ym(n, t);
    }
    n.constructor = e;
  }
  return e.prototype = ge, e.DP = Um, e.RM = Vm, e.NE = Hm, e.PE = jm, e.strict = qm, e.roundDown = 0, e.roundHalfUp = 1, e.roundHalfEven = 2, e.roundUp = 3, e;
}
function Ym(e, t) {
  var n, s, o;
  if (!zm.test(t))
    throw Error(on + "number");
  for (e.s = t.charAt(0) == "-" ? (t = t.slice(1), -1) : 1, (n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (s = t.search(/e/i)) > 0 ? (n < 0 && (n = s), n += +t.slice(s + 1), t = t.substring(0, s)) : n < 0 && (n = t.length), o = t.length, s = 0; s < o && t.charAt(s) == "0"; ) ++s;
  if (s == o)
    e.c = [e.e = 0];
  else {
    for (; o > 0 && t.charAt(--o) == "0"; ) ;
    for (e.e = n - s - 1, e.c = [], n = 0; s <= o; ) e.c[n++] = +t.charAt(s++);
  }
  return e;
}
function rn(e, t, n, s) {
  var o = e.c;
  if (n === Tt && (n = e.constructor.RM), n !== 0 && n !== 1 && n !== 2 && n !== 3)
    throw Error(Wm);
  if (t < 1)
    s = n === 3 && (s || !!o[0]) || t === 0 && (n === 1 && o[0] >= 5 || n === 2 && (o[0] > 5 || o[0] === 5 && (s || o[1] !== Tt))), o.length = 1, s ? (e.e = e.e - t + 1, o[0] = 1) : o[0] = e.e = 0;
  else if (t < o.length) {
    if (s = n === 1 && o[t] >= 5 || n === 2 && (o[t] > 5 || o[t] === 5 && (s || o[t + 1] !== Tt || o[t - 1] & 1)) || n === 3 && (s || !!o[0]), o.length = t, s) {
      for (; ++o[--t] > 9; )
        if (o[t] = 0, t === 0) {
          ++e.e, o.unshift(1);
          break;
        }
    }
    for (t = o.length; !o[--t]; ) o.pop();
  }
  return e;
}
function an(e, t, n) {
  var s = e.e, o = e.c.join(""), r = o.length;
  if (t)
    o = o.charAt(0) + (r > 1 ? "." + o.slice(1) : "") + (s < 0 ? "e" : "e+") + s;
  else if (s < 0) {
    for (; ++s; ) o = "0" + o;
    o = "0." + o;
  } else if (s > 0)
    if (++s > r)
      for (s -= r; s--; ) o += "0";
    else s < r && (o = o.slice(0, s) + "." + o.slice(s));
  else r > 1 && (o = o.charAt(0) + "." + o.slice(1));
  return e.s < 0 && n ? "-" + o : o;
}
ge.abs = function() {
  var e = new this.constructor(this);
  return e.s = 1, e;
};
ge.cmp = function(e) {
  var t, n = this, s = n.c, o = (e = new n.constructor(e)).c, r = n.s, a = e.s, i = n.e, l = e.e;
  if (!s[0] || !o[0]) return s[0] ? r : o[0] ? -a : 0;
  if (r != a) return r;
  if (t = r < 0, i != l) return i > l ^ t ? 1 : -1;
  for (a = (i = s.length) < (l = o.length) ? i : l, r = -1; ++r < a; )
    if (s[r] != o[r]) return s[r] > o[r] ^ t ? 1 : -1;
  return i == l ? 0 : i > l ^ t ? 1 : -1;
};
ge.div = function(e) {
  var t = this, n = t.constructor, s = t.c, o = (e = new n(e)).c, r = t.s == e.s ? 1 : -1, a = n.DP;
  if (a !== ~~a || a < 0 || a > en)
    throw Error(Cs);
  if (!o[0])
    throw Error(Ci);
  if (!s[0])
    return e.s = r, e.c = [e.e = 0], e;
  var i, l, c, h, m, p = o.slice(), g = i = o.length, _ = s.length, f = s.slice(0, i), w = f.length, u = e, b = u.c = [], x = 0, v = a + (u.e = t.e - e.e) + 1;
  for (u.s = r, r = v < 0 ? 0 : v, p.unshift(0); w++ < i; ) f.push(0);
  do {
    for (c = 0; c < 10; c++) {
      if (i != (w = f.length))
        h = i > w ? 1 : -1;
      else
        for (m = -1, h = 0; ++m < i; )
          if (o[m] != f[m]) {
            h = o[m] > f[m] ? 1 : -1;
            break;
          }
      if (h < 0) {
        for (l = w == i ? o : p; w; ) {
          if (f[--w] < l[w]) {
            for (m = w; m && !f[--m]; ) f[m] = 9;
            --f[m], f[w] += 10;
          }
          f[w] -= l[w];
        }
        for (; !f[0]; ) f.shift();
      } else
        break;
    }
    b[x++] = h ? c : ++c, f[0] && h ? f[w] = s[g] || 0 : f = [s[g]];
  } while ((g++ < _ || f[0] !== Tt) && r--);
  return !b[0] && x != 1 && (b.shift(), u.e--, v--), x > v && rn(u, v, n.RM, f[0] !== Tt), u;
};
ge.eq = function(e) {
  return this.cmp(e) === 0;
};
ge.gt = function(e) {
  return this.cmp(e) > 0;
};
ge.gte = function(e) {
  return this.cmp(e) > -1;
};
ge.lt = function(e) {
  return this.cmp(e) < 0;
};
ge.lte = function(e) {
  return this.cmp(e) < 1;
};
ge.minus = ge.sub = function(e) {
  var t, n, s, o, r = this, a = r.constructor, i = r.s, l = (e = new a(e)).s;
  if (i != l)
    return e.s = -l, r.plus(e);
  var c = r.c.slice(), h = r.e, m = e.c, p = e.e;
  if (!c[0] || !m[0])
    return m[0] ? e.s = -l : c[0] ? e = new a(r) : e.s = 1, e;
  if (i = h - p) {
    for ((o = i < 0) ? (i = -i, s = c) : (p = h, s = m), s.reverse(), l = i; l--; ) s.push(0);
    s.reverse();
  } else
    for (n = ((o = c.length < m.length) ? c : m).length, i = l = 0; l < n; l++)
      if (c[l] != m[l]) {
        o = c[l] < m[l];
        break;
      }
  if (o && (s = c, c = m, m = s, e.s = -e.s), (l = (n = m.length) - (t = c.length)) > 0) for (; l--; ) c[t++] = 0;
  for (l = t; n > i; ) {
    if (c[--n] < m[n]) {
      for (t = n; t && !c[--t]; ) c[t] = 9;
      --c[t], c[n] += 10;
    }
    c[n] -= m[n];
  }
  for (; c[--l] === 0; ) c.pop();
  for (; c[0] === 0; )
    c.shift(), --p;
  return c[0] || (e.s = 1, c = [p = 0]), e.c = c, e.e = p, e;
};
ge.mod = function(e) {
  var t, n = this, s = n.constructor, o = n.s, r = (e = new s(e)).s;
  if (!e.c[0])
    throw Error(Ci);
  return n.s = e.s = 1, t = e.cmp(n) == 1, n.s = o, e.s = r, t ? new s(n) : (o = s.DP, r = s.RM, s.DP = s.RM = 0, n = n.div(e), s.DP = o, s.RM = r, this.minus(n.times(e)));
};
ge.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, e;
};
ge.plus = ge.add = function(e) {
  var t, n, s, o = this, r = o.constructor;
  if (e = new r(e), o.s != e.s)
    return e.s = -e.s, o.minus(e);
  var a = o.e, i = o.c, l = e.e, c = e.c;
  if (!i[0] || !c[0])
    return c[0] || (i[0] ? e = new r(o) : e.s = o.s), e;
  if (i = i.slice(), t = a - l) {
    for (t > 0 ? (l = a, s = c) : (t = -t, s = i), s.reverse(); t--; ) s.push(0);
    s.reverse();
  }
  for (i.length - c.length < 0 && (s = c, c = i, i = s), t = c.length, n = 0; t; i[t] %= 10) n = (i[--t] = i[t] + c[t] + n) / 10 | 0;
  for (n && (i.unshift(n), ++l), t = i.length; i[--t] === 0; ) i.pop();
  return e.c = i, e.e = l, e;
};
ge.pow = function(e) {
  var t = this, n = new t.constructor("1"), s = n, o = e < 0;
  if (e !== ~~e || e < -Pr || e > Pr)
    throw Error(on + "exponent");
  for (o && (e = -e); e & 1 && (s = s.times(t)), e >>= 1, !!e; )
    t = t.times(t);
  return o ? n.div(s) : s;
};
ge.prec = function(e, t) {
  if (e !== ~~e || e < 1 || e > en)
    throw Error(on + "precision");
  return rn(new this.constructor(this), e, t);
};
ge.round = function(e, t) {
  if (e === Tt) e = 0;
  else if (e !== ~~e || e < -en || e > en)
    throw Error(Cs);
  return rn(new this.constructor(this), e + this.e + 1, t);
};
ge.sqrt = function() {
  var e, t, n, s = this, o = s.constructor, r = s.s, a = s.e, i = new o("0.5");
  if (!s.c[0]) return new o(s);
  if (r < 0)
    throw Error(Vn + "No square root");
  r = Math.sqrt(+an(s, !0, !0)), r === 0 || r === 1 / 0 ? (t = s.c.join(""), t.length + a & 1 || (t += "0"), r = Math.sqrt(t), a = ((a + 1) / 2 | 0) - (a < 0 || a & 1), e = new o((r == 1 / 0 ? "5e" : (r = r.toExponential()).slice(0, r.indexOf("e") + 1)) + a)) : e = new o(r + ""), a = e.e + (o.DP += 4);
  do
    n = e, e = i.times(n.plus(s.div(n)));
  while (n.c.slice(0, a).join("") !== e.c.slice(0, a).join(""));
  return rn(e, (o.DP -= 4) + e.e + 1, o.RM);
};
ge.times = ge.mul = function(e) {
  var t, n = this, s = n.constructor, o = n.c, r = (e = new s(e)).c, a = o.length, i = r.length, l = n.e, c = e.e;
  if (e.s = n.s == e.s ? 1 : -1, !o[0] || !r[0])
    return e.c = [e.e = 0], e;
  for (e.e = l + c, a < i && (t = o, o = r, r = t, c = a, a = i, i = c), t = new Array(c = a + i); c--; ) t[c] = 0;
  for (l = i; l--; ) {
    for (i = 0, c = a + l; c > l; )
      i = t[c] + r[l] * o[c - l - 1] + i, t[c--] = i % 10, i = i / 10 | 0;
    t[c] = i;
  }
  for (i ? ++e.e : t.shift(), l = t.length; !t[--l]; ) t.pop();
  return e.c = t, e;
};
ge.toExponential = function(e, t) {
  var n = this, s = n.c[0];
  if (e !== Tt) {
    if (e !== ~~e || e < 0 || e > en)
      throw Error(Cs);
    for (n = rn(new n.constructor(n), ++e, t); n.c.length < e; ) n.c.push(0);
  }
  return an(n, !0, !!s);
};
ge.toFixed = function(e, t) {
  var n = this, s = n.c[0];
  if (e !== Tt) {
    if (e !== ~~e || e < 0 || e > en)
      throw Error(Cs);
    for (n = rn(new n.constructor(n), e + n.e + 1, t), e = e + n.e + 1; n.c.length < e; ) n.c.push(0);
  }
  return an(n, !1, !!s);
};
ge.toJSON = ge.toString = function() {
  var e = this, t = e.constructor;
  return an(e, e.e <= t.NE || e.e >= t.PE, !!e.c[0]);
};
typeof Symbol < "u" && (ge[Symbol.for("nodejs.util.inspect.custom")] = ge.toJSON);
ge.toNumber = function() {
  var e = +an(this, !0, !0);
  if (this.constructor.strict === !0 && !this.eq(e.toString()))
    throw Error(Vn + "Imprecise conversion");
  return e;
};
ge.toPrecision = function(e, t) {
  var n = this, s = n.constructor, o = n.c[0];
  if (e !== Tt) {
    if (e !== ~~e || e < 1 || e > en)
      throw Error(on + "precision");
    for (n = rn(new s(n), e, t); n.c.length < e; ) n.c.push(0);
  }
  return an(n, e <= n.e || n.e <= s.NE || n.e >= s.PE, !!o);
};
ge.valueOf = function() {
  var e = this, t = e.constructor;
  if (t.strict === !0)
    throw Error(Vn + "valueOf disallowed");
  return an(e, e.e <= t.NE || e.e >= t.PE, !0);
};
var Rt = Ti();
function Oi(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Gm } = Object.prototype, { getPrototypeOf: Ts } = Object, { iterator: Os, toStringTag: Ai } = Symbol, As = /* @__PURE__ */ ((e) => (t) => {
  const n = Gm.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), _t = (e) => (e = e.toLowerCase(), (t) => As(t) === e), Ss = (e) => (t) => typeof t === e, { isArray: Cn } = Array, wn = Ss("undefined");
function Hn(e) {
  return e !== null && !wn(e) && e.constructor !== null && !wn(e.constructor) && at(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Si = _t("ArrayBuffer");
function Km(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Si(e.buffer), t;
}
const Xm = Ss("string"), at = Ss("function"), Ni = Ss("number"), jn = (e) => e !== null && typeof e == "object", Jm = (e) => e === !0 || e === !1, Qn = (e) => {
  if (As(e) !== "object")
    return !1;
  const t = Ts(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Ai in e) && !(Os in e);
}, Zm = (e) => {
  if (!jn(e) || Hn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Qm = _t("Date"), eh = _t("File"), th = (e) => !!(e && typeof e.uri < "u"), nh = (e) => e && typeof e.getParts < "u", sh = _t("Blob"), oh = _t("FileList"), rh = (e) => jn(e) && at(e.pipe);
function ah() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Dr = ah(), Rr = typeof Dr.FormData < "u" ? Dr.FormData : void 0, ih = (e) => {
  if (!e) return !1;
  if (Rr && e instanceof Rr) return !0;
  const t = Ts(e);
  if (!t || t === Object.prototype || !at(e.append)) return !1;
  const n = As(e);
  return n === "formdata" || // detect form-data instance
  n === "object" && at(e.toString) && e.toString() === "[object FormData]";
}, lh = _t("URLSearchParams"), [ch, uh, dh, fh] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(_t), mh = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function qn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let s, o;
  if (typeof e != "object" && (e = [e]), Cn(e))
    for (s = 0, o = e.length; s < o; s++)
      t.call(null, e[s], s, e);
  else {
    if (Hn(e))
      return;
    const r = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = r.length;
    let i;
    for (s = 0; s < a; s++)
      i = r[s], t.call(null, e[i], i, e);
  }
}
function Li(e, t) {
  if (Hn(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length, o;
  for (; s-- > 0; )
    if (o = n[s], t === o.toLowerCase())
      return o;
  return null;
}
const Kt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $i = (e) => !wn(e) && e !== Kt;
function so(...e) {
  const { caseless: t, skipUndefined: n } = $i(this) && this || {}, s = {}, o = (r, a) => {
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    const i = t && Li(s, a) || a, l = oo(s, i) ? s[i] : void 0;
    Qn(l) && Qn(r) ? s[i] = so(l, r) : Qn(r) ? s[i] = so({}, r) : Cn(r) ? s[i] = r.slice() : (!n || !wn(r)) && (s[i] = r);
  };
  for (let r = 0, a = e.length; r < a; r++)
    e[r] && qn(e[r], o);
  return s;
}
const hh = (e, t, n, { allOwnKeys: s } = {}) => (qn(
  t,
  (o, r) => {
    n && at(o) ? Object.defineProperty(e, r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: Oi(o, n),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, r, {
      __proto__: null,
      value: o,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: s }
), e), ph = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), gh = (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, bh = (e, t, n, s) => {
  let o, r, a;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), r = o.length; r-- > 0; )
      a = o[r], (!s || s(a, e, t)) && !i[a] && (t[a] = e[a], i[a] = !0);
    e = n !== !1 && Ts(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, wh = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, yh = (e) => {
  if (!e) return null;
  if (Cn(e)) return e;
  let t = e.length;
  if (!Ni(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, vh = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ts(Uint8Array)), _h = (e, t) => {
  const s = (e && e[Os]).call(e);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const r = o.value;
    t.call(e, r[0], r[1]);
  }
}, xh = (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; )
    s.push(n);
  return s;
}, Eh = _t("HTMLFormElement"), kh = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, s, o) {
  return s.toUpperCase() + o;
}), oo = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ch = _t("RegExp"), Ii = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  qn(n, (o, r) => {
    let a;
    (a = t(o, r, e)) !== !1 && (s[r] = a || o);
  }), Object.defineProperties(e, s);
}, Th = (e) => {
  Ii(e, (t, n) => {
    if (at(e) && ["arguments", "caller", "callee"].includes(n))
      return !1;
    const s = e[n];
    if (at(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Oh = (e, t) => {
  const n = {}, s = (o) => {
    o.forEach((r) => {
      n[r] = !0;
    });
  };
  return Cn(e) ? s(e) : s(String(e).split(t)), n;
}, Ah = () => {
}, Sh = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Nh(e) {
  return !!(e && at(e.append) && e[Ai] === "FormData" && e[Os]);
}
const Lh = (e) => {
  const t = /* @__PURE__ */ new WeakSet(), n = (s) => {
    if (jn(s)) {
      if (t.has(s))
        return;
      if (Hn(s))
        return s;
      if (!("toJSON" in s)) {
        t.add(s);
        const o = Cn(s) ? [] : {};
        return qn(s, (r, a) => {
          const i = n(r);
          !wn(i) && (o[a] = i);
        }), t.delete(s), o;
      }
    }
    return s;
  };
  return n(e);
}, $h = _t("AsyncFunction"), Ih = (e) => e && (jn(e) || at(e)) && at(e.then) && at(e.catch), Pi = ((e, t) => e ? setImmediate : t ? ((n, s) => (Kt.addEventListener(
  "message",
  ({ source: o, data: r }) => {
    o === Kt && r === n && s.length && s.shift()();
  },
  !1
), (o) => {
  s.push(o), Kt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(typeof setImmediate == "function", at(Kt.postMessage)), Ph = typeof queueMicrotask < "u" ? queueMicrotask.bind(Kt) : typeof process < "u" && process.nextTick || Pi, Dh = (e) => e != null && at(e[Os]), T = {
  isArray: Cn,
  isArrayBuffer: Si,
  isBuffer: Hn,
  isFormData: ih,
  isArrayBufferView: Km,
  isString: Xm,
  isNumber: Ni,
  isBoolean: Jm,
  isObject: jn,
  isPlainObject: Qn,
  isEmptyObject: Zm,
  isReadableStream: ch,
  isRequest: uh,
  isResponse: dh,
  isHeaders: fh,
  isUndefined: wn,
  isDate: Qm,
  isFile: eh,
  isReactNativeBlob: th,
  isReactNative: nh,
  isBlob: sh,
  isRegExp: Ch,
  isFunction: at,
  isStream: rh,
  isURLSearchParams: lh,
  isTypedArray: vh,
  isFileList: oh,
  forEach: qn,
  merge: so,
  extend: hh,
  trim: mh,
  stripBOM: ph,
  inherits: gh,
  toFlatObject: bh,
  kindOf: As,
  kindOfTest: _t,
  endsWith: wh,
  toArray: yh,
  forEachEntry: _h,
  matchAll: xh,
  isHTMLForm: Eh,
  hasOwnProperty: oo,
  hasOwnProp: oo,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ii,
  freezeMethods: Th,
  toObjectSet: Oh,
  toCamelCase: kh,
  noop: Ah,
  toFiniteNumber: Sh,
  findKey: Li,
  global: Kt,
  isContextDefined: $i,
  isSpecCompliantForm: Nh,
  toJSONObject: Lh,
  isAsyncFn: $h,
  isThenable: Ih,
  setImmediate: Pi,
  asap: Ph,
  isIterable: Dh
}, Rh = T.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Mh = (e) => {
  const t = {};
  let n, s, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), s = a.substring(o + 1).trim(), !(!n || t[n] && Rh[n]) && (n === "set-cookie" ? t[n] ? t[n].push(s) : t[n] = [s] : t[n] = t[n] ? t[n] + ", " + s : s);
  }), t;
};
function Bh(e) {
  let t = 0, n = e.length;
  for (; t < n; ) {
    const s = e.charCodeAt(t);
    if (s !== 9 && s !== 32)
      break;
    t += 1;
  }
  for (; n > t; ) {
    const s = e.charCodeAt(n - 1);
    if (s !== 9 && s !== 32)
      break;
    n -= 1;
  }
  return t === 0 && n === e.length ? e : e.slice(t, n);
}
const Fh = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Uh = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Mo(e, t) {
  return T.isArray(e) ? e.map((n) => Mo(n, t)) : Bh(String(e).replace(t, ""));
}
const Vh = (e) => Mo(e, Fh), Hh = (e) => Mo(e, Uh);
function Di(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return T.forEach(e.toJSON(), (n, s) => {
    t[s] = Hh(n);
  }), t;
}
const Mr = Symbol("internals");
function On(e) {
  return e && String(e).trim().toLowerCase();
}
function es(e) {
  return e === !1 || e == null ? e : T.isArray(e) ? e.map(es) : Vh(String(e));
}
function jh(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(e); )
    t[s[1]] = s[2];
  return t;
}
const qh = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Fs(e, t, n, s, o) {
  if (T.isFunction(s))
    return s.call(this, t, n);
  if (o && (t = n), !!T.isString(t)) {
    if (T.isString(s))
      return t.indexOf(s) !== -1;
    if (T.isRegExp(s))
      return s.test(t);
  }
}
function Wh(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function zh(e, t) {
  const n = T.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(e, s + n, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(o, r, a) {
        return this[s].call(this, t, o, r, a);
      },
      configurable: !0
    });
  });
}
let tt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const o = this;
    function r(i, l, c) {
      const h = On(l);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const m = T.findKey(o, h);
      (!m || o[m] === void 0 || c === !0 || c === void 0 && o[m] !== !1) && (o[m || l] = es(i));
    }
    const a = (i, l) => T.forEach(i, (c, h) => r(c, h, l));
    if (T.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (T.isString(t) && (t = t.trim()) && !qh(t))
      a(Mh(t), n);
    else if (T.isObject(t) && T.isIterable(t)) {
      let i = {}, l, c;
      for (const h of t) {
        if (!T.isArray(h))
          throw TypeError("Object iterator must return a key-value pair");
        i[c = h[0]] = (l = i[c]) ? T.isArray(l) ? [...l, h[1]] : [l, h[1]] : h[1];
      }
      a(i, n);
    } else
      t != null && r(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = On(t), t) {
      const s = T.findKey(this, t);
      if (s) {
        const o = this[s];
        if (!n)
          return o;
        if (n === !0)
          return jh(o);
        if (T.isFunction(n))
          return n.call(this, o, s);
        if (T.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = On(t), t) {
      const s = T.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || Fs(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let o = !1;
    function r(a) {
      if (a = On(a), a) {
        const i = T.findKey(s, a);
        i && (!n || Fs(s, s[i], i, n)) && (delete s[i], o = !0);
      }
    }
    return T.isArray(t) ? t.forEach(r) : r(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, o = !1;
    for (; s--; ) {
      const r = n[s];
      (!t || Fs(this, this[r], r, t, !0)) && (delete this[r], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, s = {};
    return T.forEach(this, (o, r) => {
      const a = T.findKey(s, r);
      if (a) {
        n[a] = es(o), delete n[r];
        return;
      }
      const i = t ? Wh(r) : String(r).trim();
      i !== r && delete n[r], n[i] = es(o), s[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return T.forEach(this, (s, o) => {
      s != null && s !== !1 && (n[o] = t && T.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((o) => s.set(o)), s;
  }
  static accessor(t) {
    const s = (this[Mr] = this[Mr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function r(a) {
      const i = On(a);
      s[i] || (zh(o, a), s[i] = !0);
    }
    return T.isArray(t) ? t.forEach(r) : r(t), this;
  }
};
tt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
T.reduceDescriptors(tt.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
T.freezeMethods(tt);
const Yh = "[REDACTED ****]";
function Gh(e) {
  if (T.hasOwnProp(e, "toJSON"))
    return !0;
  let t = Object.getPrototypeOf(e);
  for (; t && t !== Object.prototype; ) {
    if (T.hasOwnProp(t, "toJSON"))
      return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
function Kh(e, t) {
  const n = new Set(t.map((r) => String(r).toLowerCase())), s = [], o = (r) => {
    if (r === null || typeof r != "object" || T.isBuffer(r)) return r;
    if (s.indexOf(r) !== -1) return;
    r instanceof tt && (r = r.toJSON()), s.push(r);
    let a;
    if (T.isArray(r))
      a = [], r.forEach((i, l) => {
        const c = o(i);
        T.isUndefined(c) || (a[l] = c);
      });
    else {
      if (!T.isPlainObject(r) && Gh(r))
        return s.pop(), r;
      a = /* @__PURE__ */ Object.create(null);
      for (const [i, l] of Object.entries(r)) {
        const c = n.has(i.toLowerCase()) ? Yh : o(l);
        T.isUndefined(c) || (a[i] = c);
      }
    }
    return s.pop(), a;
  };
  return o(e);
}
let Y = class Ri extends Error {
  static from(t, n, s, o, r, a) {
    const i = new Ri(t.message, n || t.code, s, o, r);
    return i.cause = t, i.name = t.name, t.status != null && i.status == null && (i.status = t.status), a && Object.assign(i, a), i;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, n, s, o, r) {
    super(t), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, n && (this.code = n), s && (this.config = s), o && (this.request = o), r && (this.response = r, this.status = r.status);
  }
  toJSON() {
    const t = this.config, n = t && T.hasOwnProp(t, "redact") ? t.redact : void 0, s = T.isArray(n) && n.length > 0 ? Kh(t, n) : T.toJSONObject(t);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: s,
      code: this.code,
      status: this.status
    };
  }
};
Y.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
Y.ERR_BAD_OPTION = "ERR_BAD_OPTION";
Y.ECONNABORTED = "ECONNABORTED";
Y.ETIMEDOUT = "ETIMEDOUT";
Y.ECONNREFUSED = "ECONNREFUSED";
Y.ERR_NETWORK = "ERR_NETWORK";
Y.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
Y.ERR_DEPRECATED = "ERR_DEPRECATED";
Y.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
Y.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
Y.ERR_CANCELED = "ERR_CANCELED";
Y.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
Y.ERR_INVALID_URL = "ERR_INVALID_URL";
Y.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const Xh = null;
function ro(e) {
  return T.isPlainObject(e) || T.isArray(e);
}
function Mi(e) {
  return T.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Us(e, t, n) {
  return e ? e.concat(t).map(function(o, r) {
    return o = Mi(o), !n && r ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function Jh(e) {
  return T.isArray(e) && !e.some(ro);
}
const Zh = T.toFlatObject(T, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ns(e, t, n) {
  if (!T.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = T.toFlatObject(
    n,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(w, u) {
      return !T.isUndefined(u[w]);
    }
  );
  const s = n.metaTokens, o = n.visitor || m, r = n.dots, a = n.indexes, i = n.Blob || typeof Blob < "u" && Blob, l = n.maxDepth === void 0 ? 100 : n.maxDepth, c = i && T.isSpecCompliantForm(t);
  if (!T.isFunction(o))
    throw new TypeError("visitor must be a function");
  function h(f) {
    if (f === null) return "";
    if (T.isDate(f))
      return f.toISOString();
    if (T.isBoolean(f))
      return f.toString();
    if (!c && T.isBlob(f))
      throw new Y("Blob is not supported. Use a Buffer instead.");
    return T.isArrayBuffer(f) || T.isTypedArray(f) ? c && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function m(f, w, u) {
    let b = f;
    if (T.isReactNative(t) && T.isReactNativeBlob(f))
      return t.append(Us(u, w, r), h(f)), !1;
    if (f && !u && typeof f == "object") {
      if (T.endsWith(w, "{}"))
        w = s ? w : w.slice(0, -2), f = JSON.stringify(f);
      else if (T.isArray(f) && Jh(f) || (T.isFileList(f) || T.endsWith(w, "[]")) && (b = T.toArray(f)))
        return w = Mi(w), b.forEach(function(v, A) {
          !(T.isUndefined(v) || v === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Us([w], A, r) : a === null ? w : w + "[]",
            h(v)
          );
        }), !1;
    }
    return ro(f) ? !0 : (t.append(Us(u, w, r), h(f)), !1);
  }
  const p = [], g = Object.assign(Zh, {
    defaultVisitor: m,
    convertValue: h,
    isVisitable: ro
  });
  function _(f, w, u = 0) {
    if (!T.isUndefined(f)) {
      if (u > l)
        throw new Y(
          "Object is too deeply nested (" + u + " levels). Max depth: " + l,
          Y.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (p.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      p.push(f), T.forEach(f, function(x, v) {
        (!(T.isUndefined(x) || x === null) && o.call(t, x, T.isString(v) ? v.trim() : v, w, g)) === !0 && _(x, w ? w.concat(v) : [v], u + 1);
      }), p.pop();
    }
  }
  if (!T.isObject(e))
    throw new TypeError("data must be an object");
  return _(e), t;
}
function Br(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(s) {
    return t[s];
  });
}
function Bo(e, t) {
  this._pairs = [], e && Ns(e, this, t);
}
const Bi = Bo.prototype;
Bi.append = function(t, n) {
  this._pairs.push([t, n]);
};
Bi.toString = function(t) {
  const n = t ? function(s) {
    return t.call(this, s, Br);
  } : Br;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Qh(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Fi(e, t, n) {
  if (!t)
    return e;
  const s = n && n.encode || Qh, o = T.isFunction(n) ? {
    serialize: n
  } : n, r = o && o.serialize;
  let a;
  if (r ? a = r(t, o) : a = T.isURLSearchParams(t) ? t.toString() : new Bo(t, o).toString(s), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Fr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    T.forEach(this.handlers, function(s) {
      s !== null && t(s);
    });
  }
}
const Fo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, ep = typeof URLSearchParams < "u" ? URLSearchParams : Bo, tp = typeof FormData < "u" ? FormData : null, np = typeof Blob < "u" ? Blob : null, sp = {
  isBrowser: !0,
  classes: {
    URLSearchParams: ep,
    FormData: tp,
    Blob: np
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Uo = typeof window < "u" && typeof document < "u", ao = typeof navigator == "object" && navigator || void 0, op = Uo && (!ao || ["ReactNative", "NativeScript", "NS"].indexOf(ao.product) < 0), rp = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ap = Uo && window.location.href || "http://localhost", ip = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Uo,
  hasStandardBrowserEnv: op,
  hasStandardBrowserWebWorkerEnv: rp,
  navigator: ao,
  origin: ap
}, Symbol.toStringTag, { value: "Module" })), Xe = {
  ...ip,
  ...sp
};
function lp(e, t) {
  return Ns(e, new Xe.classes.URLSearchParams(), {
    visitor: function(n, s, o, r) {
      return Xe.isNode && T.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function cp(e) {
  return T.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function up(e) {
  const t = {}, n = Object.keys(e);
  let s;
  const o = n.length;
  let r;
  for (s = 0; s < o; s++)
    r = n[s], t[r] = e[r];
  return t;
}
function Ui(e) {
  function t(n, s, o, r) {
    let a = n[r++];
    if (a === "__proto__") return !0;
    const i = Number.isFinite(+a), l = r >= n.length;
    return a = !a && T.isArray(o) ? o.length : a, l ? (T.hasOwnProp(o, a) ? o[a] = T.isArray(o[a]) ? o[a].concat(s) : [o[a], s] : o[a] = s, !i) : ((!T.hasOwnProp(o, a) || !T.isObject(o[a])) && (o[a] = []), t(n, s, o[a], r) && T.isArray(o[a]) && (o[a] = up(o[a])), !i);
  }
  if (T.isFormData(e) && T.isFunction(e.entries)) {
    const n = {};
    return T.forEachEntry(e, (s, o) => {
      t(cp(s), o, n, 0);
    }), n;
  }
  return null;
}
const cn = (e, t) => e != null && T.hasOwnProp(e, t) ? e[t] : void 0;
function dp(e, t, n) {
  if (T.isString(e))
    try {
      return (t || JSON.parse)(e), T.trim(e);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(e);
}
const Wn = {
  transitional: Fo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, n) {
      const s = n.getContentType() || "", o = s.indexOf("application/json") > -1, r = T.isObject(t);
      if (r && T.isHTMLForm(t) && (t = new FormData(t)), T.isFormData(t))
        return o ? JSON.stringify(Ui(t)) : t;
      if (T.isArrayBuffer(t) || T.isBuffer(t) || T.isStream(t) || T.isFile(t) || T.isBlob(t) || T.isReadableStream(t))
        return t;
      if (T.isArrayBufferView(t))
        return t.buffer;
      if (T.isURLSearchParams(t))
        return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let i;
      if (r) {
        const l = cn(this, "formSerializer");
        if (s.indexOf("application/x-www-form-urlencoded") > -1)
          return lp(t, l).toString();
        if ((i = T.isFileList(t)) || s.indexOf("multipart/form-data") > -1) {
          const c = cn(this, "env"), h = c && c.FormData;
          return Ns(
            i ? { "files[]": t } : t,
            h && new h(),
            l
          );
        }
      }
      return r || o ? (n.setContentType("application/json", !1), dp(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const n = cn(this, "transitional") || Wn.transitional, s = n && n.forcedJSONParsing, o = cn(this, "responseType"), r = o === "json";
      if (T.isResponse(t) || T.isReadableStream(t))
        return t;
      if (t && T.isString(t) && (s && !o || r)) {
        const i = !(n && n.silentJSONParsing) && r;
        try {
          return JSON.parse(t, cn(this, "parseReviver"));
        } catch (l) {
          if (i)
            throw l.name === "SyntaxError" ? Y.from(l, Y.ERR_BAD_RESPONSE, this, null, cn(this, "response")) : l;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Xe.classes.FormData,
    Blob: Xe.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
T.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Wn.headers[e] = {};
});
function Vs(e, t) {
  const n = this || Wn, s = t || n, o = tt.from(s.headers);
  let r = s.data;
  return T.forEach(e, function(i) {
    r = i.call(n, r, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), r;
}
function Vi(e) {
  return !!(e && e.__CANCEL__);
}
let zn = class extends Y {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, n, s) {
    super(t ?? "canceled", Y.ERR_CANCELED, n, s), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Hi(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? e(n) : t(new Y(
    "Request failed with status code " + n.status,
    n.status >= 400 && n.status < 500 ? Y.ERR_BAD_REQUEST : Y.ERR_BAD_RESPONSE,
    n.config,
    n.request,
    n
  ));
}
function fp(e) {
  const t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return t && t[1] || "";
}
function mp(e, t) {
  e = e || 10;
  const n = new Array(e), s = new Array(e);
  let o = 0, r = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), h = s[r];
    a || (a = c), n[o] = l, s[o] = c;
    let m = r, p = 0;
    for (; m !== o; )
      p += n[m++], m = m % e;
    if (o = (o + 1) % e, o === r && (r = (r + 1) % e), c - a < t)
      return;
    const g = h && c - h;
    return g ? Math.round(p * 1e3 / g) : void 0;
  };
}
function hp(e, t) {
  let n = 0, s = 1e3 / t, o, r;
  const a = (c, h = Date.now()) => {
    n = h, o = null, r && (clearTimeout(r), r = null), e(...c);
  };
  return [(...c) => {
    const h = Date.now(), m = h - n;
    m >= s ? a(c, h) : (o = c, r || (r = setTimeout(() => {
      r = null, a(o);
    }, s - m)));
  }, () => o && a(o)];
}
const ps = (e, t, n = 3) => {
  let s = 0;
  const o = mp(50, 250);
  return hp((r) => {
    if (!r || typeof r.loaded != "number")
      return;
    const a = r.loaded, i = r.lengthComputable ? r.total : void 0, l = i != null ? Math.min(a, i) : a, c = Math.max(0, l - s), h = o(c);
    s = Math.max(s, l);
    const m = {
      loaded: l,
      total: i,
      progress: i ? l / i : void 0,
      bytes: c,
      rate: h || void 0,
      estimated: h && i ? (i - l) / h : void 0,
      event: r,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(m);
  }, n);
}, Ur = (e, t) => {
  const n = e != null;
  return [
    (s) => t[0]({
      lengthComputable: n,
      total: e,
      loaded: s
    }),
    t[1]
  ];
}, Vr = (e) => (...t) => T.asap(() => e(...t)), pp = Xe.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Xe.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Xe.origin),
  Xe.navigator && /(msie|trident)/i.test(Xe.navigator.userAgent)
) : () => !0, gp = Xe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, s, o, r, a) {
      if (typeof document > "u") return;
      const i = [`${e}=${encodeURIComponent(t)}`];
      T.isNumber(n) && i.push(`expires=${new Date(n).toUTCString()}`), T.isString(s) && i.push(`path=${s}`), T.isString(o) && i.push(`domain=${o}`), r === !0 && i.push("secure"), T.isString(a) && i.push(`SameSite=${a}`), document.cookie = i.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.split(";");
      for (let n = 0; n < t.length; n++) {
        const s = t[n].replace(/^\s+/, ""), o = s.indexOf("=");
        if (o !== -1 && s.slice(0, o) === e)
          return decodeURIComponent(s.slice(o + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function bp(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function wp(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ji(e, t, n) {
  let s = !bp(t);
  return e && (s || n === !1) ? wp(e, t) : t;
}
const Hr = (e) => e instanceof tt ? { ...e } : e;
function tn(e, t) {
  t = t || {};
  const n = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(n, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function s(c, h, m, p) {
    return T.isPlainObject(c) && T.isPlainObject(h) ? T.merge.call({ caseless: p }, c, h) : T.isPlainObject(h) ? T.merge({}, h) : T.isArray(h) ? h.slice() : h;
  }
  function o(c, h, m, p) {
    if (T.isUndefined(h)) {
      if (!T.isUndefined(c))
        return s(void 0, c, m, p);
    } else return s(c, h, m, p);
  }
  function r(c, h) {
    if (!T.isUndefined(h))
      return s(void 0, h);
  }
  function a(c, h) {
    if (T.isUndefined(h)) {
      if (!T.isUndefined(c))
        return s(void 0, c);
    } else return s(void 0, h);
  }
  function i(c, h, m) {
    if (T.hasOwnProp(t, m))
      return s(c, h);
    if (T.hasOwnProp(e, m))
      return s(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    allowedSocketPaths: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (c, h, m) => o(Hr(c), Hr(h), m, !0)
  };
  return T.forEach(Object.keys({ ...e, ...t }), function(h) {
    if (h === "__proto__" || h === "constructor" || h === "prototype") return;
    const m = T.hasOwnProp(l, h) ? l[h] : o, p = T.hasOwnProp(e, h) ? e[h] : void 0, g = T.hasOwnProp(t, h) ? t[h] : void 0, _ = m(p, g, h);
    T.isUndefined(_) && m !== i || (n[h] = _);
  }), n;
}
const yp = ["content-type", "content-length"];
function vp(e, t, n) {
  if (n !== "content-only") {
    e.set(t);
    return;
  }
  Object.entries(t).forEach(([s, o]) => {
    yp.includes(s.toLowerCase()) && e.set(s, o);
  });
}
const _p = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (t, n) => String.fromCharCode(parseInt(n, 16))
), qi = (e) => {
  const t = tn({}, e), n = (p) => T.hasOwnProp(t, p) ? t[p] : void 0, s = n("data");
  let o = n("withXSRFToken");
  const r = n("xsrfHeaderName"), a = n("xsrfCookieName");
  let i = n("headers");
  const l = n("auth"), c = n("baseURL"), h = n("allowAbsoluteUrls"), m = n("url");
  if (t.headers = i = tt.from(i), t.url = Fi(
    ji(c, m, h),
    e.params,
    e.paramsSerializer
  ), l && i.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? _p(l.password) : ""))
  ), T.isFormData(s) && (Xe.hasStandardBrowserEnv || Xe.hasStandardBrowserWebWorkerEnv ? i.setContentType(void 0) : T.isFunction(s.getHeaders) && vp(i, s.getHeaders(), n("formDataHeaderPolicy"))), Xe.hasStandardBrowserEnv && (T.isFunction(o) && (o = o(t)), o === !0 || o == null && pp(t.url))) {
    const g = r && a && gp.read(a);
    g && i.set(r, g);
  }
  return t;
}, xp = typeof XMLHttpRequest < "u", Ep = xp && function(e) {
  return new Promise(function(n, s) {
    const o = qi(e);
    let r = o.data;
    const a = tt.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: l, onDownloadProgress: c } = o, h, m, p, g, _;
    function f() {
      g && g(), _ && _(), o.cancelToken && o.cancelToken.unsubscribe(h), o.signal && o.signal.removeEventListener("abort", h);
    }
    let w = new XMLHttpRequest();
    w.open(o.method.toUpperCase(), o.url, !0), w.timeout = o.timeout;
    function u() {
      if (!w)
        return;
      const x = tt.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), A = {
        data: !i || i === "text" || i === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: x,
        config: e,
        request: w
      };
      Hi(
        function(C) {
          n(C), f();
        },
        function(C) {
          s(C), f();
        },
        A
      ), w = null;
    }
    "onloadend" in w ? w.onloadend = u : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.startsWith("file:")) || setTimeout(u);
    }, w.onabort = function() {
      w && (s(new Y("Request aborted", Y.ECONNABORTED, e, w)), f(), w = null);
    }, w.onerror = function(v) {
      const A = v && v.message ? v.message : "Network Error", $ = new Y(A, Y.ERR_NETWORK, e, w);
      $.event = v || null, s($), f(), w = null;
    }, w.ontimeout = function() {
      let v = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || Fo;
      o.timeoutErrorMessage && (v = o.timeoutErrorMessage), s(
        new Y(
          v,
          A.clarifyTimeoutError ? Y.ETIMEDOUT : Y.ECONNABORTED,
          e,
          w
        )
      ), f(), w = null;
    }, r === void 0 && a.setContentType(null), "setRequestHeader" in w && T.forEach(Di(a), function(v, A) {
      w.setRequestHeader(A, v);
    }), T.isUndefined(o.withCredentials) || (w.withCredentials = !!o.withCredentials), i && i !== "json" && (w.responseType = o.responseType), c && ([p, _] = ps(c, !0), w.addEventListener("progress", p)), l && w.upload && ([m, g] = ps(l), w.upload.addEventListener("progress", m), w.upload.addEventListener("loadend", g)), (o.cancelToken || o.signal) && (h = (x) => {
      w && (s(!x || x.type ? new zn(null, e, w) : x), w.abort(), f(), w = null);
    }, o.cancelToken && o.cancelToken.subscribe(h), o.signal && (o.signal.aborted ? h() : o.signal.addEventListener("abort", h)));
    const b = fp(o.url);
    if (b && !Xe.protocols.includes(b)) {
      s(
        new Y(
          "Unsupported protocol " + b + ":",
          Y.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    w.send(r || null);
  });
}, kp = (e, t) => {
  if (e = e ? e.filter(Boolean) : [], !t && !e.length)
    return;
  const n = new AbortController();
  let s = !1;
  const o = function(l) {
    if (!s) {
      s = !0, a();
      const c = l instanceof Error ? l : this.reason;
      n.abort(
        c instanceof Y ? c : new zn(c instanceof Error ? c.message : c)
      );
    }
  };
  let r = t && setTimeout(() => {
    r = null, o(new Y(`timeout of ${t}ms exceeded`, Y.ETIMEDOUT));
  }, t);
  const a = () => {
    e && (r && clearTimeout(r), r = null, e.forEach((l) => {
      l.unsubscribe ? l.unsubscribe(o) : l.removeEventListener("abort", o);
    }), e = null);
  };
  e.forEach((l) => l.addEventListener("abort", o));
  const { signal: i } = n;
  return i.unsubscribe = () => T.asap(a), i;
}, Cp = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let s = 0, o;
  for (; s < n; )
    o = s + t, yield e.slice(s, o), s = o;
}, Tp = async function* (e, t) {
  for await (const n of Op(e))
    yield* Cp(n, t);
}, Op = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await t.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await t.cancel();
  }
}, jr = (e, t, n, s) => {
  const o = Tp(e, t);
  let r = 0, a, i = (l) => {
    a || (a = !0, s && s(l));
  };
  return new ReadableStream(
    {
      async pull(l) {
        try {
          const { done: c, value: h } = await o.next();
          if (c) {
            i(), l.close();
            return;
          }
          let m = h.byteLength;
          if (n) {
            let p = r += m;
            n(p);
          }
          l.enqueue(new Uint8Array(h));
        } catch (c) {
          throw i(c), c;
        }
      },
      cancel(l) {
        return i(l), o.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
};
function Ap(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const t = e.indexOf(",");
  if (t < 0) return 0;
  const n = e.slice(5, t), s = e.slice(t + 1);
  if (/;base64/i.test(n)) {
    let a = s.length;
    const i = s.length;
    for (let g = 0; g < i; g++)
      if (s.charCodeAt(g) === 37 && g + 2 < i) {
        const _ = s.charCodeAt(g + 1), f = s.charCodeAt(g + 2);
        (_ >= 48 && _ <= 57 || _ >= 65 && _ <= 70 || _ >= 97 && _ <= 102) && (f >= 48 && f <= 57 || f >= 65 && f <= 70 || f >= 97 && f <= 102) && (a -= 2, g += 2);
      }
    let l = 0, c = i - 1;
    const h = (g) => g >= 2 && s.charCodeAt(g - 2) === 37 && // '%'
    s.charCodeAt(g - 1) === 51 && // '3'
    (s.charCodeAt(g) === 68 || s.charCodeAt(g) === 100);
    c >= 0 && (s.charCodeAt(c) === 61 ? (l++, c--) : h(c) && (l++, c -= 3)), l === 1 && c >= 0 && (s.charCodeAt(c) === 61 || h(c)) && l++;
    const p = Math.floor(a / 4) * 3 - (l || 0);
    return p > 0 ? p : 0;
  }
  if (typeof Buffer < "u" && typeof Buffer.byteLength == "function")
    return Buffer.byteLength(s, "utf8");
  let r = 0;
  for (let a = 0, i = s.length; a < i; a++) {
    const l = s.charCodeAt(a);
    if (l < 128)
      r += 1;
    else if (l < 2048)
      r += 2;
    else if (l >= 55296 && l <= 56319 && a + 1 < i) {
      const c = s.charCodeAt(a + 1);
      c >= 56320 && c <= 57343 ? (r += 4, a++) : r += 3;
    } else
      r += 3;
  }
  return r;
}
const Vo = "1.16.1", qr = 64 * 1024, { isFunction: Jn } = T, Wr = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Sp = (e) => {
  const t = T.global !== void 0 && T.global !== null ? T.global : globalThis, { ReadableStream: n, TextEncoder: s } = t;
  e = T.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: t.Request,
      Response: t.Response
    },
    e
  );
  const { fetch: o, Request: r, Response: a } = e, i = o ? Jn(o) : typeof fetch == "function", l = Jn(r), c = Jn(a);
  if (!i)
    return !1;
  const h = i && Jn(n), m = i && (typeof s == "function" ? /* @__PURE__ */ ((u) => (b) => u.encode(b))(new s()) : async (u) => new Uint8Array(await new r(u).arrayBuffer())), p = l && h && Wr(() => {
    let u = !1;
    const b = new r(Xe.origin, {
      body: new n(),
      method: "POST",
      get duplex() {
        return u = !0, "half";
      }
    }), x = b.headers.has("Content-Type");
    return b.body != null && b.body.cancel(), u && !x;
  }), g = c && h && Wr(() => T.isReadableStream(new a("").body)), _ = {
    stream: g && ((u) => u.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((u) => {
    !_[u] && (_[u] = (b, x) => {
      let v = b && b[u];
      if (v)
        return v.call(b);
      throw new Y(
        `Response type '${u}' is not supported`,
        Y.ERR_NOT_SUPPORT,
        x
      );
    });
  });
  const f = async (u) => {
    if (u == null)
      return 0;
    if (T.isBlob(u))
      return u.size;
    if (T.isSpecCompliantForm(u))
      return (await new r(Xe.origin, {
        method: "POST",
        body: u
      }).arrayBuffer()).byteLength;
    if (T.isArrayBufferView(u) || T.isArrayBuffer(u))
      return u.byteLength;
    if (T.isURLSearchParams(u) && (u = u + ""), T.isString(u))
      return (await m(u)).byteLength;
  }, w = async (u, b) => {
    const x = T.toFiniteNumber(u.getContentLength());
    return x ?? f(b);
  };
  return async (u) => {
    let {
      url: b,
      method: x,
      data: v,
      signal: A,
      cancelToken: $,
      timeout: C,
      onDownloadProgress: B,
      onUploadProgress: D,
      responseType: F,
      headers: H,
      withCredentials: te = "same-origin",
      fetchOptions: Me,
      maxContentLength: j,
      maxBodyLength: U
    } = qi(u);
    const M = T.isNumber(j) && j > -1, K = T.isNumber(U) && U > -1;
    let V = o || fetch;
    F = F ? (F + "").toLowerCase() : "text";
    let J = kp(
      [A, $ && $.toAbortSignal()],
      C
    ), q = null;
    const oe = J && J.unsubscribe && (() => {
      J.unsubscribe();
    });
    let le;
    try {
      if (M && typeof b == "string" && b.startsWith("data:") && Ap(b) > j)
        throw new Y(
          "maxContentLength size of " + j + " exceeded",
          Y.ERR_BAD_RESPONSE,
          u,
          q
        );
      if (K && x !== "get" && x !== "head") {
        const ae = await w(H, v);
        if (typeof ae == "number" && isFinite(ae) && ae > U)
          throw new Y(
            "Request body larger than maxBodyLength limit",
            Y.ERR_BAD_REQUEST,
            u,
            q
          );
      }
      if (D && p && x !== "get" && x !== "head" && (le = await w(H, v)) !== 0) {
        let ae = new r(b, {
          method: "POST",
          body: v,
          duplex: "half"
        }), Be;
        if (T.isFormData(v) && (Be = ae.headers.get("content-type")) && H.setContentType(Be), ae.body) {
          const [ke, re] = Ur(
            le,
            ps(Vr(D))
          );
          v = jr(ae.body, qr, ke, re);
        }
      }
      T.isString(te) || (te = te ? "include" : "omit");
      const ne = l && "credentials" in r.prototype;
      if (T.isFormData(v)) {
        const ae = H.getContentType();
        ae && /^multipart\/form-data/i.test(ae) && !/boundary=/i.test(ae) && H.delete("content-type");
      }
      H.set("User-Agent", "axios/" + Vo, !1);
      const fe = {
        ...Me,
        signal: J,
        method: x.toUpperCase(),
        headers: Di(H.normalize()),
        body: v,
        duplex: "half",
        credentials: ne ? te : void 0
      };
      q = l && new r(b, fe);
      let be = await (l ? V(q, Me) : V(b, fe));
      if (M) {
        const ae = T.toFiniteNumber(be.headers.get("content-length"));
        if (ae != null && ae > j)
          throw new Y(
            "maxContentLength size of " + j + " exceeded",
            Y.ERR_BAD_RESPONSE,
            u,
            q
          );
      }
      const Ye = g && (F === "stream" || F === "response");
      if (g && be.body && (B || M || Ye && oe)) {
        const ae = {};
        ["status", "statusText", "headers"].forEach((Q) => {
          ae[Q] = be[Q];
        });
        const Be = T.toFiniteNumber(be.headers.get("content-length")), [ke, re] = B && Ur(
          Be,
          ps(Vr(B), !0)
        ) || [];
        let se = 0;
        const ie = (Q) => {
          if (M && (se = Q, se > j))
            throw new Y(
              "maxContentLength size of " + j + " exceeded",
              Y.ERR_BAD_RESPONSE,
              u,
              q
            );
          ke && ke(Q);
        };
        be = new a(
          jr(be.body, qr, ie, () => {
            re && re(), oe && oe();
          }),
          ae
        );
      }
      F = F || "text";
      let Te = await _[T.findKey(_, F) || "text"](
        be,
        u
      );
      if (M && !g && !Ye) {
        let ae;
        if (Te != null && (typeof Te.byteLength == "number" ? ae = Te.byteLength : typeof Te.size == "number" ? ae = Te.size : typeof Te == "string" && (ae = typeof s == "function" ? new s().encode(Te).byteLength : Te.length)), typeof ae == "number" && ae > j)
          throw new Y(
            "maxContentLength size of " + j + " exceeded",
            Y.ERR_BAD_RESPONSE,
            u,
            q
          );
      }
      return !Ye && oe && oe(), await new Promise((ae, Be) => {
        Hi(ae, Be, {
          data: Te,
          headers: tt.from(be.headers),
          status: be.status,
          statusText: be.statusText,
          config: u,
          request: q
        });
      });
    } catch (ne) {
      if (oe && oe(), J && J.aborted && J.reason instanceof Y) {
        const fe = J.reason;
        throw fe.config = u, q && (fe.request = q), ne !== fe && (fe.cause = ne), fe;
      }
      throw ne && ne.name === "TypeError" && /Load failed|fetch/i.test(ne.message) ? Object.assign(
        new Y(
          "Network Error",
          Y.ERR_NETWORK,
          u,
          q,
          ne && ne.response
        ),
        {
          cause: ne.cause || ne
        }
      ) : Y.from(ne, ne && ne.code, u, q, ne && ne.response);
    }
  };
}, Np = /* @__PURE__ */ new Map(), Wi = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: s, Response: o } = t, r = [s, o, n];
  let a = r.length, i = a, l, c, h = Np;
  for (; i--; )
    l = r[i], c = h.get(l), c === void 0 && h.set(l, c = i ? /* @__PURE__ */ new Map() : Sp(t)), h = c;
  return c;
};
Wi();
const Ho = {
  http: Xh,
  xhr: Ep,
  fetch: {
    get: Wi
  }
};
T.forEach(Ho, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: t });
  }
});
const zr = (e) => `- ${e}`, Lp = (e) => T.isFunction(e) || e === null || e === !1;
function $p(e, t) {
  e = T.isArray(e) ? e : [e];
  const { length: n } = e;
  let s, o;
  const r = {};
  for (let a = 0; a < n; a++) {
    s = e[a];
    let i;
    if (o = s, !Lp(s) && (o = Ho[(i = String(s)).toLowerCase()], o === void 0))
      throw new Y(`Unknown adapter '${i}'`);
    if (o && (T.isFunction(o) || (o = o.get(t))))
      break;
    r[i || "#" + a] = o;
  }
  if (!o) {
    const a = Object.entries(r).map(
      ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let i = n ? a.length > 1 ? `since :
` + a.map(zr).join(`
`) : " " + zr(a[0]) : "as no adapter specified";
    throw new Y(
      "There is no suitable adapter to dispatch the request " + i,
      "ERR_NOT_SUPPORT"
    );
  }
  return o;
}
const zi = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: $p,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ho
};
function Hs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zn(null, e);
}
function Yr(e) {
  return Hs(e), e.headers = tt.from(e.headers), e.data = Vs.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), zi.getAdapter(e.adapter || Wn.adapter, e)(e).then(
    function(s) {
      Hs(e), e.response = s;
      try {
        s.data = Vs.call(e, e.transformResponse, s);
      } finally {
        delete e.response;
      }
      return s.headers = tt.from(s.headers), s;
    },
    function(s) {
      if (!Vi(s) && (Hs(e), s && s.response)) {
        e.response = s.response;
        try {
          s.response.data = Vs.call(
            e,
            e.transformResponse,
            s.response
          );
        } finally {
          delete e.response;
        }
        s.response.headers = tt.from(s.response.headers);
      }
      return Promise.reject(s);
    }
  );
}
const Ls = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ls[e] = function(s) {
    return typeof s === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Gr = {};
Ls.transitional = function(t, n, s) {
  function o(r, a) {
    return "[Axios v" + Vo + "] Transitional option '" + r + "'" + a + (s ? ". " + s : "");
  }
  return (r, a, i) => {
    if (t === !1)
      throw new Y(
        o(a, " has been removed" + (n ? " in " + n : "")),
        Y.ERR_DEPRECATED
      );
    return n && !Gr[a] && (Gr[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(r, a, i) : !0;
  };
};
Ls.spelling = function(t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function Ip(e, t, n) {
  if (typeof e != "object")
    throw new Y("options must be an object", Y.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let o = s.length;
  for (; o-- > 0; ) {
    const r = s[o], a = Object.prototype.hasOwnProperty.call(t, r) ? t[r] : void 0;
    if (a) {
      const i = e[r], l = i === void 0 || a(i, r, e);
      if (l !== !0)
        throw new Y(
          "option " + r + " must be " + l,
          Y.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (n !== !0)
      throw new Y("Unknown option " + r, Y.ERR_BAD_OPTION);
  }
}
const ts = {
  assertOptions: Ip,
  validators: Ls
}, ht = ts.validators;
let Jt = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Fr(),
      response: new Fr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const r = (() => {
          if (!o.stack)
            return "";
          const a = o.stack.indexOf(`
`);
          return a === -1 ? "" : o.stack.slice(a + 1);
        })();
        try {
          if (!s.stack)
            s.stack = r;
          else if (r) {
            const a = r.indexOf(`
`), i = a === -1 ? -1 : r.indexOf(`
`, a + 1), l = i === -1 ? "" : r.slice(i + 1);
            String(s.stack).endsWith(l) || (s.stack += `
` + r);
          }
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = tn(this.defaults, n);
    const { transitional: s, paramsSerializer: o, headers: r } = n;
    s !== void 0 && ts.assertOptions(
      s,
      {
        silentJSONParsing: ht.transitional(ht.boolean),
        forcedJSONParsing: ht.transitional(ht.boolean),
        clarifyTimeoutError: ht.transitional(ht.boolean),
        legacyInterceptorReqResOrdering: ht.transitional(ht.boolean)
      },
      !1
    ), o != null && (T.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : ts.assertOptions(
      o,
      {
        encode: ht.function,
        serialize: ht.function
      },
      !0
    )), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ts.assertOptions(
      n,
      {
        baseUrl: ht.spelling("baseURL"),
        withXsrfToken: ht.spelling("withXSRFToken")
      },
      !0
    ), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = r && T.merge(r.common, r[n.method]);
    r && T.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (_) => {
      delete r[_];
    }), n.headers = tt.concat(a, r);
    const i = [];
    let l = !0;
    this.interceptors.request.forEach(function(f) {
      if (typeof f.runWhen == "function" && f.runWhen(n) === !1)
        return;
      l = l && f.synchronous;
      const w = n.transitional || Fo;
      w && w.legacyInterceptorReqResOrdering ? i.unshift(f.fulfilled, f.rejected) : i.push(f.fulfilled, f.rejected);
    });
    const c = [];
    this.interceptors.response.forEach(function(f) {
      c.push(f.fulfilled, f.rejected);
    });
    let h, m = 0, p;
    if (!l) {
      const _ = [Yr.bind(this), void 0];
      for (_.unshift(...i), _.push(...c), p = _.length, h = Promise.resolve(n); m < p; )
        h = h.then(_[m++], _[m++]);
      return h;
    }
    p = i.length;
    let g = n;
    for (; m < p; ) {
      const _ = i[m++], f = i[m++];
      try {
        g = _(g);
      } catch (w) {
        f.call(this, w);
        break;
      }
    }
    try {
      h = Yr.call(this, g);
    } catch (_) {
      return Promise.reject(_);
    }
    for (m = 0, p = c.length; m < p; )
      h = h.then(c[m++], c[m++]);
    return h;
  }
  getUri(t) {
    t = tn(this.defaults, t);
    const n = ji(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Fi(n, t.params, t.paramsSerializer);
  }
};
T.forEach(["delete", "get", "head", "options"], function(t) {
  Jt.prototype[t] = function(n, s) {
    return this.request(
      tn(s || {}, {
        method: t,
        url: n,
        data: (s || {}).data
      })
    );
  };
});
T.forEach(["post", "put", "patch", "query"], function(t) {
  function n(s) {
    return function(r, a, i) {
      return this.request(
        tn(i || {}, {
          method: t,
          headers: s ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: r,
          data: a
        })
      );
    };
  }
  Jt.prototype[t] = n(), t !== "query" && (Jt.prototype[t + "Form"] = n(!0));
});
let Pp = class Yi {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(r) {
      n = r;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners) return;
      let r = s._listeners.length;
      for (; r-- > 0; )
        s._listeners[r](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let r;
      const a = new Promise((i) => {
        s.subscribe(i), r = i;
      }).then(o);
      return a.cancel = function() {
        s.unsubscribe(r);
      }, a;
    }, t(function(r, a, i) {
      s.reason || (s.reason = new zn(r, a, i), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Yi(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
function Dp(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Rp(e) {
  return T.isObject(e) && e.isAxiosError === !0;
}
const io = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(io).forEach(([e, t]) => {
  io[t] = e;
});
function Gi(e) {
  const t = new Jt(e), n = Oi(Jt.prototype.request, t);
  return T.extend(n, Jt.prototype, t, { allOwnKeys: !0 }), T.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return Gi(tn(e, o));
  }, n;
}
const De = Gi(Wn);
De.Axios = Jt;
De.CanceledError = zn;
De.CancelToken = Pp;
De.isCancel = Vi;
De.VERSION = Vo;
De.toFormData = Ns;
De.AxiosError = Y;
De.Cancel = De.CanceledError;
De.all = function(t) {
  return Promise.all(t);
};
De.spread = Dp;
De.isAxiosError = Rp;
De.mergeConfig = tn;
De.AxiosHeaders = tt;
De.formToJSON = (e) => Ui(T.isHTMLForm(e) ? new FormData(e) : e);
De.getAdapter = zi.getAdapter;
De.HttpStatusCode = io;
De.default = De;
const {
  Axios: gv,
  AxiosError: bv,
  CanceledError: wv,
  isCancel: yv,
  CancelToken: vv,
  VERSION: _v,
  all: xv,
  Cancel: Ev,
  isAxiosError: kv,
  spread: Cv,
  toFormData: Tv,
  AxiosHeaders: Ov,
  HttpStatusCode: Av,
  formToJSON: Sv,
  getAdapter: Nv,
  mergeConfig: Lv,
  create: $v
} = De;
function Ki(e) {
  const t = G(null), n = G(!1), s = G(null), o = G({}), r = dl({}), a = G(0), i = async (u) => {
    n.value = !0, s.value = null;
    try {
      t.value = await e.getMenuByQr(u);
    } catch (b) {
      s.value = b.message || "無法載入菜單";
    } finally {
      n.value = !1;
    }
  }, l = async (u) => {
    try {
      o.value = await e.getImages(u);
    } catch {
    } finally {
    }
  }, c = () => {
    Object.keys(r).forEach((u) => {
      delete r[u];
    });
  }, h = (u) => {
    const b = r[u] || 0;
    b < 7 && a.value < 20 && (r[u] = b + 1, a.value++);
  }, m = (u) => {
    r[u] && r[u] > 0 && (r[u]--, a.value--, r[u] === 0 && delete r[u]);
  }, p = me(() => t.value ? t.value.items.reduce((b, x) => {
    const v = r[x.id] || 0;
    if (v <= 0) return b;
    const A = new Rt(x.price).times(v);
    return b.plus(A);
  }, new Rt(0)).toString() : "0"), g = async (u, b) => {
    if (!u) {
      s.value = "遺失桌號資訊 (QR code)，無法下單";
      return;
    }
    if (!(!t.value || Object.keys(r).length === 0)) {
      n.value = !0;
      try {
        const x = (b == null ? void 0 : b.nickname) || "", v = (b == null ? void 0 : b.memo1) || "", A = {
          merchantId: t.value.merchantId,
          tableNumber: t.value.tableNumber,
          qr: u,
          items: Object.entries(r).map(([C, B]) => ({ menuItemId: C, quantity: B })),
          nickname: x,
          memo1: v
        };
        return await e.submitOrder(A);
      } catch (x) {
        throw s.value = x.message || "送單失敗", x;
      } finally {
        n.value = !1;
      }
    }
  };
  return {
    menuData: t,
    loading: n,
    error: s,
    cart: r,
    totalCounter: a,
    loadMenu: i,
    addToCart: h,
    removeFromCart: m,
    totalPrice: p,
    handleOrderSubmit: async (u, b) => {
      var x, v, A, $;
      try {
        const C = (b == null ? void 0 : b.nickname) || "", B = (b == null ? void 0 : b.memo1) || "", D = await g(u, {
          nickname: C,
          memo1: B
        });
        if (D)
          return await _e.fire({
            title: "Order placed successfully！",
            text: `Order Number: ${D}`,
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), c(), D;
      } catch (C) {
        let B = "請確認網路連線或聯繫服務人員", D = "UNKNOWN_ERROR";
        throw De.isAxiosError(C) ? (D = ((v = (x = C.response) == null ? void 0 : x.data) == null ? void 0 : v.error_code) || D, B = (($ = (A = C.response) == null ? void 0 : A.data) == null ? void 0 : $.message) || C.message) : C instanceof Error && (B = C.message), _e.fire({
          title: "下單失敗",
          text: B,
          icon: "error",
          footer: `錯誤代碼: ${D}`
        }), C;
      }
    },
    handlePaymentSubmit: async (u) => {
      if (!u.qr || typeof u.qr != "string" || u.qr.trim() === "")
        return Ne.error("handlePaymentSubmit Validation Error: QR code is missing or invalid"), !1;
      if (!Array.isArray(u.ids) || u.ids.length === 0)
        return Ne.error("handlePaymentSubmit Validation Error: No order IDs selected"), !1;
      if (!u.merchant_id || typeof u.merchant_id != "string" || u.merchant_id.trim() === "")
        return Ne.error("handlePaymentSubmit Validation Error: Merchant ID is missing or invalid"), !1;
      try {
        Ne.log("handlePaymentSubmit payload:", u);
        const b = await e.handlePayment(u);
        if (b) {
          if (b == "BFFErrSvcBatchProcessAmountLimit")
            return b;
          document.body.appendChild(b), b.submit();
        }
        return !0;
      } catch (b) {
        return Ne.error("Payment error:", b), !1;
      }
    },
    images: o,
    loadImg: l,
    queryCompanyName: async (u) => await e.queryCompanyName(u)
  };
}
function Xi(e) {
  const t = G([]), n = G(!1), s = G(null), o = async (i) => {
    if (i) {
      n.value = !0, s.value = null;
      try {
        const l = await e.getTableOrders(i);
        t.value = Array.isArray(l) ? l : [];
      } catch (l) {
        s.value = l.message || "無法載入訂單紀錄", console.error("OrderHistory Error:", l);
      } finally {
        n.value = !1;
      }
    }
  }, r = async (i) => {
    if (i) {
      n.value = !0, s.value = null;
      try {
        const l = await e.getTableSessionOrders(i);
        t.value = Array.isArray(l) ? l : [];
      } catch (l) {
        s.value = l.message || "無法載入訂單紀錄", console.error("OrderHistory Error:", l);
      } finally {
        n.value = !1;
      }
    }
  }, a = me(() => t.value.reduce((l, c) => {
    const h = c.subtotal || "0";
    return l.plus(new Rt(h));
  }, new Rt(0)).toString());
  return {
    orderHistory: t,
    historyLoading: n,
    historyError: s,
    loadOrderHistory: o,
    loadOrderHistorySession: r,
    cumulativeTotal: a
  };
}
function Mp(e, t, n, s, o) {
  const r = G([]), a = G("0"), i = (f) => {
    r.value = f.ids, a.value = f.total;
  }, l = G("All"), c = me(() => {
    var b;
    const f = ((b = e.value) == null ? void 0 : b.categoryItem) || [], w = /* @__PURE__ */ new Map();
    return f.forEach((x) => {
      x.category && (!w.has(x.category) || x.orderNum < w.get(x.category)) && w.set(x.category, x.orderNum);
    }), Array.from(w.entries()).map(([x, v]) => ({
      name: x,
      order: v
    })).sort((x, v) => x.order - v.order || x.name.localeCompare(v.name)).map((x) => x.name);
  }), h = me(() => {
    var w;
    const f = ((w = e.value) == null ? void 0 : w.items) || [];
    return l.value === "All" ? f : f.filter((u) => u.category === l.value);
  }), m = [
    "杏簾招客飲，在望有山莊",
    "菱荇鵝兒水，桑榆燕子梁",
    "一畦春韭綠，十里稻花香",
    "盛世無飢餒，何須耕織忙"
  ], p = G(m[0]);
  vt(n, () => {
    const f = (m.indexOf(p.value) + 1) % m.length;
    p.value = m[f];
  });
  const g = (f) => f ? f.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;") : "";
  return {
    selectedOrderIds: r,
    selectedTotal: a,
    handleSelectionChange: i,
    selectedCategory: l,
    availableCategories: c,
    filteredItems: h,
    formatOrderHtml: (f, w, u) => {
      const b = f.map((x) => {
        const v = x.name ? g(x.name) : u("menu.unknownItem"), A = Number(x.price).toFixed(2), $ = Number(x.subtotal).toFixed(2);
        return `
        <li style="border-bottom: 1px solid #f3f4f6; padding: 12px 4px; display: flex; justify-content: space-between; align-items: center;">
          <div style="flex: 1; min-width: 0; padding-right: 8px;">
            <div style="font-weight: 600; color: #1f2937; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" title="${v}">
              ${v}
            </div>
            <div style="font-size: 0.85em; color: #6b7280; margin-top: 2px;">
              $${A} x ${x.quantity}
            </div>
          </div>
          <div style="font-weight: 700; color: #111827; flex-shrink: 0;">
            $${$}
          </div>
        </li>
      `;
      }).join("");
      return `
      <div style="text-align: left; max-height: 260px; overflow-y: auto; font-family: system-ui, -apple-system, sans-serif; padding-right: 4px;">
        <div style="border-bottom: 2px solid #3b82f6; padding-bottom: 8px; margin-bottom: 4px; font-weight: bold; display: flex; justify-content: space-between; color: #4b5563; font-size: 0.9em;">
          <span>${u("menu.item")}</span>
          <span>${u("menu.subtotal")}</span>
        </div>
        <ul style="list-style: none; padding: 0; margin: 0;">${b}</ul>
        <div style="margin-top: 16px; padding-top: 12px; border-top: 2px solid #f3f4f6; text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <span style="color: #4b5563; margin-right: 8px; font-weight: 500;">${u("menu.orderTotal")}:</span>
          <span style="font-size: 1.4em; font-weight: 800; color: #2563eb;">$${Number(w).toFixed(2)}</span>
        </div>
      </div>`;
    },
    currentQuote: p
  };
}
function Bp() {
  const e = (s) => {
    var o, r, a, i;
    return {
      carrier_num: ((o = s.carrier_num) == null ? void 0 : o.trim().toUpperCase()) || "",
      customer_identifier: ((r = s.customer_identifier) == null ? void 0 : r.replace(/\D/g, "").slice(0, 8)) || "",
      customer_name: ((a = s.customer_name) == null ? void 0 : a.trim()) || "",
      customer_email: ((i = s.customer_email) == null ? void 0 : i.trim()) || ""
    };
  }, t = (s) => {
    if (!/^\d{8}$/.test(s)) return !1;
    const o = [1, 2, 1, 2, 1, 2, 4, 1];
    let r = 0, a = 0;
    for (let i = 0; i < 8; i++) {
      const l = parseInt(s.charAt(i), 10) * o[i];
      if (l >= 10) {
        const c = Math.floor(l / 10), h = l % 10;
        i === 6 && c === 7 ? (r += 7, a += 8) : (r += c + h, a += c + h);
      } else
        r += l, a += l;
    }
    return r % 5 === 0 || a % 5 === 0;
  };
  return { normalizeForm: e, validateUBN: t, validateForm: (s) => {
    if (s.carrier_num && !/^\/[0-9A-Z.+-]{7}$/.test(s.carrier_num))
      return "手機條碼格式需為 /ABC1234，共 8 碼";
    if (s.customer_identifier) {
      if (s.customer_identifier.length !== 8) return "統一編號需為 8 碼數字";
      if (!t(s.customer_identifier)) return "統一編號格式驗證失敗";
      if (!s.customer_name) return "填寫統一編號時，請一併填入公司全名";
    }
    return s.customer_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.customer_email) ? "CustomerEmail 格式不正確" : "";
  } };
}
function Fp(e, t, n, s) {
  const o = G([]), r = G(0);
  let a = null;
  const i = 4e3, l = async (m) => {
    if (!m || !t.value) return;
    await n(m);
    const p = Array.from({ length: 10 }, (_, f) => {
      var x;
      const w = (f + 1).toString();
      if (!((x = t.value) != null && x[w])) return Promise.resolve(null);
      const u = t.value[w], b = `${s}${m}-${w}?t=${u}`;
      return new Promise((v) => {
        const A = new Image();
        A.src = b, A.onload = () => v(b), A.onerror = () => v(null);
      });
    }), g = await Promise.all(p);
    o.value = g.filter((_) => _ !== null);
  }, c = () => {
    a || o.value.length <= 1 || (a = setInterval(() => {
      const m = e.value;
      if (!m) return;
      const p = m.firstElementChild;
      if (!p) return;
      const g = p.offsetWidth + 14;
      r.value = (Math.round(m.scrollLeft / g) + 1) % o.value.length, m.scrollTo({ left: r.value * g, behavior: "smooth" });
    }, i));
  }, h = () => {
    a && (clearInterval(a), a = null);
  };
  return vt(o, (m) => {
    m.length > 1 && setTimeout(c, 1e3);
  }, { immediate: !0 }), Qr(h), { activeImages: o, currentIndex: r, checkAndLoadImages: l, startAutoplay: c, stopAutoplay: h };
}
const Up = { class: "flex items-center gap-2 mb-4 px-1" }, Vp = { class: "text-sm font-bold text-gray-700 uppercase tracking-widest" }, Hp = /* @__PURE__ */ Ee({
  __name: "SectionHeader",
  props: {
    title: {},
    color: {}
  },
  setup(e) {
    return (t, n) => (L(), I("div", Up, [
      d("span", {
        class: Ae(["w-2 h-2 rounded-full shadow-sm", e.color || "bg-gray-400"])
      }, null, 2),
      d("h3", Vp, O(e.title), 1)
    ]));
  }
}), Kr = /* @__PURE__ */ kn(Hp, [["__scopeId", "data-v-6c1361b7"]]), jp = { class: "w-full bg-white border-t border-gray-100 pb-[env(safe-area-inset-bottom,1rem)]" }, qp = { class: "max-w-screen-md mx-auto p-4 flex items-center gap-4" }, Wp = { class: "flex-1 flex flex-col" }, zp = { class: "text-[10px] text-blue-700 font-bold uppercase tracking-wider" }, Yp = { class: "text-xl font-black text-gray-700" }, Gp = { class: "bg-green-700/50 px-2 py-0.5 rounded text-xs" }, Kp = { class: "flex-1 flex flex-col" }, Xp = { class: "text-[10px] text-gray-400 font-bold uppercase tracking-wider" }, Jp = { class: "text-xl font-black text-gray-700" }, Zp = ["disabled"], Qp = { class: "flex items-center justify-center gap-2" }, eg = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 opacity-50",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, tg = /* @__PURE__ */ Ee({
  __name: "OrderFooter",
  props: {
    totalPrice: {},
    loading: { type: Boolean },
    selectedIds: {},
    selectedTotal: {},
    showName: {}
  },
  emits: ["submit", "checkout"],
  setup(e) {
    Ne.log("OrderFooter.vue");
    const { t } = St();
    return (n, s) => {
      var o, r, a, i, l;
      return L(), I("section", jp, [
        d("div", qp, [
          e.selectedIds && e.selectedIds.length > 0 ? (L(), I(Fe, { key: 0 }, [
            d("div", Wp, [
              d("span", zp, O((o = k(t)) == null ? void 0 : o("menu.selectedAmount")), 1),
              d("span", Yp, "$" + O(e.selectedTotal || 0), 1)
            ]),
            d("button", {
              onClick: s[0] || (s[0] = (c) => n.$emit("checkout")),
              class: "flex-[1.5] relative overflow-hidden bg-green-700 text-white py-4 rounded-2xl font-black shadow-lg shadow-green-100 active:scale-95 transition-all flex items-center justify-center gap-2 border-b-4 border-green-700"
            }, [
              d("span", null, O((r = k(t)) == null ? void 0 : r("order.checkout")), 1),
              d("span", Gp, O(e.selectedIds.length) + " " + O((a = k(t)) == null ? void 0 : a("menu.itemsUnit")), 1)
            ])
          ], 64)) : (L(), I(Fe, { key: 1 }, [
            d("div", Kp, [
              d("span", Xp, O((i = k(t)) == null ? void 0 : i("menu.subtotal")), 1),
              d("span", Jp, "$" + O(e.totalPrice), 1)
            ]),
            d("button", {
              onClick: s[1] || (s[1] = (c) => n.$emit("submit")),
              disabled: e.loading,
              class: "flex-[1.5] relative overflow-hidden group bg-blue-700 disabled:bg-gray-100 text-white py-4 rounded-2xl font-black shadow-lg shadow-blue-100 active:scale-95 transition-all border-b-4 border-blue-700 disabled:border-gray-700"
            }, [
              s[3] || (s[3] = d("div", { class: "absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shine pointer-events-none" }, null, -1)),
              d("div", Qp, [
                d("span", null, O(e.loading ? (l = k(t)) == null ? void 0 : l("menu.processing") : e.showName), 1),
                e.loading ? Z("", !0) : (L(), I("svg", eg, [...s[2] || (s[2] = [
                  d("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "3",
                    d: "M14 5l7 7m0 0l-7 7m7-7H3"
                  }, null, -1)
                ])]))
              ])
            ], 8, Zp)
          ], 64))
        ])
      ]);
    };
  }
}), Ji = /* @__PURE__ */ kn(tg, [["__scopeId", "data-v-ab532642"]]), Zi = /* @__PURE__ */ Ee({
  __name: "AddButton",
  emits: ["click"],
  setup(e) {
    return (t, n) => (L(), I("button", {
      type: "button",
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: "menu-action-btn"
    }, [...n[1] || (n[1] = [
      d("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "w-5 h-5",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
      }, [
        d("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2.5",
          d: "M12 4v16m8-8H4"
        })
      ], -1)
    ])]));
  }
}), Qi = /* @__PURE__ */ Ee({
  __name: "RemoveButton",
  emits: ["click"],
  setup(e) {
    return (t, n) => (L(), I("button", {
      type: "button",
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: "menu-action-btn bg-white text-blue-700 border border-blue-100"
    }, [...n[1] || (n[1] = [
      d("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "w-5 h-5",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
      }, [
        d("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2.5",
          d: "M20 12H4"
        })
      ], -1)
    ])]));
  }
}), ng = { class: "space-y-3" }, sg = { class: "flex-1" }, og = { class: "font-bold text-gray-700" }, rg = {
  key: 0,
  class: "text-xs bg-sky-700 text-white"
}, ag = { class: "text-blue-700 font-mono font-bold text-lg" }, ig = { class: "menu-controls-pill flex items-center bg-gray-100 rounded-full px-2 py-1 gap-2" }, lg = {
  key: 1,
  class: "text-lg font-black text-gray-700 min-w-[1.5rem] text-center tabular-nums"
}, cg = /* @__PURE__ */ Ee({
  __name: "MenuItemList",
  props: {
    items: {},
    cart: {},
    totalCount: {},
    onAdd: { type: Function },
    onRemove: { type: Function }
  },
  setup(e) {
    const { t } = St(), n = e;
    return me(() => Object.values(n.cart).reduce((s, o) => s + o, 0)), (s, o) => {
      var r, a;
      return L(), I("main", ng, [
        (L(!0), I(Fe, null, Je(e.items, (i) => (L(), I("div", {
          key: i.id,
          class: "menu-item-row flex items-center justify-between p-3 bg-white rounded-lg shadow-sm"
        }, [
          d("div", sg, [
            d("h3", og, O(i.name), 1),
            i.description ? (L(), I("p", rg, O(i.description), 1)) : Z("", !0),
            d("p", ag, "$ " + O(i.price), 1)
          ]),
          d("div", ig, [
            e.cart[i.id] ? (L(), ct(Qi, {
              key: 0,
              onClick: (l) => e.onRemove(i.id)
            }, null, 8, ["onClick"])) : Z("", !0),
            e.cart[i.id] ? (L(), I("span", lg, O(e.cart[i.id]), 1)) : Z("", !0),
            (e.cart[i.id] || 0) < 7 && e.totalCount < 20 ? (L(), ct(Zi, {
              key: 2,
              onClick: (l) => e.onAdd(i.id)
            }, null, 8, ["onClick"])) : Z("", !0)
          ])
        ]))), 128)),
        e.totalCount >= 10 ? (L(), I("div", {
          key: 0,
          class: Ae(["text-right text-[10px] font-bold", e.totalCount >= 20 ? "text-red-700" : "text-orange-400"])
        }, O((r = k(t)) == null ? void 0 : r("menu.currentNum")) + ": " + O(e.totalCount) + " / 20 " + O(e.totalCount >= 20 ? (a = k(t)) == null ? void 0 : a("menu.orderMaxNum") : ""), 3)) : Z("", !0)
      ]);
    };
  }
}), ug = { class: "sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b py-4 mb-6 shadow-sm -mx-4 px-4" }, dg = { class: "flex justify-between max-w-screen-md mx-auto" }, fg = { class: "flex items-center gap-3 cursor-pointer" }, mg = ["checked", "indeterminate"], hg = { class: "text-sm font-black" }, pg = { class: "text-[10px] text-gray-400" }, gg = { class: "text-right" }, bg = { class: "text-[10px] text-gray-400" }, wg = { class: "text-2xl font-black text-blue-700" }, yg = /* @__PURE__ */ Ee({
  __name: "OrderListHeader",
  props: {
    isAllSelected: { type: Boolean },
    isIndeterminate: { type: Boolean },
    selectedCount: {},
    total: {},
    t: { type: Function }
  },
  emits: ["toggle-all"],
  setup(e) {
    const t = e, n = (s) => {
      var o;
      return ((o = t.t) == null ? void 0 : o.call(t, s)) ?? s;
    };
    return (s, o) => (L(), I("div", ug, [
      d("div", dg, [
        d("label", fg, [
          d("input", {
            type: "checkbox",
            checked: e.isAllSelected,
            indeterminate: e.isIndeterminate,
            onChange: o[0] || (o[0] = (r) => s.$emit("toggle-all")),
            class: "w-6 h-6 rounded-lg"
          }, null, 40, mg),
          d("div", null, [
            d("div", hg, O(n("checkoutBar.selectAll")), 1),
            d("div", pg, O(n("checkoutBar.itemsSelected").replace("{count}", String(e.selectedCount))), 1)
          ])
        ]),
        d("div", gg, [
          d("div", bg, O(n("checkoutBar.totalAmount")), 1),
          d("div", wg, " $" + O(Number(e.total).toLocaleString()), 1)
        ])
      ])
    ]));
  }
}), vg = /* @__PURE__ */ Ee({
  __name: "ItemStatusControl",
  props: {
    status: {},
    isLocked: { type: Boolean },
    isSmall: { type: Boolean },
    ostatus: {},
    showAdd: { type: Boolean, default: !0 }
  },
  emits: ["change"],
  setup(e) {
    const t = e, n = me(
      () => ta(t.status)
    ), s = me(
      () => t.status !== Lt.SERVED && An.includes(t.status)
    ), o = me(
      () => t.ostatus === je.NEW && t.status !== Lt.CANCEL && An.includes(t.status) || t.ostatus === je.PAID && t.status !== Lt.NEW && An.includes(t.status)
    ), r = (a) => [
      "w-7 h-7 flex items-center justify-center transition-all duration-100",
      a ? "opacity-40 grayscale contrast-50 cursor-not-allowed scale-95 pointer-events-none" : "opacity-100 grayscale-0 active:scale-90"
    ];
    return (a, i) => (L(), I("div", {
      class: Ae(["menu-controls-pill bg-white shadow-sm flex items-center px-1", [
        e.isSmall ? "min-w-[110px] h-8" : "min-w-[120px]",
        e.showAdd ? "justify-between" : "justify-center"
      ]])
    }, [
      e.showAdd ? (L(), ct(Qi, {
        key: 0,
        disabled: !o.value || e.isLocked,
        onClick: i[0] || (i[0] = (l) => a.$emit("change", -1)),
        class: Ae(r(!o.value || e.isLocked))
      }, null, 8, ["disabled", "class"])) : Z("", !0),
      d("span", {
        class: Ae([
          "text-[10px] font-black px-2 py-0.5 rounded-full text-center min-w-[50px]",
          e.isLocked ? "bg-gray-100 text-gray-400" : n.value.color
        ])
      }, O(n.value.text), 3),
      e.showAdd ? (L(), ct(Zi, {
        key: 1,
        disabled: !s.value || e.isLocked,
        onClick: i[1] || (i[1] = (l) => a.$emit("change", 1)),
        class: Ae(r(!s.value || e.isLocked))
      }, null, 8, ["disabled", "class"])) : Z("", !0)
    ], 2));
  }
});
function _g() {
  const e = G({});
  return {
    expandedGroups: e,
    getGroupedItems: (a) => a ? a.reduce((i, l) => (i[l.item_name] || (i[l.item_name] = []), i[l.item_name].push(l), i), {}) : {},
    getItemTotal: (a) => a.reduce((i, l) => l.status !== Lt.CANCEL ? i + Number(l.unit_price) : i, 0),
    toggleGroup: (a, i) => {
      const l = `${a}-${i}`;
      e.value[l] = !e.value[l];
    },
    isExpanded: (a, i) => !!e.value[`${a}-${i}`],
    getStatusInfo: (a) => ta(a) || { text: "未知", color: "bg-gray-100 text-gray-600" }
  };
}
const xg = { class: "flex gap-4" }, Eg = { class: "pt-1" }, kg = ["checked", "disabled"], Cg = { class: "flex-1 flex flex-col gap-2" }, Tg = { class: "flex items-center gap-3" }, Og = {
  key: 0,
  class: "bg-blue-700 text-white text-[10px] font-black px-2 py-0.5 rounded-full"
}, Ag = {
  key: 1,
  class: "bg-blue-700 text-white text-[10px] font-black px-2 py-0.5 rounded-full"
}, Sg = {
  key: 2,
  class: "text-xs font-black text-gray-700 bg-amber-100 px-2 py-0.5 rounded-md border border-amber-200"
}, Ng = { class: "font-mono text-xs font-bold text-gray-400" }, Lg = { class: "flex items-center gap-2 text-[10px] font-bold text-gray-400" }, $g = { class: "text-blue-700" }, Ig = { class: "flex items-center justify-between" }, Pg = { class: "text-right" }, Dg = { class: "text-[10px] text-gray-400 font-bold block leading-none" }, Rg = { class: "text-blue-700 font-black text-lg tracking-tight" }, Mg = {
  key: 0,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, Bg = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, Fg = { class: "space-y-3" }, Ug = ["onClick"], Vg = { class: "flex items-center gap-2" }, Hg = { class: "text-gray-700 font-bold" }, jg = {
  key: 0,
  class: "text-[10px] bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded-md font-black"
}, qg = { class: "flex items-center gap-3" }, Wg = {
  key: 0,
  class: "flex items-center gap-1"
}, zg = { class: "text-[10px] text-gray-400 font-bold" }, Yg = { class: "font-mono font-bold text-gray-900 min-w-[45px] text-right" }, Gg = {
  key: 0,
  class: "mt-2 ml-4 space-y-2 border-l-2 border-blue-50 pl-3 py-1"
}, Kg = { class: "flex items-center gap-3" }, Xg = { class: "font-mono font-bold text-gray-400 text-xs min-w-[35px] text-right" }, el = /* @__PURE__ */ Ee({
  __name: "OrderCard",
  props: {
    order: {},
    isSelected: { type: Boolean },
    sessionIndex: {},
    index: {},
    length: {},
    showAdd: { type: Boolean },
    disableStatus: {},
    disabled: { type: Boolean }
  },
  emits: ["status-change", "toggle-selection"],
  setup(e) {
    const t = localStorage.getItem("merchant_tz") || "UTC", { t: n } = St();
    Ne.log("OrderCard.vue");
    const s = (l, c) => l !== Lt.CANCEL ? c : 0, { getGroupedItems: o, getItemTotal: r, toggleGroup: a, isExpanded: i } = _g();
    return (l, c) => {
      var h, m, p;
      return L(), I("div", {
        class: Ae(["menu-history-card flex flex-col gap-4 p-4 transition-all border rounded-2xl bg-white", {
          "ring-2 ring-blue-700 bg-blue-50/30 border-transparent": e.isSelected,
          "border-gray-100": !e.isSelected,
          "opacity-50 pointer-events-none bg-gray-50/50": e.disabled
        }])
      }, [
        d("div", xg, [
          d("div", Eg, [
            d("input", {
              type: "checkbox",
              checked: e.isSelected,
              onChange: c[0] || (c[0] = (g) => l.$emit("toggle-selection", e.order.id)),
              disabled: e.disabled || e.disableStatus !== void 0 && e.order.status === e.disableStatus,
              class: "menu-checkbox w-5 h-5 rounded border-gray-700 text-blue-700 focus:ring-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
            }, null, 40, kg)
          ]),
          d("div", Cg, [
            d("div", Tg, [
              e.sessionIndex ? (L(), I("span", Og, " #" + O(e.sessionIndex), 1)) : (L(), I("span", Ag, " #" + O(e.index + 1), 1)),
              (h = e.order.info) != null && h.nickname ? (L(), I("span", Sg, " 👤 " + O(e.order.info.nickname), 1)) : Z("", !0),
              d("span", Ng, O(String(e.order.id).slice(-3)), 1),
              d("div", Lg, [
                c[1] || (c[1] = d("span", { class: "text-gray-700" }, "|", -1)),
                d("span", $g, O(k(na)(e.order.created_at, k(t))), 1)
              ])
            ]),
            d("div", Ig, [
              d("span", {
                class: Ae([
                  "text-[10px] px-2 py-0.5 rounded-md font-black uppercase tracking-wider shadow-sm",
                  k(js)(e.order.status).color
                ])
              }, O(k(js)(e.order.status).text), 3),
              d("div", Pg, [
                d("span", Dg, O(((m = k(n)) == null ? void 0 : m("order.subtotal")) ?? "SUBTOTAL"), 1),
                d("span", Rg, " $" + O(e.order.subtotal), 1)
              ])
            ]),
            (p = e.order.info) != null && p.memo1 ? (L(), I("div", Mg, [
              c[2] || (c[2] = d("span", { class: "text-xs" }, "📝", -1)),
              d("p", Bg, O(e.order.info.memo1), 1)
            ])) : Z("", !0)
          ])
        ]),
        c[4] || (c[4] = d("hr", { class: "border-gray-50" }, null, -1)),
        d("div", Fg, [
          (L(!0), I(Fe, null, Je(k(o)(e.order.items), (g, _) => {
            var f, w;
            return L(), I("div", {
              key: _,
              class: "border-b border-gray-50 last:border-0 pb-2"
            }, [
              d("div", {
                class: "flex justify-between items-center text-sm cursor-pointer hover:bg-gray-50/50 rounded-lg p-1 transition-colors",
                onClick: (u) => g.length > 0 ? k(a)(e.order.id, _) : null
              }, [
                d("div", Vg, [
                  d("span", Hg, O(_), 1),
                  g.length > 0 ? (L(), I("span", jg, " x" + O(g.length), 1)) : Z("", !0)
                ]),
                d("div", qg, [
                  g.length > 0 ? (L(), I("div", Wg, [
                    d("span", zg, O(k(i)(e.order.id, _) ? ((f = k(n)) == null ? void 0 : f("common.collapse")) ?? "收" : ((w = k(n)) == null ? void 0 : w("common.expand")) ?? "開"), 1),
                    (L(), I("svg", {
                      class: Ae(["w-3 h-3 text-gray-700 transition-transform duration-700", { "rotate-180": k(i)(e.order.id, _) }]),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [...c[3] || (c[3] = [
                      d("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "3",
                        d: "M19 9l-7 7-7-7"
                      }, null, -1)
                    ])], 2))
                  ])) : Z("", !0),
                  d("span", Yg, " $" + O(k(r)(g)), 1)
                ])
              ], 8, Ug),
              g.length > 0 && k(i)(e.order.id, _) ? (L(), I("div", Gg, [
                (L(!0), I(Fe, null, Je(g, (u) => (L(), I("div", {
                  key: u.id,
                  class: "flex justify-between items-center text-sm"
                }, [
                  d("div", Kg, [
                    it(vg, {
                      "is-small": "",
                      "show-add": e.showAdd,
                      status: u.status,
                      ostatus: e.order.status,
                      "is-locked": e.isSelected,
                      onChange: (b) => l.$emit("status-change", e.order, u.id, b)
                    }, null, 8, ["show-add", "status", "ostatus", "is-locked", "onChange"]),
                    d("span", Xg, " $" + O(s(u.status, u.unit_price)), 1)
                  ])
                ]))), 128))
              ])) : Z("", !0)
            ]);
          }), 128))
        ])
      ], 2);
    };
  }
}), Jg = {
  key: 0,
  class: "relative pb-[env(safe-area-inset-bottom,80px)]"
}, Zg = { class: "space-y-6 max-w-screen-md mx-auto" }, Qg = /* @__PURE__ */ Ee({
  __name: "OrderHistoryList",
  props: {
    orders: {},
    selectedIds: {},
    t: { type: Function }
  },
  emits: ["selection-change"],
  setup(e, { emit: t }) {
    Ne.log("OrderHistoryList.vue");
    const n = e, s = t, o = (u) => String(u), r = me(() => new Set(n.selectedIds.map(o))), a = me(() => {
      if (n.selectedIds.length === 0) return null;
      const u = n.orders.find((b) => c(b.id));
      return u ? u.status : null;
    }), i = (u) => u.status === je.PAID ? !0 : a.value === null || c(u.id) ? !1 : u.status !== a.value, l = me(() => a.value === null ? n.orders.filter((u) => u.status !== je.PAID) : n.orders.filter((u) => u.status === a.value)), c = (u) => r.value.has(o(u)), h = me(
      () => n.orders.filter((u) => c(u.id)).reduce((u, b) => u + Number(b.subtotal || 0), 0)
    ), m = me(
      () => l.value.length > 0 && l.value.every((u) => c(u.id))
    ), p = me(() => {
      const u = l.value.filter((b) => c(b.id)).length;
      return u > 0 && u < l.value.length;
    }), g = (u) => {
      const x = n.orders.filter((v) => u.includes(v.id)).reduce((v, A) => v.plus(new Rt(A.subtotal || "0")), new Rt(0));
      s("selection-change", {
        ids: u,
        total: x.toFixed(2)
      });
    }, _ = (u) => {
      if (Ne.log("toggleSelection", u), u.status === je.PAID || !c(u.id) && a.value !== null && u.status !== a.value)
        return;
      const b = [...n.selectedIds], x = b.indexOf(u.id);
      x === -1 ? b.push(u.id) : b.splice(x, 1), g(b);
    }, f = () => {
      if (m.value) {
        const u = new Set(
          l.value.map((b) => o(b.id))
        );
        g(
          n.selectedIds.filter(
            (b) => !u.has(o(b))
          )
        );
      } else
        g([
          .../* @__PURE__ */ new Set([
            ...n.selectedIds.map(o),
            ...l.value.map((u) => o(u.id))
          ])
        ]);
    };
    G({});
    const w = (...u) => {
    };
    return (u, b) => e.orders.length ? (L(), I("div", Jg, [
      it(yg, {
        "is-all-selected": m.value,
        "is-indeterminate": p.value,
        "selected-count": e.selectedIds.length,
        total: h.value,
        t: e.t,
        onToggleAll: f
      }, null, 8, ["is-all-selected", "is-indeterminate", "selected-count", "total", "t"]),
      d("div", Zg, [
        (L(!0), I(Fe, null, Je(e.orders, (x, v) => (L(), ct(el, {
          key: x.id,
          order: x,
          length: e.orders.length,
          index: e.orders.length - v - 1,
          "is-selected": c(x.id),
          showAdd: !1,
          disableStatus: k(je).PAID,
          disabled: i(x),
          onToggleSelection: () => _(x),
          onStatusChange: w
        }, null, 8, ["order", "length", "index", "is-selected", "disableStatus", "disabled", "onToggleSelection"]))), 128))
      ])
    ])) : Z("", !0);
  }
}), eb = { class: "sticky top-0 z-30 w-full bg-white/90 backdrop-blur-md shadow-sm border-b border-gray-100/50 pt-safe-top transition-all" }, tb = { class: "max-w-screen-md mx-auto px-5 py-4 flex items-center justify-between" }, nb = { class: "space-y-0.5" }, sb = { class: "text-2xl text-blue-700 font-black tracking-widest block font-sans" }, ob = {
  key: 0,
  class: "text-xs text-blue-700/80 font-medium tracking-wide block truncate max-w-[220px]"
}, rb = { class: "inline-flex items-center gap-1.5 mt-1 bg-gray-100 px-2.5 py-1 rounded-full" }, ab = { class: "text-xs font-bold text-gray-700" }, ib = ["disabled"], lb = /* @__PURE__ */ Ee({
  __name: "MerchantHeader",
  props: {
    menuData: {},
    historyLoading: { type: Boolean },
    t: { type: Function }
  },
  emits: ["refresh"],
  setup(e) {
    return (t, n) => (L(), I("header", eb, [
      d("div", tb, [
        d("div", nb, [
          d("span", sb, O(e.menuData.merchant_name), 1),
          e.menuData.memo1 ? (L(), I("span", ob, O(e.menuData.memo1), 1)) : Z("", !0),
          d("div", rb, [
            n[1] || (n[1] = d("span", { class: "w-1.5 h-1.5 rounded-full bg-green-700 animate-pulse" }, null, -1)),
            d("h1", ab, O(e.t("order.tableNumber")) + ": " + O(e.menuData.tableNumber), 1)
          ])
        ]),
        d("button", {
          onClick: n[0] || (n[0] = (s) => t.$emit("refresh")),
          disabled: e.historyLoading,
          class: "p-3.5 bg-gray-100 hover:bg-gray-100/80 active:scale-90 rounded-2xl transition-all disabled:opacity-50 flex items-center justify-center shadow-inner"
        }, [
          d("span", {
            class: Ae([{ "animate-spin": e.historyLoading }, "text-lg leading-none select-none"])
          }, "🔄", 2)
        ], 8, ib)
      ])
    ]));
  }
}), cb = { class: "flex items-center gap-2 mb-1" }, ub = { class: "text-sm font-black text-gray-800 tracking-wide uppercase" }, db = /* @__PURE__ */ Ee({
  __name: "BlockSectionHeader",
  props: {
    title: {},
    color: {}
  },
  setup(e) {
    return (t, n) => (L(), I("div", cb, [
      d("span", {
        class: Ae(["w-1 h-4 rounded-full", e.color || "bg-blue-700"])
      }, null, 2),
      d("h2", ub, O(e.title), 1)
    ]));
  }
}), fb = { class: "bg-white p-5 rounded-3xl shadow-sm space-y-4" }, mb = { class: "space-y-4 pt-1" }, hb = { class: "flex flex-col gap-1.5" }, pb = { class: "flex justify-between items-center px-1" }, gb = {
  for: "nickname",
  class: "text-xs font-black text-gray-700 uppercase tracking-wider"
}, bb = { class: "text-[10px] font-bold text-gray-700/60" }, wb = ["placeholder"], yb = { class: "flex flex-col gap-1.5" }, vb = { class: "flex justify-between items-center px-1" }, _b = {
  for: "memo",
  class: "text-xs font-black text-gray-700 uppercase tracking-wider"
}, xb = { class: "text-[10px] font-bold text-gray-700/60" }, Eb = ["placeholder"], kb = /* @__PURE__ */ Ee({
  __name: "OrderMemoForm",
  props: {
    modelValue: {},
    t: { type: Function }
  },
  setup(e) {
    return (t, n) => (L(), I("section", fb, [
      it(db, {
        title: e.t("order.additionalInfo"),
        color: "bg-gray-700"
      }, null, 8, ["title"]),
      d("div", mb, [
        d("div", hb, [
          d("div", pb, [
            d("label", gb, O(e.t("order.nickname")), 1),
            d("div", bb, O(e.modelValue.nickname.length) + " / 50 ", 1)
          ]),
          ot(d("input", {
            id: "nickname",
            "onUpdate:modelValue": n[0] || (n[0] = (s) => e.modelValue.nickname = s),
            type: "text",
            maxlength: "50",
            placeholder: e.t("order.nicknamePlaceholder"),
            class: "w-full p-3.5 bg-gray-100 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-700 outline-none transition-all duration-200 text-sm font-medium text-gray-700 shadow-inner"
          }, null, 8, wb), [
            [wt, e.modelValue.nickname]
          ])
        ]),
        d("div", yb, [
          d("div", vb, [
            d("label", _b, O(e.t("order.specialInstructions")), 1),
            d("div", xb, O(e.modelValue.memo1.length) + " / 255 ", 1)
          ]),
          ot(d("textarea", {
            id: "memo",
            "onUpdate:modelValue": n[1] || (n[1] = (s) => e.modelValue.memo1 = s),
            maxlength: "255",
            placeholder: e.t("order.memoPlaceholder"),
            rows: "3",
            class: "w-full p-3.5 bg-gray-100 rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-700 outline-none transition-all duration-200 resize-none text-sm font-medium text-gray-700 shadow-inner"
          }, null, 8, Eb), [
            [wt, e.modelValue.memo1]
          ])
        ])
      ])
    ]));
  }
}), Cb = { class: "flex flex-col min-h-dvh bg-gray-100 text-gray-700 overflow-x-hidden pb-safe-bottom tap-none" }, Tb = { class: "flex-1 w-full max-w-screen-md mx-auto px-4 py-5 space-y-6" }, Ob = {
  key: 0,
  class: "mt-1"
}, Ab = { class: "relative overflow-hidden rounded-3xl shadow-sm bg-white w-full" }, Sb = ["src", "onClick"], Nb = { class: "absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] font-black text-blue-700 shadow-sm border border-white/50" }, Lb = {
  key: 1,
  class: "bg-red-100 text-red-700 p-4 rounded-2xl border border-red-100/50 text-sm font-medium shadow-sm animate-fade-in"
}, $b = {
  key: 2,
  class: "bg-white p-4 rounded-3xl shadow-sm"
}, Ib = { class: "sticky top-[100px] z-20 -mx-4 px-4 py-2 bg-gray-100/80 backdrop-blur-md flex gap-2 overflow-x-auto no-scrollbar scroll-touch" }, Pb = ["onClick"], Db = { class: "bg-white p-4 rounded-3xl shadow-sm" }, Rb = {
  key: 1,
  class: "py-16 text-center text-gray-700 font-medium"
}, Mb = {
  key: 1,
  class: "bg-white border-t border-gray-100 shadow-[0_-4px_24px_rgba(0,0,0,0,04)] pt-5 pb-4"
}, Bb = { class: "max-w-screen-md mx-auto px-5" }, Fb = { class: "mt-6 flex flex-col items-center gap-3 pb-4" }, Ub = { class: "text-[9px] font-medium tracking-wider text-gray-700/40 uppercase" }, Vb = {
  key: 0,
  class: "w-full mt-4 pt-4 border-t border-gray-100/80 text-center"
}, Hb = { class: "text-amber-700 font-black" }, jb = { class: "block text-[11px] text-amber-700 font-medium mt-0.5" }, Xr = "px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap transition-all duration-200 active:scale-[0.97] select-none shadow-sm", Jr = "bg-blue-700 text-white shadow-md shadow-blue-700/10", Zr = "bg-white text-gray-700 hover:bg-blue-100/50", Iv = /* @__PURE__ */ Ee({
  __name: "MenuOrderPage",
  props: {
    menuApi: {},
    orderApi: {},
    qr: {},
    t: { type: Function },
    baseUrl: {}
  },
  setup(e) {
    Ne.log("MenuOrderPage.vue initialized");
    const t = e, n = (re) => {
      var se;
      return ((se = t.t) == null ? void 0 : se.call(t, re)) ?? re;
    }, s = G(null), o = [
      "1de956ad-ea63-4e74-853a-8b24b4ef3d26",
      "8aaf84df-4d4f-436c-bd70-963a440f0448",
      "8cba5a9b-7007-4a4c-830e-01d402f1ccc0",
      "030b9e3e-4c90-43e4-8a1a-b7c90d4ce37d"
    ], r = G({ nickname: "", memo1: "" }), {
      menuData: a,
      loading: i,
      error: l,
      cart: c,
      totalCounter: h,
      loadMenu: m,
      addToCart: p,
      removeFromCart: g,
      totalPrice: _,
      handleOrderSubmit: f,
      handlePaymentSubmit: w,
      images: u,
      loadImg: b,
      queryCompanyName: x
    } = Ki(t.menuApi), {
      historyLoading: v,
      historyError: A,
      orderHistory: $,
      cumulativeTotal: C,
      loadOrderHistorySession: B
    } = Xi(t.orderApi), {
      selectedCategory: D,
      availableCategories: F,
      filteredItems: H,
      formatOrderHtml: te,
      currentQuote: Me,
      selectedOrderIds: j,
      handleSelectionChange: U,
      selectedTotal: M
    } = Mp(a, c, _), { normalizeForm: K, validateForm: V, validateUBN: J } = Bp(), { activeImages: q, checkAndLoadImages: oe, startAutoplay: le, stopAutoplay: ne } = Fp(s, u, b, t.baseUrl), fe = me(() => {
      var re;
      return o.includes(((re = a.value) == null ? void 0 : re.merchantId) ?? "");
    }), be = me(() => {
      var re, se;
      return (se = (re = $.value.find((ie) => {
        var Q;
        return (Q = ie.info) == null ? void 0 : Q.nickname;
      })) == null ? void 0 : re.info) == null ? void 0 : se.nickname;
    }), Ye = () => U({ ids: [], total: "0" }), Te = () => {
      var re, se, ie, Q;
      return K({
        carrier_num: (re = document.getElementById("checkout-carrier-num")) == null ? void 0 : re.value,
        customer_identifier: (se = document.getElementById("checkout-customer-identifier")) == null ? void 0 : se.value,
        customer_name: (ie = document.getElementById("checkout-customer-name")) == null ? void 0 : ie.value,
        customer_email: (Q = document.getElementById("checkout-customer-email")) == null ? void 0 : Q.value
      });
    };
    vt(be, (re) => {
      re && !r.value.nickname && (r.value.nickname = re);
    }, { immediate: !0 });
    const ae = async () => {
      var se;
      if (((se = a.value) == null ? void 0 : se.pStatus) !== !0)
        return Ye(), _e.fire(n("order.checkoutDisabledTitle"), n("order.checkoutDisabledText"), "warning");
      if (j.value.length === 0)
        return _e.fire(n("order.noOrderSelectedTitle"), n("order.noOrderSelectedText"), "warning");
      (await _e.fire({
        title: n("order.confirmCheckout"),
        html: Tu(
          j.value.length,
          M.value,
          n
        ),
        icon: "info",
        showCancelButton: !0,
        confirmButtonText: n("order.checkoutNow"),
        cancelButtonText: n("common.cancel"),
        confirmButtonColor: "#15803d",
        reverseButtons: !0,
        showLoaderOnConfirm: !0,
        didOpen: () => {
          const ie = document.getElementById("checkout-customer-identifier"), Q = document.getElementById("checkout-carrier-num"), ve = document.getElementById("checkout-customer-name");
          ie == null || ie.addEventListener("input", async () => {
            let Qe = ie.value.replace(/\D/g, "").slice(0, 8);
            if (ie.value = Qe, Qe.length === 8 && J(Qe)) {
              ve && (ve.placeholder = "查詢中...");
              try {
                const ze = await x(Qe);
                ve && (ve.value = (ze == null ? void 0 : ze.Company_Name) || ""), !(ze != null && ze.Company_Name) && ve && (ve.placeholder = "查無公司名稱，請手動輸入");
              } catch {
                ve && (ve.placeholder = "查詢失敗，請手動輸入");
              }
            }
          }), Q == null || Q.addEventListener("input", () => {
            Q.value = Q.value.trim().toUpperCase().slice(0, 8);
          });
        },
        preConfirm: async () => {
          var y;
          const ie = Te(), Q = V(ie);
          if (Q)
            return _e.showValidationMessage(Q), !1;
          await B(t.qr);
          const ve = $.value.map((E) => String(E.id));
          if (!j.value.every((E) => ve.includes(String(E))))
            return j.value = [], _e.showValidationMessage(n("order.statusChanged")), !1;
          const ze = await w({
            qr: t.qr,
            ids: j.value.map(String),
            merchant_id: ((y = a.value) == null ? void 0 : y.merchantId) ?? "",
            ...ie
          });
          return ze || (Ye(), _e.showValidationMessage(n("order.checkoutFailed"))), ze;
        }
      })).isConfirmed && _e.fire({ title: n("order.checkoutSubmitted"), text: n("order.checkoutProcessing"), icon: "success", timer: 2e3, showConfirmButton: !1 });
    }, Be = async () => {
      if ($.value.length >= 3)
        return _e.fire({ title: n("order.tooManyOrdersTitle"), text: n("order.tooManyOrdersText"), icon: "error" });
      const re = Object.entries(c).map(([ie, Q]) => {
        var ze;
        const ve = (ze = a.value) == null ? void 0 : ze.items.find((y) => y.id === ie), Qe = (ve == null ? void 0 : ve.price) || "0";
        return {
          menu_item_id: ie,
          name: ve == null ? void 0 : ve.name,
          price: Qe,
          quantity: Q,
          subtotal: new Rt(Qe).times(Q).toFixed(2)
        };
      }).filter((ie) => ie.quantity > 0);
      if (re.length === 0) return;
      (await _e.fire({
        title: n("order.confirmOrder"),
        html: te(re, _.value, n) || "請確認您的訂單內容",
        icon: "question",
        showCancelButton: !0,
        confirmButtonText: n("common.ok"),
        cancelButtonText: n("common.cancel"),
        confirmButtonColor: "#1d4ed8",
        reverseButtons: !0,
        heightAuto: !1,
        returnFocus: !1
      })).isConfirmed && await f(t.qr, { nickname: r.value.nickname, memo1: r.value.memo1 }) && (Object.keys(c).forEach((Q) => delete c[Q]), h.value = 0, await B(t.qr));
    }, ke = (re) => {
      _e.fire({
        imageUrl: re,
        showConfirmButton: !1,
        showCloseButton: !0,
        allowOutsideClick: !0,
        allowEscapeKey: !0,
        imageWidth: "95%",
        customClass: { popup: "border-none shadow-none bg-transparent", image: "animate__animated animate__zoomIn rounded-3xl shadow-2xl" }
      });
    };
    return Mt(async () => {
      var re;
      t.qr && (await m(t.qr), await B(t.qr), await oe((re = a.value) == null ? void 0 : re.merchantId));
    }), (re, se) => {
      const ie = co("router-link");
      return L(), I("div", Cb, [
        k(a) ? (L(), ct(lb, {
          key: 0,
          "menu-data": k(a),
          "history-loading": k(v),
          t: n,
          onRefresh: se[0] || (se[0] = (Q) => k(B)(t.qr))
        }, null, 8, ["menu-data", "history-loading"])) : Z("", !0),
        d("main", Tb, [
          k(q).length > 0 ? (L(), I("section", Ob, [
            d("div", {
              ref_key: "scrollContainer",
              ref: s,
              class: "flex gap-3.5 overflow-x-auto no-scrollbar snap-x snap-mandatory px-4 -mx-4 pb-1 scroll-touch",
              style: { "scroll-behavior": "smooth" },
              onMouseenter: se[1] || (se[1] = //@ts-ignore
              (...Q) => k(ne) && k(ne)(...Q)),
              onMouseleave: se[2] || (se[2] = //@ts-ignore
              (...Q) => k(le) && k(le)(...Q)),
              onTouchstart: se[3] || (se[3] = //@ts-ignore
              (...Q) => k(ne) && k(ne)(...Q)),
              onTouchend: se[4] || (se[4] = //@ts-ignore
              (...Q) => k(le) && k(le)(...Q))
            }, [
              (L(!0), I(Fe, null, Je(k(q), (Q, ve) => (L(), I("div", {
                key: Q,
                class: "flex-none w-full snap-center"
              }, [
                d("div", Ab, [
                  d("img", {
                    src: Q,
                    class: "w-full h-auto block transition-transform duration-500 active:scale-98",
                    onClick: (Qe) => ke(Q)
                  }, null, 8, Sb),
                  se[7] || (se[7] = d("div", { class: "absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" }, null, -1)),
                  d("div", Nb, O(ve + 1) + " / " + O(k(q).length), 1)
                ])
              ]))), 128))
            ], 544)
          ])) : Z("", !0),
          k(l) || k(A) ? (L(), I("div", Lb, " ⚠️ " + O(k(l) || k(A)), 1)) : Z("", !0),
          k($).length > 0 ? (L(), I("section", $b, [
            it(Kr, {
              title: n("order.orderHistory"),
              color: "bg-blue-700",
              class: "mb-3"
            }, null, 8, ["title"]),
            k(v) ? Z("", !0) : (L(), ct(Qg, {
              key: 0,
              orders: k($),
              t: n,
              "selected-ids": k(j),
              "total-accumulated": k(C),
              onSelectionChange: k(U)
            }, null, 8, ["orders", "selected-ids", "total-accumulated", "onSelectionChange"]))
          ])) : Z("", !0),
          d("nav", Ib, [
            d("button", {
              onClick: se[5] || (se[5] = (Q) => D.value = "All"),
              class: Ae([Xr, k(D) === "All" ? Jr : Zr])
            }, O(n("menu.all")), 3),
            (L(!0), I(Fe, null, Je(k(F), (Q) => (L(), I("button", {
              key: Q,
              onClick: (ve) => D.value = Q,
              class: Ae([Xr, k(D) === Q ? Jr : Zr])
            }, O(Q), 11, Pb))), 128))
          ]),
          d("section", Db, [
            it(Kr, {
              title: k(D) === "All" ? n("order.menuToday") : k(D),
              color: "bg-green-700",
              class: "mb-4"
            }, null, 8, ["title"]),
            k(a) ? (L(), ct(cg, {
              key: 0,
              items: k(H),
              cart: k(c),
              totalCount: k(h),
              "on-add": k(p),
              "on-remove": k(g)
            }, null, 8, ["items", "cart", "totalCount", "on-add", "on-remove"])) : Z("", !0),
            k(H).length === 0 && !k(i) ? (L(), I("div", Rb, " ☕ " + O(n("menu.emptyCategory")), 1)) : Z("", !0)
          ]),
          it(kb, {
            modelValue: r.value,
            "onUpdate:modelValue": se[6] || (se[6] = (Q) => r.value = Q),
            t: n
          }, null, 8, ["modelValue"])
        ]),
        k(a) ? (L(), I("footer", Mb, [
          d("div", Bb, [
            it(Ji, {
              "total-price": k(_),
              loading: k(i),
              "selected-ids": k(j),
              "selected-total": k(M),
              showName: n("order.submitConfirm"),
              onSubmit: Be,
              onCheckout: ae
            }, null, 8, ["total-price", "loading", "selected-ids", "selected-total", "showName"]),
            d("div", Fb, [
              se[8] || (se[8] = d("div", { class: "h-px w-12 bg-gray-100" }, null, -1)),
              it(fl, {
                name: "menu-quote-fade",
                mode: "out-in"
              }, {
                default: Sn(() => [
                  (L(), I("p", {
                    key: k(Me),
                    class: "text-xs font-serif italic text-gray-700/80 tracking-[0.18em] text-center leading-relaxed max-w-[280px]"
                  }, " 「 " + O(k(Me)) + " 」 ", 1))
                ]),
                _: 1
              }),
              d("p", Ub, O(n("order.quoteVersion")), 1),
              fe.value ? (L(), I("div", Vb, [
                it(ie, {
                  to: "/about",
                  class: "inline-block rounded-2xl border border-amber-100 bg-amber-100/40 px-8 py-3.5 text-sm font-bold text-gray-700 shadow-sm transition-all hover:bg-amber-100 hover:border-amber-700 active:scale-95"
                }, {
                  default: Sn(() => [
                    et(O(n("demo.noticeTitle1")) + " ", 1),
                    d("span", Hb, O(n("demo.noticeTitle2")), 1),
                    et(" " + O(n("demo.noticeTitle3")) + " ", 1),
                    d("span", jb, "👉 " + O(n("demo.noticeAction")), 1)
                  ]),
                  _: 1
                })
              ])) : Z("", !0)
            ])
          ])
        ])) : Z("", !0)
      ]);
    };
  }
});
function qb(e) {
  const t = G([]), n = G(!1), s = G(null);
  return {
    tables: t,
    loading: n,
    error: s,
    fetchTables: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.getTables();
      } catch (a) {
        s.value = a.message || "Failed to load tables";
      } finally {
        n.value = !1;
      }
    },
    batchPostTables: async (a) => {
      n.value = !0, s.value = null;
      try {
        const i = await e.createTables(10);
        t.value = [...t.value, ...i];
      } catch (i) {
        s.value = i.message || "Failed to generate tables";
      } finally {
        n.value = !1;
      }
    }
  };
}
const Wb = ["disabled"], zb = { class: "flex items-center" }, Yb = /* @__PURE__ */ Ee({
  __name: "BaseButton",
  props: {
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "lg" },
    variant: { default: "primary" },
    fullWidth: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e) {
    return (t, n) => (L(), I("button", {
      disabled: e.disabled || e.loading,
      onClick: n[0] || (n[0] = (s) => t.$emit("click")),
      class: Ae(["menu-btn", [
        // Size Logic
        e.size === "lg" ? "menu-btn-lg" : "menu-btn-md",
        // Style Variant Logic
        e.variant === "primary" ? "menu-btn-primary" : "menu-btn-outline",
        // Layout Logic
        e.fullWidth ? "menu-btn-full" : ""
      ]])
    }, [
      e.loading ? (L(), I("svg", {
        key: 0,
        class: Ae(["animate-spin h-5 w-5 mr-2", e.variant === "primary" ? "text-white" : "text-blue-700"]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [...n[1] || (n[1] = [
        d("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }, null, -1),
        d("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)
      ])], 2)) : Z("", !0),
      d("span", zb, [
        ml(t.$slots, "default")
      ])
    ], 10, Wb));
  }
}), Gb = { class: "min-h-dvh w-full bg-slate-50 flex flex-col" }, Kb = { class: "w-full bg-white border-b px-4 py-6 pt-[env(safe-area-inset-top,24px)]" }, Xb = { class: "max-w-screen-xl mx-auto" }, Jb = { class: "relative pl-4 border-l-4 border-blue-700" }, Zb = { class: "text-xl font-black text-gray-900 tracking-tight" }, Qb = { class: "text-gray-400 text-sm font-medium mt-1 uppercase tracking-wider" }, ew = { class: "mt-8 flex flex-wrap gap-4" }, tw = { class: "flex-1 w-full px-4 py-8 pb-[env(safe-area-inset-bottom,24px)]" }, nw = { class: "max-w-screen-xl mx-auto" }, sw = {
  key: 0,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl mb-6 border border-red-100 flex items-center gap-3"
}, ow = { class: "font-bold" }, rw = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" }, aw = { class: "self-start text-[10px] bg-gray-100 px-2 py-1 rounded-md text-gray-400 font-mono" }, iw = { class: "group relative bg-white border border-gray-100 rounded-[2rem] p-6 shadow-sm hover:shadow-xl transition-all duration-700 overflow-hidden flex flex-col items-center gap-4" }, lw = { class: "flex items-baseline justify-center gap-2" }, cw = { class: "text-xl font-black uppercase tracking-[0.2em] text-blue-700" }, uw = { class: "text-2xl font-black text-gray-900 leading-none" }, dw = { class: "relative p-3 bg-white rounded-3xl shadow-inner border border-gray-50 group-hover:border-blue-100 transition-colors" }, fw = ["src"], mw = {
  key: 1,
  class: "w-32 h-32 flex flex-col items-center justify-center gap-2"
}, hw = { class: "text-[9px] text-gray-400 font-bold uppercase tracking-widest" }, pw = { class: "mt-2 flex flex-col items-center gap-3 w-full" }, gw = { class: "text-[9px] font-mono text-gray-400 bg-gray-50 px-3 py-1 rounded-full truncate w-full text-center" }, bw = ["href"], ww = 9, yw = 10, vw = /* @__PURE__ */ Ee({
  __name: "TablePostPage",
  props: {
    api: {}
  },
  setup(e) {
    const { t } = St(), n = e, { tables: s, loading: o, error: r, fetchTables: a, batchPostTables: i } = qb(n.api), l = async () => {
      try {
        await i(yw), await a();
      } catch (c) {
        Ne.error("Failed to generate tables:", c);
      }
    };
    return Mt(async () => {
      try {
        await a();
      } catch (c) {
        Ne.error("Failed to initial fetch tables:", c);
      }
    }), (c, h) => {
      const m = co("router-link");
      return L(), I("div", Gb, [
        d("header", Kb, [
          d("div", Xb, [
            it(m, {
              to: "/all_order",
              class: "inline-flex items-center gap-2 px-3 py-1.5 mb-6 text-sm font-bold text-gray-700 hover:text-blue-700 bg-gray-50 rounded-full transition-all"
            }, {
              default: Sn(() => [
                h[1] || (h[1] = d("span", { class: "flex items-center justify-center w-6 h-6 rounded-full bg-white shadow-sm" }, [
                  d("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "w-3.5 h-3.5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    d("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "3",
                      d: "M15 19l-7-7 7-7"
                    })
                  ])
                ], -1)),
                et(" " + O(k(t)("tables.backBtn")), 1)
              ]),
              _: 1
            }),
            d("div", Jb, [
              d("h1", Zb, O(k(t)("tables.title")), 1),
              d("p", Qb, O(k(t)("tables.subtitle")), 1)
            ]),
            d("div", ew, [
              k(s).length < ww ? (L(), ct(Yb, {
                key: 0,
                onClick: l,
                loading: k(o),
                class: "shadow-lg py-4 px-8 text-lg bg-blue-700 text-white rounded-xl flex items-center justify-center transition-transform active:scale-[0.98] flex-1 sm:flex-none",
                "full-width": !1
              }, {
                default: Sn(() => [
                  et(O(k(t)("tables.generateBtn")), 1)
                ]),
                _: 1
              }, 8, ["loading"])) : Z("", !0),
              d("button", {
                onClick: h[0] || (h[0] = //@ts-ignore
                (...p) => k(a) && k(a)(...p)),
                class: "shadow-lg py-4 px-8 text-lg bg-white border border-gray-100 text-gray-700 rounded-xl flex items-center justify-center transition-transform active:scale-[0.98] flex-1 sm:flex-none"
              }, O(k(t)("tables.refreshBtn")), 1)
            ])
          ])
        ]),
        d("main", tw, [
          d("div", nw, [
            k(r) ? (L(), I("div", sw, [
              d("span", ow, O(k(t)("common.error")) + ":", 1),
              et(" " + O(k(r)), 1)
            ])) : Z("", !0),
            d("div", rw, [
              (L(!0), I(Fe, null, Je(k(s), (p) => (L(), I("div", {
                key: p.id,
                class: "flex flex-col gap-2"
              }, [
                d("div", aw, " #" + O(p.id.slice(-8)), 1),
                d("div", iw, [
                  h[4] || (h[4] = d("div", { class: "absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-full -mr-12 -mt-12 transition-transform group-hover:scale-150 duration-700 opacity-50" }, null, -1)),
                  d("div", lw, [
                    d("span", cw, O(k(t)("tables.cardHeader")), 1),
                    d("span", uw, O(p.tableNumber), 1)
                  ]),
                  d("div", dw, [
                    p.qrcode_base64 ? (L(), I("img", {
                      key: 0,
                      src: p.qrcode_base64,
                      class: "w-full max-w-[12rem] aspect-square object-contain mix-blend-multiply rounded-xl"
                    }, null, 8, fw)) : (L(), I("div", mw, [
                      h[2] || (h[2] = d("div", { class: "animate-pulse w-8 h-8 rounded-full bg-gray-100" }, null, -1)),
                      d("span", hw, O(k(t)("tables.generating")), 1)
                    ]))
                  ]),
                  d("div", pw, [
                    d("div", gw, O(p.url), 1),
                    d("a", {
                      href: p.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "flex items-center gap-2 px-6 py-2.5 bg-gray-900 text-white text-[11px] font-bold rounded-full hover:bg-blue-700 transition-all active:scale-95 shadow-md shadow-gray-100"
                    }, [
                      d("span", null, O(k(t)("tables.openLink")), 1),
                      h[3] || (h[3] = d("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "w-3 h-3",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        d("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.5",
                          d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        })
                      ], -1))
                    ], 8, bw)
                  ])
                ])
              ]))), 128))
            ])
          ])
        ])
      ]);
    };
  }
}), Pv = /* @__PURE__ */ kn(vw, [["__scopeId", "data-v-20b790df"]]);
function tl(e) {
  const t = G([]), n = G(!1), s = G(null);
  return {
    ordersOrderManagement: t,
    loadingOrderManagement: n,
    errorOrderManagement: s,
    fetchOrders: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.getOrders();
      } catch (l) {
        s.value = `取得訂單失敗: ${l.message}`;
      } finally {
        n.value = !1;
      }
    },
    updateStatus: async (l) => {
      n.value = !0, s.value = null;
      try {
        const c = await e.updateItemStatus(l), h = t.value.find((m) => m.id === l.orderId);
        if (h) {
          const m = h.items.find((p) => p.id === l.itemId);
          m && (m.status = l.newStatus);
        }
      } catch (c) {
        throw s.value = `更新狀態失敗: ${c.message}`, c;
      } finally {
        n.value = !1;
      }
    },
    performCheckout: async (l, c) => {
      if (l.length === 0) throw new Error("未選擇任何訂單");
      n.value = !0, s.value = null;
      const h = (c == null ? void 0 : c.memo2) || "", m = c == null ? void 0 : c.status;
      if (m === void 0 || isNaN(m) || m < 0 || m > 4) {
        n.value = !1;
        const p = `無效的訂單狀態: ${(c == null ? void 0 : c.status) === void 0 ? "未定義" : c.status}`;
        throw s.value = p, new Error(p);
      }
      try {
        const p = await e.checkoutOrders(l, { memo2: h, status: m });
        return p.rows_affected > 0 && (await _e.fire({
          title: "訂單處理完成！",
          text: p.message,
          icon: "success",
          confirmButtonColor: "#2563eb",
          timer: 1500
        }), t.value = t.value.filter((g) => !l.includes(g.id))), p;
      } catch (p) {
        throw s.value = `訂單處理失敗: ${p.message}`, p;
      } finally {
        n.value = !1;
      }
    },
    performCheckout2: async (l, c, h, m, p, g) => {
      if (l.length === 0) throw new Error("未選擇任何訂單");
      if (!c) throw new Error("缺少 QR Code 參數");
      n.value = !0, s.value = null;
      const _ = {
        ids: l,
        qr: c,
        carrier_num: h || "",
        customer_identifier: m || "",
        customer_name: p || "",
        memo2: g || ""
      }, f = {
        ids: l
      };
      try {
        const w = await e.checkDuplicates(f);
        if (!await gl(w.duplicates))
          return n.value = !1, { rows_affected: 0, status: "CANCELLED", amount: "0", checkout_at: 0, merchant_trade_no: "" };
        const b = await e.counterCheckoutOrders(
          _
        );
        return b.rows_affected > 0 && (await _e.fire({
          title: "櫃台結帳處理完成！",
          text: b.merchant_trade_no || "現場交易已同步完成",
          icon: "success",
          confirmButtonColor: "#2563eb",
          timer: 1500
        }), t.value = t.value.filter((x) => !l.includes(x.id))), b;
      } catch (w) {
        throw s.value = `櫃台結帳處理失敗: ${w.message}`, w;
      } finally {
        n.value = !1;
      }
    }
  };
}
const _w = { class: "flex flex-col gap-4 mb-6" }, xw = { class: "flex items-center justify-between" }, Ew = ["disabled"], kw = { class: "text-[10px] font-bold uppercase" }, Cw = { class: "bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex items-end justify-between" }, Tw = { class: "text-[10px] text-gray-400 font-black uppercase tracking-widest mb-1" }, Ow = { class: "text-4xl font-black text-gray-900 leading-none" }, Aw = { class: "flex flex-col items-end" }, Sw = { class: "text-[10px] font-bold text-gray-400 uppercase" }, Nw = /* @__PURE__ */ Ee({
  __name: "OrderTableHeader",
  props: {
    tableNumber: {},
    loading: { type: Boolean },
    t: { type: Function }
  },
  emits: ["refresh"],
  setup(e) {
    return (t, n) => {
      const s = co("router-link");
      return L(), I("section", _w, [
        d("div", xw, [
          it(s, {
            to: "/all_order",
            class: "flex items-center gap-1 text-sm font-bold text-blue-700 hover:text-blue-700 transition-colors"
          }, {
            default: Sn(() => [
              n[1] || (n[1] = d("span", { class: "text-lg" }, "‹", -1)),
              et(" 📋 " + O(e.t("order.manage")), 1)
            ]),
            _: 1
          }),
          d("button", {
            onClick: n[0] || (n[0] = (o) => t.$emit("refresh")),
            disabled: e.loading,
            class: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-95 transition-all disabled:opacity-50"
          }, [
            d("span", {
              class: Ae([{ "animate-spin": e.loading }, "text-sm"])
            }, "🔄", 2),
            d("span", kw, O(e.t("common.refresh")), 1)
          ], 8, Ew)
        ]),
        d("div", Cw, [
          d("div", null, [
            d("p", Tw, O(e.t("order.currentTable")), 1),
            d("h1", Ow, O(e.tableNumber || e.t("common.na")), 1)
          ]),
          d("div", Aw, [
            n[2] || (n[2] = d("span", { class: "flex h-2 w-2 rounded-full bg-green-700 animate-pulse mb-1" }, null, -1)),
            d("span", Sw, O(e.t("order.activeSession")), 1)
          ])
        ])
      ]);
    };
  }
}), Lw = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
}, $w = { class: "bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-xl mx-4" }, Iw = { class: "px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50" }, Pw = { class: "text-sm font-semibold text-blue-700" }, Dw = { class: "p-6 space-y-5 max-h-[65vh] overflow-y-auto" }, Rw = ["value"], Mw = { key: 0 }, Bw = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, Fw = { key: 1 }, Uw = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, Vw = { key: 2 }, Hw = { class: "relative" }, jw = {
  key: 0,
  class: "absolute right-3 top-1/2 -translate-y-1/2"
}, qw = { class: "px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end space-x-3" }, Ww = ["disabled"], zw = ["disabled"], Yw = {
  key: 0,
  class: "animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"
}, Gw = /* @__PURE__ */ Ee({
  __name: "CheckoutInvoiceModal",
  props: /* @__PURE__ */ Yo({
    isOpen: { type: Boolean },
    otype: {},
    total: {},
    options: {},
    queryCompanyName: { type: Function },
    isSubmitting: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Yo(["close", "submit"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, s = hl(e, "modelValue"), o = t, r = G(""), a = G(""), i = G(!1);
    vt(() => n.isOpen, (h) => {
      h || (r.value = "", a.value = "");
    });
    const l = async (h) => {
      const m = h.target, p = bl(m.value);
      if (m.value = p.value, s.value.CustomerIdentifier = p.value, r.value = p.error, p.isReady && n.queryCompanyName) {
        i.value = !0;
        try {
          const g = await n.queryCompanyName(p.value), _ = g == null ? void 0 : g.Company_Name;
          _ ? s.value.CustomerName = _ : r.value = "查無此統一編號的公司名稱";
        } catch (g) {
          Ne.error("查詢公司名稱失敗:", g), r.value = "系統查詢名稱失敗，請手動輸入公司名稱";
        } finally {
          i.value = !1;
        }
      }
    }, c = () => {
      if (s.value.CarrierNum && !s.value.CarrierNum.startsWith("/")) {
        a.value = "手機條碼第一碼必須為斜線 /";
        return;
      }
      a.value = "", o("submit");
    };
    return (h, m) => e.isOpen ? (L(), I("div", Lw, [
      d("div", $w, [
        d("div", Iw, [
          m[6] || (m[6] = d("h3", { class: "text-base font-bold text-gray-800" }, "結帳與發票設定", -1)),
          d("p", Pw, "總金額: " + O(e.total), 1)
        ]),
        d("div", Dw, [
          d("div", null, [
            m[7] || (m[7] = d("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "變更訂單狀態", -1)),
            ot(d("select", {
              "onUpdate:modelValue": m[0] || (m[0] = (p) => s.value.status = p),
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
            }, [
              (L(!0), I(Fe, null, Je(e.options, (p) => (L(), I("option", {
                key: p.value,
                value: p.value
              }, O(p.icon) + " " + O(p.label), 9, Rw))), 128))
            ], 512), [
              [uo, s.value.status]
            ])
          ]),
          d("div", null, [
            m[8] || (m[8] = d("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "備註", -1)),
            ot(d("input", {
              "onUpdate:modelValue": m[1] || (m[1] = (p) => s.value.memo2 = p),
              type: "text",
              maxlength: "30",
              placeholder: "",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 512), [
              [wt, s.value.memo2]
            ]),
            m[9] || (m[9] = d("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "備註", -1))
          ]),
          m[15] || (m[15] = d("hr", { class: "border-gray-100" }, null, -1)),
          e.otype === 0 ? (L(), I("div", Mw, [
            m[10] || (m[10] = d("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "手機條碼 (CarrierNum)", -1)),
            ot(d("input", {
              "onUpdate:modelValue": m[2] || (m[2] = (p) => s.value.CarrierNum = p),
              type: "text",
              maxlength: "8",
              placeholder: "/ABC1234",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 512), [
              [wt, s.value.CarrierNum]
            ]),
            m[11] || (m[11] = d("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "* 第一碼必須為斜線 /", -1)),
            a.value ? (L(), I("p", Bw, O(a.value), 1)) : Z("", !0)
          ])) : Z("", !0),
          e.otype === 0 ? (L(), I("div", Fw, [
            m[12] || (m[12] = d("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人統編 (CustomerIdentifier)", -1)),
            ot(d("input", {
              "onUpdate:modelValue": m[3] || (m[3] = (p) => s.value.CustomerIdentifier = p),
              onInput: l,
              type: "text",
              maxlength: "8",
              placeholder: "8 位數字統編",
              class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
            }, null, 544), [
              [wt, s.value.CustomerIdentifier]
            ]),
            r.value ? (L(), I("p", Uw, O(r.value), 1)) : Z("", !0)
          ])) : Z("", !0),
          e.otype === 0 ? (L(), I("div", Vw, [
            m[14] || (m[14] = d("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人名稱 (CustomerName)", -1)),
            d("div", Hw, [
              ot(d("input", {
                "onUpdate:modelValue": m[4] || (m[4] = (p) => s.value.CustomerName = p),
                type: "text",
                placeholder: "公司全名",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
              }, null, 512), [
                [wt, s.value.CustomerName]
              ]),
              i.value ? (L(), I("div", jw, [...m[13] || (m[13] = [
                d("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-blue-700 border-t-transparent" }, null, -1)
              ])])) : Z("", !0)
            ])
          ])) : Z("", !0)
        ]),
        d("div", qw, [
          d("button", {
            onClick: m[5] || (m[5] = (p) => h.$emit("close")),
            disabled: e.isSubmitting,
            class: "px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          }, " 取消 ", 8, Ww),
          d("button", {
            onClick: c,
            disabled: e.isSubmitting,
            class: "px-5 py-2 text-sm font-medium text-white bg-blue-700 rounded-xl hover:bg-blue-800 transition-colors shadow-lg shadow-blue-700/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
          }, [
            e.isSubmitting ? (L(), I("span", Yw)) : Z("", !0),
            d("span", null, O(e.isSubmitting ? "處理中..." : "確認送出"), 1)
          ], 8, zw)
        ])
      ])
    ])) : Z("", !0);
  }
}), Kw = { key: 0 }, Xw = { class: "flex items-center justify-between mb-4" }, Jw = { class: "menu-section-title" }, Zw = { class: "text-xs font-bold text-white bg-blue-700 px-3 py-1 rounded-full shadow-sm" }, Qw = { class: "flex items-center justify-between mb-4 px-1" }, e0 = { class: "flex items-center gap-2 cursor-pointer" }, t0 = ["checked"], n0 = { class: "text-sm font-bold text-gray-700" }, s0 = /* @__PURE__ */ Ee({
  __name: "OrderManagementList",
  props: {
    orders: {},
    t: { type: Function }
  },
  emits: ["update-item-status", "selection-change"],
  setup(e, { emit: t }) {
    Ne.log("OrderManagementList.vue");
    const n = e, s = (g) => {
      var _;
      return ((_ = n.t) == null ? void 0 : _.call(n, g)) ?? g;
    }, o = t, r = G([]), a = me(() => n.orders.length > 0 && r.value.length === n.orders.length), i = () => {
      r.value = a.value ? [] : n.orders.map((g) => g.id);
    }, l = (g) => {
      const _ = r.value.indexOf(g), f = [...r.value];
      _ > -1 ? f.splice(_, 1) : f.push(g), r.value = f;
    }, c = me(() => n.orders.filter(
      (g) => (
        // 1. Must be selected
        r.value.includes(g.id) && // 2. Must be a valid status (e.g., exclude CLOSED or specific error statuses)
        g.status !== je.PAID
      )
    ).reduce((g, _) => g + Number(_.subtotal || 0), 0));
    vt(r, (g) => {
      o("selection-change", {
        ids: [...g],
        // Send a copy to ensure reactivity in the parent
        total: c.value
      });
    }, { deep: !0 });
    const h = (g, _, f) => {
      const w = g.items.find((x) => x.id === _);
      if (!w) return;
      const u = An.indexOf(w.status), b = An[u + f];
      if (b !== void 0) {
        const x = new Rt(g.subtotal || "0"), v = new Rt(w.unit_price || "0");
        w.status !== Lt.CANCEL && b === Lt.CANCEL ? g.subtotal = x.minus(v).toFixed(2) : w.status === Lt.CANCEL && b !== Lt.CANCEL && (g.subtotal = x.plus(v).toFixed(2)), w.status = b, o("update-item-status", { orderId: g.id, itemId: _, newStatus: b });
      }
    }, m = me(() => [...n.orders].sort((g, _) => {
      var b, x;
      const f = ((b = g.info) == null ? void 0 : b.session_id) || "", w = ((x = _.info) == null ? void 0 : x.session_id) || "", u = f.localeCompare(w);
      if (u === 0) {
        const v = new Date(g.created_at).getTime();
        return new Date(_.created_at).getTime() - v;
      }
      return u;
    })), p = me(() => {
      const g = {}, _ = {};
      return [...m.value].reverse().forEach((f) => {
        var u;
        const w = ((u = f.info) == null ? void 0 : u.session_id) || "default";
        g[w] = (g[w] || 0) + 1, _[f.id] = g[w];
      }), _;
    });
    return (g, _) => e.orders.length > 0 ? (L(), I("div", Kw, [
      d("header", Xw, [
        d("h2", Jw, [
          _[0] || (_[0] = d("span", { class: "menu-section-dot" }, null, -1)),
          et(" " + O(s("orderHistory.title")), 1)
        ]),
        d("span", Zw, O(s("orderHistory.selectedTotal")) + " $" + O(c.value), 1)
      ]),
      d("div", Qw, [
        d("label", e0, [
          d("input", {
            type: "checkbox",
            checked: a.value,
            onChange: i,
            class: "menu-checkbox w-5 h-5 accent-blue-700"
          }, null, 40, t0),
          d("span", n0, O(s("orderHistory.selectAll")), 1)
        ])
      ]),
      (L(!0), I(Fe, null, Je(m.value, (f, w) => (L(), ct(el, {
        key: f.id,
        order: f,
        length: e.orders.length,
        index: e.orders.length - w - 1,
        "is-selected": r.value.includes(f.id),
        "show-add": !0,
        "session-index": p.value[f.id],
        onToggleSelection: l,
        onStatusChange: h
      }, null, 8, ["order", "length", "index", "is-selected", "session-index"]))), 128))
    ])) : Z("", !0);
  }
}), o0 = { class: "menu-order-shell" }, r0 = {
  key: 0,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl mb-4 border border-red-100 text-sm font-medium"
}, a0 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-20 space-y-4"
}, i0 = { class: "text-gray-400 text-sm font-medium" }, Dv = /* @__PURE__ */ Ee({
  __name: "OrderManagementPage",
  props: {
    menuApi: {},
    orderApi: {},
    orderManagementApi: {},
    qr: {},
    onNavigate: { type: Function },
    t: { type: Function }
  },
  setup(e) {
    const t = e, n = (B) => {
      var D;
      return ((D = t.t) == null ? void 0 : D.call(t, B)) ?? B;
    }, s = me(() => n("common.done"));
    Ki(t.menuApi);
    const { historyLoading: o, historyError: r, orderHistory: a, cumulativeTotal: i, loadOrderHistory: l } = Xi(t.orderApi), { updateStatus: c, performCheckout: h, performCheckout2: m } = tl(t.orderManagementApi), p = G("0"), g = G([]), _ = G(""), f = G(!1), w = G(!1), u = G(0), b = G([]), x = G({
      status: je.COMPLETE,
      CarrierNum: "",
      CustomerIdentifier: "",
      CustomerName: "",
      memo2: ""
    });
    Mt(() => {
      t.qr && l(t.qr);
    });
    const v = ({ ids: B, total: D }) => {
      g.value = B, p.value = D;
    }, A = async (B) => {
      await c(B);
    }, $ = async () => {
      if (g.value.length === 0) return;
      const D = a.value.filter(
        (H) => g.value.includes(H.id)
      ).map((H) => H.status);
      if (new Set(D).size > 1) {
        _e.fire({
          icon: "error",
          title: "錯誤",
          text: "❌ 無法同時結帳不同狀態的訂單，請重新選擇！"
        });
        return;
      }
      D[0] === je.PAID ? u.value = 1 : u.value = 0, _.value = D[0], b.value = [
        { value: je.COMPLETE, label: n("order.statusComplete"), icon: "✅" },
        { value: je.CLOSED, label: n("order.statusClose"), icon: "❌" }
      ], x.value.status = b.value[0].value, x.value.CarrierNum = "", x.value.CustomerIdentifier = "", x.value.CustomerName = "", x.value.memo2 = "", f.value = !0;
    }, C = async () => {
      var B;
      try {
        w.value = !0;
        let D;
        const { status: F, memo2: H, CarrierNum: te, CustomerIdentifier: Me, CustomerName: j } = x.value;
        F === je.CLOSED || _.value === je.PAID ? D = await h(g.value, {
          memo2: H,
          status: F
        }) : D = await m(
          g.value,
          t.qr,
          te,
          Me,
          j,
          H
        ), D.rows_affected > 0 && (f.value = !1, p.value = "0", await l(t.qr), await pl(), a.value.length === 0 && ((B = t.onNavigate) == null || B.call(t, "/all_order")));
      } catch (D) {
        console.error("Checkout failed:", D), _e.fire({
          icon: "error",
          title: "結帳失敗",
          text: "系統發生錯誤，請稍後再試。"
        });
      } finally {
        w.value = !1;
      }
    };
    return (B, D) => {
      var F, H;
      return L(), I("div", o0, [
        k(a).length > 0 ? (L(), ct(Nw, {
          key: 0,
          "table-number": (H = (F = k(a)[0]) == null ? void 0 : F.table) == null ? void 0 : H.tableNumber,
          loading: k(o),
          t: n,
          onRefresh: D[0] || (D[0] = (te) => k(l)(t.qr))
        }, null, 8, ["table-number", "loading"])) : Z("", !0),
        d("section", null, [
          k(r) ? (L(), I("div", r0, O(k(r)), 1)) : Z("", !0),
          !k(o) && k(a).length > 0 ? (L(), ct(s0, {
            key: 1,
            orders: k(a),
            "total-accumulated": k(i),
            t: n,
            onUpdateItemStatus: A,
            onSelectionChange: v
          }, null, 8, ["orders", "total-accumulated"])) : Z("", !0),
          k(o) ? (L(), I("div", a0, [
            D[3] || (D[3] = d("div", { class: "w-12 h-12 border-4 border-blue-100 border-t-blue-700 rounded-full animate-spin" }, null, -1)),
            d("p", i0, O(n("order.loadingHistory")), 1)
          ])) : Z("", !0),
          k(a).length > 0 ? (L(), ct(Ji, {
            key: 3,
            "total-price": p.value,
            loading: k(o),
            showName: s.value,
            onSubmit: $
          }, null, 8, ["total-price", "loading", "showName"])) : Z("", !0)
        ]),
        it(Gw, {
          modelValue: x.value,
          "onUpdate:modelValue": D[1] || (D[1] = (te) => x.value = te),
          "is-open": f.value,
          otype: u.value,
          total: p.value,
          options: b.value,
          "query-company-name": t.menuApi.queryCompanyName,
          "is-submitting": w.value,
          onClose: D[2] || (D[2] = (te) => f.value = !1),
          onSubmit: C
        }, null, 8, ["modelValue", "is-open", "otype", "total", "options", "query-company-name", "is-submitting"])
      ]);
    };
  }
});
function l0(e) {
  const t = G([]), n = G(!1), s = G(null), o = G(1), r = G(10), a = G(0), i = G(void 0);
  return {
    orders: t,
    loading: n,
    error: s,
    currentPage: o,
    pageSize: r,
    totalCount: a,
    selectedStatus: i,
    // 匯出這些讓 UI 綁定
    fetchOrders: async () => {
      n.value = !0, s.value = null;
      try {
        const c = await e.getAllOrderWithPage({
          page: o.value,
          size: r.value,
          status: i.value
        });
        t.value = c.orders, a.value = c.total_count;
      } catch (c) {
        s.value = c.message || "無法取得訂單列表";
      } finally {
        n.value = !1;
      }
    },
    getStatusLabel: js
  };
}
const c0 = { class: "flex flex-col min-h-dvh w-full bg-slate-50 overflow-x-hidden" }, u0 = { class: "w-full px-4 pt-[env(safe-area-inset-top,1.5rem)] pb-6 max-w-4xl mx-auto" }, d0 = { class: "flex flex-col gap-6" }, f0 = { class: "flex justify-between items-start" }, m0 = ["disabled"], h0 = { class: "text-3xl font-black text-gray-900 tracking-tight" }, p0 = { class: "text-gray-400 text-sm font-bold mt-1" }, g0 = { class: "text-blue-700" }, b0 = { class: "bg-gray-100/50 p-1 rounded-2xl flex w-full" }, w0 = ["onClick"], y0 = { class: "flex-grow px-4 pb-12 max-w-4xl mx-auto w-full" }, v0 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}, _0 = { class: "text-gray-400 font-medium mt-4" }, x0 = {
  key: 1,
  class: "bg-red-50 text-red-700 p-5 rounded-2xl border border-red-100 font-medium flex items-center gap-3"
}, E0 = {
  key: 2,
  class: "grid grid-cols-1 gap-6"
}, k0 = ["onClick"], C0 = { class: "p-6" }, T0 = { class: "flex justify-between items-start mb-4" }, O0 = { class: "space-y-1" }, A0 = { class: "flex items-center gap-2" }, S0 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-blue-700 animate-pulse"
}, N0 = { class: "text-2xl font-black text-gray-900" }, L0 = { class: "flex items-center gap-2 flex-wrap" }, $0 = { class: "text-[0.65rem] text-gray-400 font-mono tracking-tighter bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100" }, I0 = {
  key: 0,
  class: "text-xs font-black text-gray-700 bg-amber-100 px-2 py-0.5 rounded-md border border-amber-200"
}, P0 = {
  key: 0,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, D0 = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, R0 = {
  key: 1,
  class: "mt-1 flex items-start gap-2 bg-gray-50 border-l-4 border-amber-400 p-2 rounded-r-lg"
}, M0 = { class: "text-[11px] leading-relaxed font-bold text-gray-600 italic" }, B0 = { class: "mt-6 pt-5 border-t border-gray-50 flex justify-between items-end" }, F0 = { class: "text-[0.7rem] font-bold text-gray-400" }, U0 = { class: "text-right" }, V0 = { class: "text-[0.6rem] text-gray-400 font-bold uppercase tracking-widest mb-1" }, H0 = { class: "text-3xl font-black text-blue-700 tabular-nums leading-none" }, j0 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20 bg-white rounded-[3rem] border-2 border-dashed border-gray-100"
}, q0 = { class: "text-gray-400 font-bold" }, W0 = {
  key: 3,
  class: "flex flex-col sm:flex-row items-center justify-between gap-4 bg-white px-6 py-4 rounded-2xl border border-gray-100 shadow-xs mt-2"
}, z0 = { class: "text-xs font-mono font-bold text-gray-400" }, Y0 = { class: "flex items-center gap-3" }, G0 = ["disabled"], K0 = ["disabled"], Rv = /* @__PURE__ */ Ee({
  __name: "MerchantOrderListPage",
  props: {
    merchantOrderApi: {},
    orderManagementApi: {},
    t: { type: Function }
  },
  emits: ["navigate-to-table"],
  setup(e, { emit: t }) {
    const n = e, s = (v) => {
      var A;
      return ((A = n.t) == null ? void 0 : A.call(n, v)) ?? v;
    }, o = localStorage.getItem("merchant_tz") || "UTC", {
      orders: r,
      loading: a,
      error: i,
      currentPage: l,
      totalCount: c,
      pageSize: h,
      selectedStatus: m,
      fetchOrders: p,
      getStatusLabel: g
    } = l0(n.merchantOrderApi), {
      performCheckout: _
    } = tl(n.orderManagementApi), f = G("all"), w = [
      { key: "active", label: "order.tab.active" },
      { key: "completed", label: "order.tab.completed" },
      { key: "all", label: "order.tab.all" }
    ];
    vt(f, (v) => {
      v === "completed" ? m.value = je.COMPLETE : v === "active" ? m.value = je.PAID : m.value = void 0, l.value = 1, p();
    }), vt(l, () => {
      p();
    });
    const u = () => {
      p();
    }, b = t, x = async (v) => {
      var $, C, B;
      if (v.status === je.COMPLETE || v.status === je.CLOSED) {
        if (Ne.log("handleTableClick", ($ = v.table) == null ? void 0 : $.tableNumber, (C = v.table) == null ? void 0 : C.qr, v.id, v.status), await _e.fire({
          title: s("order.completedTitle"),
          text: s("order.completedText"),
          icon: "info",
          confirmButtonColor: "#2563eb",
          timer: 1e3
        }), (await _e.fire({
          title: "是否要修改狀態？",
          text: "點擊確認將會更新目前的訂單狀態。",
          icon: "question",
          showCancelButton: !0,
          // 顯示取消按鈕
          confirmButtonColor: "#2563eb",
          // 保持相同的主題藍色
          cancelButtonColor: "#d33",
          confirmButtonText: "確定修改",
          cancelButtonText: "不用，謝謝"
        })).isConfirmed)
          try {
            _e.fire({
              title: "更新中...",
              allowOutsideClick: !1,
              didOpen: () => {
                _e.showLoading();
              }
            });
            const F = await _(
              [v.id],
              {
                memo2: "",
                // 因為 memo2 是必填的，若無內容可先帶空字串
                status: je.NEW
              }
            );
            p();
          } catch (F) {
            Ne.error("API 呼叫失敗:", F), await _e.fire({
              title: "修改失敗",
              text: "切換狀態時發生錯誤，請稍後再試。",
              icon: "error",
              confirmButtonColor: "#2563eb",
              timer: 1e3
            });
          }
        return;
      }
      const A = (B = v.table) == null ? void 0 : B.qr;
      A && b("navigate-to-table", A);
    };
    return Mt(() => {
      p();
    }), (v, A) => {
      var $;
      return L(), I("div", c0, [
        d("header", u0, [
          d("div", d0, [
            d("div", f0, [
              d("button", {
                onClick: u,
                disabled: k(a),
                "aria-label": "Refresh Orders",
                class: "w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-2xl bg-white shadow-sm border border-gray-100 active:scale-90 transition-all touch-manipulation"
              }, [
                d("span", {
                  class: Ae([{ "animate-spin": k(a) }, "text-xl"])
                }, "🔄", 2)
              ], 8, m0),
              d("div", null, [
                d("h1", h0, O(s("order.manage")), 1),
                d("p", p0, [
                  et(O(s("order.totalPrefix")) + " ", 1),
                  d("span", g0, O(k(c)), 1),
                  et(" " + O(s("order.totalSuffix")), 1)
                ])
              ])
            ]),
            d("nav", b0, [
              (L(), I(Fe, null, Je(w, (C) => d("button", {
                key: C.key,
                onClick: (B) => f.value = C.key,
                class: Ae([
                  "flex-1 py-3 text-sm font-bold rounded-xl transition-all touch-manipulation",
                  f.value === C.key ? "bg-white text-blue-700 shadow-sm" : "text-gray-700"
                ])
              }, O(s(C.label)), 11, w0)), 64))
            ])
          ])
        ]),
        d("main", y0, [
          k(a) ? (L(), I("div", v0, [
            A[2] || (A[2] = d("div", { class: "w-12 h-12 border-4 border-blue-100 border-t-blue-700 rounded-full animate-spin" }, null, -1)),
            d("p", _0, O(s("order.syncing")), 1)
          ])) : k(i) ? (L(), I("div", x0, [
            A[3] || (A[3] = d("span", null, "⚠️", -1)),
            et(" " + O(k(i)), 1)
          ])) : (L(), I("div", E0, [
            (L(!0), I(Fe, null, Je(k(r), (C) => {
              var B, D, F, H;
              return L(), I("article", {
                key: C.id,
                class: "bg-white rounded-[2.5rem] border border-gray-100 shadow-sm flex flex-col transition-all active:scale-[0.98] touch-manipulation",
                onClick: (te) => x(C)
              }, [
                d("div", C0, [
                  d("div", T0, [
                    d("div", O0, [
                      d("div", A0, [
                        f.value === "active" ? (L(), I("span", S0)) : Z("", !0),
                        d("h2", N0, O(s("order.table")) + " " + O((B = C.table) == null ? void 0 : B.tableNumber), 1)
                      ]),
                      d("div", L0, [
                        d("p", $0, O(C.id.slice(-3)), 1),
                        (D = C.info) != null && D.nickname ? (L(), I("p", I0, " 👤 " + O(C.info.nickname), 1)) : Z("", !0)
                      ])
                    ]),
                    d("span", {
                      class: Ae([
                        "px-4 py-1.5 rounded-xl text-[0.7rem] font-black uppercase tracking-wider",
                        k(g)(C.status).color
                      ])
                    }, O(k(g)(C.status).text), 3)
                  ]),
                  (F = C.info) != null && F.memo1 ? (L(), I("div", P0, [
                    A[4] || (A[4] = d("span", { class: "text-xs" }, "📝", -1)),
                    d("p", D0, O(C.info.memo1), 1)
                  ])) : Z("", !0),
                  (H = C.info) != null && H.memo2 ? (L(), I("div", R0, [
                    A[5] || (A[5] = d("span", { class: "text-xs" }, "📝", -1)),
                    d("p", M0, O(C.info.memo2), 1)
                  ])) : Z("", !0),
                  d("div", B0, [
                    d("time", F0, " 🕒 " + O(k(na)(C.created_at, k(o))), 1),
                    d("div", U0, [
                      d("p", V0, O(s("order.totalAmount")), 1),
                      d("p", H0, [
                        A[6] || (A[6] = d("span", { class: "text-lg" }, "$", -1)),
                        et(O(C.subtotal), 1)
                      ])
                    ])
                  ])
                ])
              ], 8, k0);
            }), 128)),
            k(r).length === 0 ? (L(), I("div", j0, [
              A[7] || (A[7] = d("div", { class: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center text-3xl mb-4" }, " 📋 ", -1)),
              d("p", q0, O(s("order.emptyPrefix")) + " " + O(s(($ = w.find((C) => C.key === f.value)) == null ? void 0 : $.label)) + " " + O(s("order.emptySuffix")), 1)
            ])) : Z("", !0)
          ])),
          k(r).length > 0 ? (L(), I("div", W0, [
            d("span", z0, " PAGE " + O(k(l)) + " / " + O(Math.ceil(k(c) / k(h)) || 1), 1),
            d("div", Y0, [
              d("button", {
                onClick: A[0] || (A[0] = (C) => l.value--),
                disabled: k(l) === 1 || k(a),
                class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
              }, " ← " + O(s("common.prev")), 9, G0),
              d("button", {
                onClick: A[1] || (A[1] = (C) => l.value++),
                disabled: k(l) * k(h) >= k(c) || k(a),
                class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
              }, O(s("common.next")) + " → ", 9, K0)
            ])
          ])) : Z("", !0)
        ]),
        A[8] || (A[8] = d("footer", { class: "w-full pb-[env(safe-area-inset-bottom,2rem)] bg-transparent pointer-events-none" }, null, -1))
      ]);
    };
  }
});
function X0(e) {
  const t = G(/* @__PURE__ */ new Set()), n = G(!1), s = G(null);
  return {
    selectedItemIds: t,
    loading: n,
    error: s,
    toggleSelection: (a) => {
      t.value.has(a) ? t.value.delete(a) : t.value.add(a);
    },
    submitCategorization: async (a) => {
      if (t.value.size === 0) {
        s.value = "Please select at least one item";
        return;
      }
      n.value = !0, s.value = null;
      try {
        const i = {
          itemIds: Array.from(t.value)
          // This becomes ["uuid1", "uuid2"]
        };
        Ne.log("submitCategorization", i);
        const l = await e.updateCategoryItems(a, i);
        return t.value.clear(), l;
      } catch (i) {
        throw s.value = i.message || "儲存失敗", i;
      } finally {
        n.value = !1;
      }
    }
  };
}
const J0 = { class: "menu-lib-container" }, Z0 = { class: "lib-header" }, Q0 = { class: "lib-title" }, ey = { class: "lib-subtitle" }, ty = {
  key: 0,
  class: "lib-status-loading"
}, ny = {
  key: 1,
  class: "lib-status-error"
}, sy = { class: "lib-form mb-8" }, oy = { class: "lib-label" }, ry = { class: "lib-label-text" }, ay = { class: "lib-instruction-box" }, iy = {
  value: "",
  disabled: "",
  selected: ""
}, ly = ["value"], cy = { class: "lib-grid" }, uy = ["onClick"], dy = { class: "card-header-row" }, fy = {
  key: 0,
  class: "check-mark"
}, my = { class: "card-title" }, hy = { class: "price-tag" }, py = { class: "card-footer" }, gy = { class: "price-tag" }, by = { class: "id-tag" }, wy = { class: "lib-footer-actions" }, yy = ["disabled"], vy = /* @__PURE__ */ Ee({
  __name: "MenuCategoryPage",
  props: {
    menuItems: {},
    categoryItems: {},
    menuCategoryApi: {}
  },
  emits: ["updated"],
  setup(e, { emit: t }) {
    const { t: n } = St(), s = e, o = t, r = G(""), { selectedItemIds: a, loading: i, error: l, toggleSelection: c, submitCategorization: h } = X0(s.menuCategoryApi), m = me(() => {
      const g = s.categoryItems.find((_) => _.id === r.value);
      return g ? g.category : n("assign.noneSelected");
    }), p = async () => {
      if (r.value)
        try {
          await h(r.value), await _e.fire({
            title: n("assign.successTitle"),
            text: n("assign.successText"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1e3
          }), a.value.clear(), r.value = "", o("updated");
        } catch (g) {
          console.error("Save failed:", g);
        }
    };
    return (g, _) => (L(), I("section", J0, [
      d("header", Z0, [
        d("h1", Q0, O(k(n)("assign.title")), 1),
        d("p", ey, O(k(n)("assign.subtitle")), 1)
      ]),
      k(i) ? (L(), I("div", ty, O(k(n)("common.processing")), 1)) : k(l) ? (L(), I("div", ny, O(k(l)), 1)) : Z("", !0),
      d("div", sy, [
        d("label", oy, [
          d("span", ry, O(k(n)("assign.targetLabel")), 1),
          d("div", ay, O(k(n)("assign.instruction")), 1)
        ]),
        ot(d("select", {
          "onUpdate:modelValue": _[0] || (_[0] = (f) => r.value = f),
          class: "lib-select"
        }, [
          d("option", iy, "-- " + O(k(n)("assign.selectPlaceholder")) + " --", 1),
          (L(!0), I(Fe, null, Je(e.categoryItems, (f) => (L(), I("option", {
            key: f.id,
            value: f.id
          }, O(f.category), 9, ly))), 128))
        ], 512), [
          [uo, r.value]
        ])
      ]),
      d("div", cy, [
        (L(!0), I(Fe, null, Je(e.menuItems, (f) => (L(), I("div", {
          key: f.id,
          onClick: (w) => k(c)(f.id),
          class: Ae(["lib-card selectable-card", [
            k(a).has(f.id) ? "card-selected" : f.id.charCodeAt(0) % 2 === 0 ? "card-even" : "card-odd"
          ]])
        }, [
          d("div", dy, [
            d("div", {
              class: Ae(["custom-checkbox", { "is-checked": k(a).has(f.id) }])
            }, [
              k(a).has(f.id) ? (L(), I("div", fy, "L")) : Z("", !0)
            ], 2),
            d("p", my, O(f.name), 1),
            d("p", hy, O(f.category), 1)
          ]),
          d("div", py, [
            d("p", gy, "$" + O(f.price), 1),
            d("p", by, "ID: " + O(f.id.slice(-5)), 1)
          ])
        ], 10, uy))), 128))
      ]),
      d("div", wy, [
        d("button", {
          onClick: p,
          disabled: k(i) || !r.value || k(a).size === 0,
          class: "lib-btn-primary"
        }, O(k(i) ? k(n)("common.saving") : k(n)("assign.submitBtn", { count: k(a).size, category: m.value })), 9, yy)
      ])
    ]));
  }
}), Mv = /* @__PURE__ */ kn(vy, [["__scopeId", "data-v-937a7aa4"]]);
function _y(e) {
  const t = G([]), n = G(!1), s = G(null);
  return {
    categories: t,
    loading: n,
    error: s,
    loadCategories: async () => {
      n.value = !0, s.value = null;
      try {
        t.value = await e.fetchCategories();
      } catch {
        s.value = "載入分類失敗";
      } finally {
        n.value = !1;
      }
    },
    handleBulkCreate: async (a) => {
      n.value = !0;
      try {
        return Ne.log("handleBulkCreate newCategories", a), await e.createCategories(a);
      } catch (i) {
        throw s.value = "批量新增失敗", i;
      } finally {
        n.value = !1;
      }
    }
  };
}
const xy = { class: "menu-lib-container" }, Ey = { class: "lib-header" }, ky = { class: "lib-title" }, Cy = {
  key: 0,
  class: "lib-status-loading"
}, Ty = {
  key: 1,
  class: "lib-status-error"
}, Oy = { class: "lib-label" }, Ay = { class: "lib-label-text" }, Sy = { class: "lib-instruction-box" }, Ny = { class: "whitespace-pre-line" }, Ly = { class: "text-accent" }, $y = ["placeholder"], Iy = ["disabled"], Py = { class: "lib-grid" }, Dy = { class: "card-body" }, Ry = { class: "card-title" }, My = { class: "card-footer" }, By = { class: "order-tag" }, Fy = { class: "id-tag" }, Uy = { class: "lib-footer-actions" }, Vy = /* @__PURE__ */ Ee({
  __name: "CategoryManagerPage",
  props: {
    categoryApi: {},
    merchantId: {}
  },
  emits: ["saved"],
  setup(e, { emit: t }) {
    const { t: n } = St(), s = e, o = t, { categories: r, loading: a, error: i, loadCategories: l, handleBulkCreate: c } = _y(s.categoryApi), h = G("");
    vt(r, (p) => {
      h.value || (h.value = [...p].sort((g, _) => g.orderNum - _.orderNum).map((g) => g.category).join(`
`));
    }, { immediate: !0 }), Mt(l);
    const m = async () => {
      const p = [...new Set(
        h.value.split(`
`).map((g) => g.trim()).filter((g) => g !== "")
      )];
      if (p.length !== 0) {
        a.value = !0;
        try {
          const g = p.map((_, f) => ({
            category: _,
            orderNum: f + 1,
            merchantId: s.merchantId
          }));
          await c(g), o("saved"), await _e.fire({
            title: n("category.saveSuccessTitle"),
            text: n("category.saveSuccessText"),
            icon: "success",
            confirmButtonColor: "#2563eb",
            timer: 1500
          }), await l();
        } catch (g) {
          console.error("Failed to save categories:", g);
        } finally {
          a.value = !1;
        }
      }
    };
    return (p, g) => (L(), I("section", xy, [
      d("header", Ey, [
        d("h1", ky, O(k(n)("category.title")), 1)
      ]),
      k(a) ? (L(), I("div", Cy, O(k(n)("common.loading")), 1)) : k(i) ? (L(), I("div", Ty, O(k(i)), 1)) : Z("", !0),
      d("form", {
        onSubmit: ea(m, ["prevent"]),
        class: "lib-form"
      }, [
        d("label", Oy, [
          d("span", Ay, O(k(n)("category.inputLabel")), 1),
          d("div", Sy, [
            et(O(k(n)("category.formatInstruction")), 1),
            g[2] || (g[2] = d("br", null, null, -1)),
            et(" " + O(k(n)("category.exampleTitle")), 1),
            g[3] || (g[3] = d("br", null, null, -1)),
            d("div", Ny, O(k(n)("category.exampleList")), 1),
            d("span", Ly, O(k(n)("category.autoSyncNote")), 1)
          ])
        ]),
        ot(d("textarea", {
          "onUpdate:modelValue": g[0] || (g[0] = (_) => h.value = _),
          class: "lib-textarea",
          placeholder: k(n)("category.placeholder")
        }, null, 8, $y), [
          [wt, h.value]
        ]),
        d("button", {
          type: "submit",
          disabled: k(a),
          class: "lib-btn-primary"
        }, O(k(a) ? k(n)("common.saving") : k(n)("category.submitBtn")), 9, Iy)
      ], 32),
      d("div", Py, [
        (L(!0), I(Fe, null, Je(k(r), (_) => (L(), I("div", {
          key: _.id,
          class: Ae(["lib-card", _.orderNum % 2 === 0 ? "card-even" : "card-odd"])
        }, [
          d("div", Dy, [
            d("h2", Ry, O(_.category), 1)
          ]),
          d("div", My, [
            d("p", By, O(k(n)("category.orderPrefix")) + ": #" + O(_.orderNum), 1),
            d("p", Fy, "ID: " + O(_.id.slice(-5)), 1)
          ])
        ], 2))), 128))
      ]),
      d("div", Uy, [
        d("button", {
          onClick: g[1] || (g[1] = //@ts-ignore
          (..._) => k(l) && k(l)(..._)),
          class: "lib-btn-secondary"
        }, O(k(n)("category.reloadBtn")), 1)
      ])
    ]));
  }
}), Bv = /* @__PURE__ */ kn(Vy, [["__scopeId", "data-v-9a9df28b"]]);
var jo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nl = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(jo, function() {
    var n = 1e3, s = 6e4, o = 36e5, r = "millisecond", a = "second", i = "minute", l = "hour", c = "day", h = "week", m = "month", p = "quarter", g = "year", _ = "date", f = "Invalid Date", w = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, u = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(j) {
      var U = ["th", "st", "nd", "rd"], M = j % 100;
      return "[" + j + (U[(M - 20) % 10] || U[M] || U[0]) + "]";
    } }, x = function(j, U, M) {
      var K = String(j);
      return !K || K.length >= U ? j : "" + Array(U + 1 - K.length).join(M) + j;
    }, v = { s: x, z: function(j) {
      var U = -j.utcOffset(), M = Math.abs(U), K = Math.floor(M / 60), V = M % 60;
      return (U <= 0 ? "+" : "-") + x(K, 2, "0") + ":" + x(V, 2, "0");
    }, m: function j(U, M) {
      if (U.date() < M.date()) return -j(M, U);
      var K = 12 * (M.year() - U.year()) + (M.month() - U.month()), V = U.clone().add(K, m), J = M - V < 0, q = U.clone().add(K + (J ? -1 : 1), m);
      return +(-(K + (M - V) / (J ? V - q : q - V)) || 0);
    }, a: function(j) {
      return j < 0 ? Math.ceil(j) || 0 : Math.floor(j);
    }, p: function(j) {
      return { M: m, y: g, w: h, d: c, D: _, h: l, m: i, s: a, ms: r, Q: p }[j] || String(j || "").toLowerCase().replace(/s$/, "");
    }, u: function(j) {
      return j === void 0;
    } }, A = "en", $ = {};
    $[A] = b;
    var C = "$isDayjsObject", B = function(j) {
      return j instanceof te || !(!j || !j[C]);
    }, D = function j(U, M, K) {
      var V;
      if (!U) return A;
      if (typeof U == "string") {
        var J = U.toLowerCase();
        $[J] && (V = J), M && ($[J] = M, V = J);
        var q = U.split("-");
        if (!V && q.length > 1) return j(q[0]);
      } else {
        var oe = U.name;
        $[oe] = U, V = oe;
      }
      return !K && V && (A = V), V || !K && A;
    }, F = function(j, U) {
      if (B(j)) return j.clone();
      var M = typeof U == "object" ? U : {};
      return M.date = j, M.args = arguments, new te(M);
    }, H = v;
    H.l = D, H.i = B, H.w = function(j, U) {
      return F(j, { locale: U.$L, utc: U.$u, x: U.$x, $offset: U.$offset });
    };
    var te = function() {
      function j(M) {
        this.$L = D(M.locale, null, !0), this.parse(M), this.$x = this.$x || M.x || {}, this[C] = !0;
      }
      var U = j.prototype;
      return U.parse = function(M) {
        this.$d = function(K) {
          var V = K.date, J = K.utc;
          if (V === null) return /* @__PURE__ */ new Date(NaN);
          if (H.u(V)) return /* @__PURE__ */ new Date();
          if (V instanceof Date) return new Date(V);
          if (typeof V == "string" && !/Z$/i.test(V)) {
            var q = V.match(w);
            if (q) {
              var oe = q[2] - 1 || 0, le = (q[7] || "0").substring(0, 3);
              return J ? new Date(Date.UTC(q[1], oe, q[3] || 1, q[4] || 0, q[5] || 0, q[6] || 0, le)) : new Date(q[1], oe, q[3] || 1, q[4] || 0, q[5] || 0, q[6] || 0, le);
            }
          }
          return new Date(V);
        }(M), this.init();
      }, U.init = function() {
        var M = this.$d;
        this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
      }, U.$utils = function() {
        return H;
      }, U.isValid = function() {
        return this.$d.toString() !== f;
      }, U.isSame = function(M, K) {
        var V = F(M);
        return this.startOf(K) <= V && V <= this.endOf(K);
      }, U.isAfter = function(M, K) {
        return F(M) < this.startOf(K);
      }, U.isBefore = function(M, K) {
        return this.endOf(K) < F(M);
      }, U.$g = function(M, K, V) {
        return H.u(M) ? this[K] : this.set(V, M);
      }, U.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, U.valueOf = function() {
        return this.$d.getTime();
      }, U.startOf = function(M, K) {
        var V = this, J = !!H.u(K) || K, q = H.p(M), oe = function(Be, ke) {
          var re = H.w(V.$u ? Date.UTC(V.$y, ke, Be) : new Date(V.$y, ke, Be), V);
          return J ? re : re.endOf(c);
        }, le = function(Be, ke) {
          return H.w(V.toDate()[Be].apply(V.toDate("s"), (J ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ke)), V);
        }, ne = this.$W, fe = this.$M, be = this.$D, Ye = "set" + (this.$u ? "UTC" : "");
        switch (q) {
          case g:
            return J ? oe(1, 0) : oe(31, 11);
          case m:
            return J ? oe(1, fe) : oe(0, fe + 1);
          case h:
            var Te = this.$locale().weekStart || 0, ae = (ne < Te ? ne + 7 : ne) - Te;
            return oe(J ? be - ae : be + (6 - ae), fe);
          case c:
          case _:
            return le(Ye + "Hours", 0);
          case l:
            return le(Ye + "Minutes", 1);
          case i:
            return le(Ye + "Seconds", 2);
          case a:
            return le(Ye + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, U.endOf = function(M) {
        return this.startOf(M, !1);
      }, U.$set = function(M, K) {
        var V, J = H.p(M), q = "set" + (this.$u ? "UTC" : ""), oe = (V = {}, V[c] = q + "Date", V[_] = q + "Date", V[m] = q + "Month", V[g] = q + "FullYear", V[l] = q + "Hours", V[i] = q + "Minutes", V[a] = q + "Seconds", V[r] = q + "Milliseconds", V)[J], le = J === c ? this.$D + (K - this.$W) : K;
        if (J === m || J === g) {
          var ne = this.clone().set(_, 1);
          ne.$d[oe](le), ne.init(), this.$d = ne.set(_, Math.min(this.$D, ne.daysInMonth())).$d;
        } else oe && this.$d[oe](le);
        return this.init(), this;
      }, U.set = function(M, K) {
        return this.clone().$set(M, K);
      }, U.get = function(M) {
        return this[H.p(M)]();
      }, U.add = function(M, K) {
        var V, J = this;
        M = Number(M);
        var q = H.p(K), oe = function(fe) {
          var be = F(J);
          return H.w(be.date(be.date() + Math.round(fe * M)), J);
        };
        if (q === m) return this.set(m, this.$M + M);
        if (q === g) return this.set(g, this.$y + M);
        if (q === c) return oe(1);
        if (q === h) return oe(7);
        var le = (V = {}, V[i] = s, V[l] = o, V[a] = n, V)[q] || 1, ne = this.$d.getTime() + M * le;
        return H.w(ne, this);
      }, U.subtract = function(M, K) {
        return this.add(-1 * M, K);
      }, U.format = function(M) {
        var K = this, V = this.$locale();
        if (!this.isValid()) return V.invalidDate || f;
        var J = M || "YYYY-MM-DDTHH:mm:ssZ", q = H.z(this), oe = this.$H, le = this.$m, ne = this.$M, fe = V.weekdays, be = V.months, Ye = V.meridiem, Te = function(ke, re, se, ie) {
          return ke && (ke[re] || ke(K, J)) || se[re].slice(0, ie);
        }, ae = function(ke) {
          return H.s(oe % 12 || 12, ke, "0");
        }, Be = Ye || function(ke, re, se) {
          var ie = ke < 12 ? "AM" : "PM";
          return se ? ie.toLowerCase() : ie;
        };
        return J.replace(u, function(ke, re) {
          return re || function(se) {
            switch (se) {
              case "YY":
                return String(K.$y).slice(-2);
              case "YYYY":
                return H.s(K.$y, 4, "0");
              case "M":
                return ne + 1;
              case "MM":
                return H.s(ne + 1, 2, "0");
              case "MMM":
                return Te(V.monthsShort, ne, be, 3);
              case "MMMM":
                return Te(be, ne);
              case "D":
                return K.$D;
              case "DD":
                return H.s(K.$D, 2, "0");
              case "d":
                return String(K.$W);
              case "dd":
                return Te(V.weekdaysMin, K.$W, fe, 2);
              case "ddd":
                return Te(V.weekdaysShort, K.$W, fe, 3);
              case "dddd":
                return fe[K.$W];
              case "H":
                return String(oe);
              case "HH":
                return H.s(oe, 2, "0");
              case "h":
                return ae(1);
              case "hh":
                return ae(2);
              case "a":
                return Be(oe, le, !0);
              case "A":
                return Be(oe, le, !1);
              case "m":
                return String(le);
              case "mm":
                return H.s(le, 2, "0");
              case "s":
                return String(K.$s);
              case "ss":
                return H.s(K.$s, 2, "0");
              case "SSS":
                return H.s(K.$ms, 3, "0");
              case "Z":
                return q;
            }
            return null;
          }(ke) || q.replace(":", "");
        });
      }, U.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, U.diff = function(M, K, V) {
        var J, q = this, oe = H.p(K), le = F(M), ne = (le.utcOffset() - this.utcOffset()) * s, fe = this - le, be = function() {
          return H.m(q, le);
        };
        switch (oe) {
          case g:
            J = be() / 12;
            break;
          case m:
            J = be();
            break;
          case p:
            J = be() / 3;
            break;
          case h:
            J = (fe - ne) / 6048e5;
            break;
          case c:
            J = (fe - ne) / 864e5;
            break;
          case l:
            J = fe / o;
            break;
          case i:
            J = fe / s;
            break;
          case a:
            J = fe / n;
            break;
          default:
            J = fe;
        }
        return V ? J : H.a(J);
      }, U.daysInMonth = function() {
        return this.endOf(m).$D;
      }, U.$locale = function() {
        return $[this.$L];
      }, U.locale = function(M, K) {
        if (!M) return this.$L;
        var V = this.clone(), J = D(M, K, !0);
        return J && (V.$L = J), V;
      }, U.clone = function() {
        return H.w(this.$d, this);
      }, U.toDate = function() {
        return new Date(this.valueOf());
      }, U.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, U.toISOString = function() {
        return this.$d.toISOString();
      }, U.toString = function() {
        return this.$d.toUTCString();
      }, j;
    }(), Me = te.prototype;
    return F.prototype = Me, [["$ms", r], ["$s", a], ["$m", i], ["$H", l], ["$W", c], ["$M", m], ["$y", g], ["$D", _]].forEach(function(j) {
      Me[j[1]] = function(U) {
        return this.$g(U, j[0], j[1]);
      };
    }), F.extend = function(j, U) {
      return j.$i || (j(U, te, F), j.$i = !0), F;
    }, F.locale = D, F.isDayjs = B, F.unix = function(j) {
      return F(1e3 * j);
    }, F.en = $[A], F.Ls = $, F.p = {}, F;
  });
})(nl);
var Hy = nl.exports;
const Wo = /* @__PURE__ */ qo(Hy);
var sl = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(jo, function() {
    var n = "minute", s = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(r, a, i) {
      var l = a.prototype;
      i.utc = function(f) {
        var w = { date: f, utc: !0, args: arguments };
        return new a(w);
      }, l.utc = function(f) {
        var w = i(this.toDate(), { locale: this.$L, utc: !0 });
        return f ? w.add(this.utcOffset(), n) : w;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = l.parse;
      l.parse = function(f) {
        f.utc && (this.$u = !0), this.$utils().u(f.$offset) || (this.$offset = f.$offset), c.call(this, f);
      };
      var h = l.init;
      l.init = function() {
        if (this.$u) {
          var f = this.$d;
          this.$y = f.getUTCFullYear(), this.$M = f.getUTCMonth(), this.$D = f.getUTCDate(), this.$W = f.getUTCDay(), this.$H = f.getUTCHours(), this.$m = f.getUTCMinutes(), this.$s = f.getUTCSeconds(), this.$ms = f.getUTCMilliseconds();
        } else h.call(this);
      };
      var m = l.utcOffset;
      l.utcOffset = function(f, w) {
        var u = this.$utils().u;
        if (u(f)) return this.$u ? 0 : u(this.$offset) ? m.call(this) : this.$offset;
        if (typeof f == "string" && (f = function(A) {
          A === void 0 && (A = "");
          var $ = A.match(s);
          if (!$) return null;
          var C = ("" + $[0]).match(o) || ["-", 0, 0], B = C[0], D = 60 * +C[1] + +C[2];
          return D === 0 ? 0 : B === "+" ? D : -D;
        }(f), f === null)) return this;
        var b = Math.abs(f) <= 16 ? 60 * f : f;
        if (b === 0) return this.utc(w);
        var x = this.clone();
        if (w) return x.$offset = b, x.$u = !1, x;
        var v = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (x = this.local().add(b + v, n)).$offset = b, x.$x.$localOffset = v, x;
      };
      var p = l.format;
      l.format = function(f) {
        var w = f || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return p.call(this, w);
      }, l.valueOf = function() {
        var f = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * f;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var g = l.toDate;
      l.toDate = function(f) {
        return f === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
      };
      var _ = l.diff;
      l.diff = function(f, w, u) {
        if (f && this.$u === f.$u) return _.call(this, f, w, u);
        var b = this.local(), x = i(f).local();
        return _.call(b, x, w, u);
      };
    };
  });
})(sl);
var jy = sl.exports;
const qy = /* @__PURE__ */ qo(jy);
var ol = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(jo, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, s = {};
    return function(o, r, a) {
      var i, l = function(p, g, _) {
        _ === void 0 && (_ = {});
        var f = new Date(p), w = function(u, b) {
          b === void 0 && (b = {});
          var x = b.timeZoneName || "short", v = u + "|" + x, A = s[v];
          return A || (A = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: u, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: x }), s[v] = A), A;
        }(g, _);
        return w.formatToParts(f);
      }, c = function(p, g) {
        for (var _ = l(p, g), f = [], w = 0; w < _.length; w += 1) {
          var u = _[w], b = u.type, x = u.value, v = n[b];
          v >= 0 && (f[v] = parseInt(x, 10));
        }
        var A = f[3], $ = A === 24 ? 0 : A, C = f[0] + "-" + f[1] + "-" + f[2] + " " + $ + ":" + f[4] + ":" + f[5] + ":000", B = +p;
        return (a.utc(C).valueOf() - (B -= B % 1e3)) / 6e4;
      }, h = r.prototype;
      h.tz = function(p, g) {
        p === void 0 && (p = i);
        var _, f = this.utcOffset(), w = this.toDate(), u = w.toLocaleString("en-US", { timeZone: p }), b = Math.round((w - new Date(u)) / 1e3 / 60), x = 15 * -Math.round(w.getTimezoneOffset() / 15) - b;
        if (!Number(x)) _ = this.utcOffset(0, g);
        else if (_ = a(u, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(x, !0), g) {
          var v = _.utcOffset();
          _ = _.add(f - v, "minute");
        }
        return _.$x.$timezone = p, _;
      }, h.offsetName = function(p) {
        var g = this.$x.$timezone || a.tz.guess(), _ = l(this.valueOf(), g, { timeZoneName: p }).find(function(f) {
          return f.type.toLowerCase() === "timezonename";
        });
        return _ && _.value;
      };
      var m = h.startOf;
      h.startOf = function(p, g) {
        if (!this.$x || !this.$x.$timezone) return m.call(this, p, g);
        var _ = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return m.call(_, p, g).tz(this.$x.$timezone, !0);
      }, a.tz = function(p, g, _) {
        var f = _ && g, w = _ || g || i, u = c(+a(), w);
        if (typeof p != "string") return a(p).tz(w);
        var b = function($, C, B) {
          var D = $ - 60 * C * 1e3, F = c(D, B);
          if (C === F) return [D, C];
          var H = c(D -= 60 * (F - C) * 1e3, B);
          return F === H ? [D, F] : [$ - 60 * Math.min(F, H) * 1e3, Math.max(F, H)];
        }(a.utc(p, f).valueOf(), u, w), x = b[0], v = b[1], A = a(x).utcOffset(v);
        return A.$x.$timezone = w, A;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(p) {
        i = p;
      };
    };
  });
})(ol);
var Wy = ol.exports;
const zy = /* @__PURE__ */ qo(Wy);
Wo.extend(qy);
Wo.extend(zy);
function Yy(e) {
  const t = G("UTC"), n = G(!1), s = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    currentTz: t,
    loading: n,
    detectBrowserTz: s,
    loadStoredTz: async () => {
      Ne.log("載入商家時區中..."), n.value = !0;
      try {
        const i = await e.getMerchantTz();
        Ne.log("取得商家時區:", i.tz), t.value = i.tz || "UTC";
      } catch (i) {
        Ne.error("無法載入時區", i);
      } finally {
        n.value = !1;
      }
    },
    formatTimeByZone: (i, l) => {
      if (!i) return "--";
      const c = l || t.value;
      return Wo(i).tz(c).format("YYYY-MM-DD HH:mm:ss");
    },
    syncTzToBackend: async () => {
      const i = s();
      n.value = !0;
      try {
        await e.updateMerchantTz(i), t.value = i;
      } catch (l) {
        throw l;
      } finally {
        n.value = !1;
      }
    }
  };
}
const Gy = [
  // West Coast / Pacific (Negative Offsets)
  { label: "UTC -10 (Hawaii Standard Time)", value: "Pacific/Honolulu", offset: -10 },
  { label: "UTC -9 (Alaska Standard Time)", value: "America/Anchorage", offset: -9 },
  { label: "UTC -8 (Pacific Time - Los Angeles / Vancouver)", value: "America/Los_Angeles", offset: -8 },
  { label: "UTC -7 (Mountain Time - Denver / Phoenix)", value: "America/Denver", offset: -7 },
  { label: "UTC -6 (Central Time - Chicago / Mexico City)", value: "America/Chicago", offset: -6 },
  { label: "UTC -5 (Eastern Time - New York / Toronto)", value: "America/New_York", offset: -5 },
  { label: "UTC -4 (Atlantic Time - Halifax)", value: "America/Halifax", offset: -4 },
  { label: "UTC -3 (Brasilia / Buenos Aires)", value: "America/Sao_Paulo", offset: -3 },
  { label: "UTC -1 (Azores)", value: "Atlantic/Azores", offset: -1 },
  // Base Timezone
  { label: "UTC +0 (London / Lisbon / Casablanca)", value: "Europe/London", offset: 0 },
  // East Coast / Asia / Oceania (Positive Offsets)
  { label: "UTC +1 (Paris / Berlin / Rome / Madrid)", value: "Europe/Paris", offset: 1 },
  { label: "UTC +2 (Athens / Istanbul / Cairo / Jerusalem)", value: "Europe/Athens", offset: 2 },
  { label: "UTC +3 (Moscow / Riyadh / Nairobi)", value: "Europe/Moscow", offset: 3 },
  { label: "UTC +4 (Dubai / Baku)", value: "Asia/Dubai", offset: 4 },
  { label: "UTC +5 (Karachi / Tashkent)", value: "Asia/Karachi", offset: 5 },
  { label: "UTC +5.5 (India - Delhi / Mumbai)", value: "Asia/Kolkata", offset: 5.5 },
  { label: "UTC +6 (Dhaka / Almaty)", value: "Asia/Dhaka", offset: 6 },
  { label: "UTC +7 (Bangkok / Ho Chi Minh / Jakarta)", value: "Asia/Ho_Chi_Minh", offset: 7 },
  { label: "UTC +8 (Taipei / Beijing / Hong Kong / Singapore)", value: "Asia/Taipei", offset: 8 },
  { label: "UTC +9 (Tokyo / Seoul)", value: "Asia/Tokyo", offset: 9 },
  { label: "UTC +9.5 (Adelaide)", value: "Australia/Adelaide", offset: 9.5 },
  { label: "UTC +10 (Sydney / Melbourne / Guam)", value: "Australia/Sydney", offset: 10 },
  { label: "UTC +11 (Solomon Islands / Guadalcanal)", value: "Pacific/Guadalcanal", offset: 11 },
  { label: "UTC +12 (Auckland / Fiji)", value: "Pacific/Auckland", offset: 12 }
], Ky = { class: "p-6 bg-white rounded-xl shadow-md border border-gray-100 max-w-lg" }, Xy = { class: "space-y-4" }, Jy = ["value"], Zy = { class: "flex items-center gap-2 p-3 bg-blue-50 rounded-lg" }, Qy = { class: "flex-1" }, ev = { class: "text-sm font-mono text-blue-700" }, tv = {
  key: 0,
  class: "text-xs bg-orange-400 text-white px-2 py-1 rounded-full animate-pulse"
}, nv = ["disabled"], sv = { class: "mt-6 pt-4 border-t border-dashed" }, ov = { class: "text-xs text-gray-400 font-bold mb-1" }, rv = { class: "text-lg font-mono text-gray-600" }, Fv = /* @__PURE__ */ Ee({
  __name: "TzSettingCard",
  props: {
    merchantTzApi: {}
  },
  setup(e) {
    const t = e, { currentTz: n, loading: s, loadStoredTz: o, formatTimeByZone: r } = Yy(t.merchantTzApi), a = G(""), i = me(() => a.value !== n.value), l = me(() => r((/* @__PURE__ */ new Date()).toISOString(), a.value));
    Mt(async () => {
      await o(), a.value = n.value;
    });
    const c = async () => {
      var h, m;
      try {
        s.value = !0, await t.merchantTzApi.updateMerchantTz(a.value), n.value = a.value;
      } catch (p) {
        (m = (h = p.response) == null ? void 0 : h.data) != null && m.message;
      } finally {
        s.value = !1;
      }
    };
    return (h, m) => (L(), I("div", Ky, [
      m[3] || (m[3] = d("h3", { class: "text-lg font-bold text-gray-800 mb-2" }, "時區偏好設定", -1)),
      m[4] || (m[4] = d("p", { class: "text-sm text-gray-500 mb-6" }, "設定後，訂單與報表時間將依照此時區顯示。", -1)),
      d("div", Xy, [
        d("div", null, [
          m[1] || (m[1] = d("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "選擇時區 (GMT 偏移)", -1)),
          ot(d("select", {
            "onUpdate:modelValue": m[0] || (m[0] = (p) => a.value = p),
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none appearance-none bg-white"
          }, [
            (L(!0), I(Fe, null, Je(k(Gy), (p) => (L(), I("option", {
              key: p.value,
              value: p.value
            }, O(p.label) + " (" + O(p.offset > 0 ? "+" + p.offset : p.offset) + ") ", 9, Jy))), 128))
          ], 512), [
            [uo, a.value]
          ])
        ]),
        d("div", Zy, [
          d("div", Qy, [
            m[2] || (m[2] = d("p", { class: "text-xs text-blue-500 font-bold uppercase" }, "目前資料庫設定", -1)),
            d("p", ev, O(k(n)), 1)
          ]),
          i.value ? (L(), I("div", tv, " 尚未儲存 ")) : Z("", !0)
        ]),
        d("button", {
          onClick: c,
          disabled: k(s) || !i.value,
          class: "w-full py-3 bg-blue-600 text-white rounded-xl font-bold shadow-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:shadow-none"
        }, O(k(s) ? "儲存中..." : "儲存時區設定"), 9, nv)
      ]),
      d("div", sv, [
        d("p", ov, "預覽時間 (" + O(a.value) + ")", 1),
        d("p", rv, O(l.value), 1)
      ])
    ]));
  }
}), av = { class: "p-6 bg-white rounded-xl shadow-md border border-gray-100 max-w-lg" }, iv = { class: "space-y-4" }, lv = {
  key: 0,
  class: "flex items-center gap-2 p-3 bg-orange-50 rounded-lg"
}, cv = ["disabled"], Uv = /* @__PURE__ */ Ee({
  __name: "MerchantInfoEditCard",
  props: {
    merchantTzApi: {}
  },
  setup(e) {
    const t = e, n = G(!1), s = G({
      tz: "",
      memo1: "",
      memo2: "",
      merchant_name: ""
    }), o = G({
      merchantName: "",
      memo1: "",
      memo2: ""
    }), r = me(() => o.value.merchantName !== s.value.merchant_name || o.value.memo1 !== s.value.memo1 || o.value.memo2 !== s.value.memo2);
    Mt(async () => {
      await a();
    });
    const a = async () => {
      try {
        n.value = !0;
        const l = localStorage.getItem("merchantId");
        if (!l)
          throw new Error("Merchant ID not found in storage");
        const c = await t.merchantTzApi.getMerchantInfo(l);
        s.value = c, o.value.merchantName = c.merchant_name, o.value.memo1 = c.memo1, o.value.memo2 = c.memo2;
      } catch (l) {
        console.error("Failed to load merchant info:", l);
      } finally {
        n.value = !1;
      }
    }, i = async () => {
      var l, c;
      try {
        if (n.value = !0, !localStorage.getItem("merchantId"))
          throw new Error("Merchant ID not found in storage");
        const m = await t.merchantTzApi.updateMerchantInfo(
          o.value.merchantName,
          o.value.memo1,
          o.value.memo2
        );
        Ne.log("Merchant info updated:", m), s.value.merchant_name = o.value.merchantName, s.value.memo1 = o.value.memo1, s.value.memo2 = o.value.memo2;
      } catch (h) {
        const m = ((c = (l = h.response) == null ? void 0 : l.data) == null ? void 0 : c.error) || "儲存失敗";
        console.error(m);
      } finally {
        n.value = !1;
      }
    };
    return (l, c) => (L(), I("div", av, [
      c[7] || (c[7] = d("h3", { class: "text-lg font-bold text-gray-800 mb-2" }, "商家資訊設定", -1)),
      c[8] || (c[8] = d("p", { class: "text-sm text-gray-500 mb-6" }, "更新商家名稱與備註資訊。", -1)),
      d("div", iv, [
        d("div", null, [
          c[3] || (c[3] = d("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "商家名稱", -1)),
          ot(d("input", {
            "onUpdate:modelValue": c[0] || (c[0] = (h) => o.value.merchantName = h),
            type: "text",
            placeholder: "請輸入商家名稱",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none",
            maxlength: "100"
          }, null, 512), [
            [wt, o.value.merchantName]
          ])
        ]),
        d("div", null, [
          c[4] || (c[4] = d("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "備註 1 (客人點餐畫面說明)", -1)),
          ot(d("textarea", {
            "onUpdate:modelValue": c[1] || (c[1] = (h) => o.value.memo1 = h),
            placeholder: "請輸入備註 1",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none resize-none",
            rows: "3",
            maxlength: "255"
          }, null, 512), [
            [wt, o.value.memo1]
          ])
        ]),
        d("div", null, [
          c[5] || (c[5] = d("label", { class: "block text-sm font-bold text-gray-700 mb-1" }, "備註 2 (客人訂位畫面說明)", -1)),
          ot(d("textarea", {
            "onUpdate:modelValue": c[2] || (c[2] = (h) => o.value.memo2 = h),
            placeholder: "請輸入備註 2",
            class: "w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none resize-none",
            rows: "3",
            maxlength: "255"
          }, null, 512), [
            [wt, o.value.memo2]
          ])
        ]),
        r.value ? (L(), I("div", lv, [...c[6] || (c[6] = [
          d("div", { class: "text-xs bg-orange-400 text-white px-2 py-1 rounded-full animate-pulse" }, " 尚未儲存 ", -1)
        ])])) : Z("", !0),
        d("button", {
          onClick: i,
          disabled: n.value || !r.value,
          class: "w-full py-3 bg-blue-600 text-white rounded-xl font-bold shadow-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:shadow-none"
        }, O(n.value ? "儲存中..." : "儲存商家資訊"), 9, cv)
      ])
    ]));
  }
});
let lo;
const Vv = (e) => lo ? lo(e) : (console.warn(`Translation called for "${e}" before i18n was initialized.`), e), Hv = (e) => {
  lo = e;
};
export {
  Bv as CategoryManagerPage,
  Mv as MenuCategoryPage,
  fv as MenuEditorPage,
  Iv as MenuOrderPage,
  Uv as MerchantInfoEditCard,
  Rv as MerchantOrderListPage,
  Dv as OrderManagementPage,
  Pv as TablePostPage,
  Fv as TzSettingCard,
  Hv as setI18nMenu,
  Vv as t
};
